webpackJsonp([2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = errorMessage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(94);


function errorMessage(err, defaultMessage) {
  return err.data ? __WEBPACK_IMPORTED_MODULE_0__main__["App"].$bus.$emit('toastError', 'Error: ' + err.data.message) : __WEBPACK_IMPORTED_MODULE_0__main__["App"].$bus.$emit('toastError', defaultMessage);
}

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return apiCreateProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return apiGetListCustomers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return apiGetProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return apiUpdateProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return apiProjectTaskCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return apiProjectTaskRemove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return apiUpdateUserTaskOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return apiUpdateUserCustomTaskOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return apiGetTasks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return apiGetArchivedTasks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return apiProjectUserInvite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return apiProjectUserRemove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return apiProjectChatInit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return apiProjectUpdateClientCharacterNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return apiProjectNotificationsSeen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return apiStripeConfirmSubscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return apiStripeConfirmPayAsYouGo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return apiGetUserProjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return apiGetProjectDesigners; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return apiPingJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return apiManualSetupPaymentPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiUserRemoveAllInformation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return apiPaymentExecute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return apiUpdateFeedback; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_main_api__ = __webpack_require__(20);




var apiCreateProject = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(userRole, data) {
    var endpoint;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            endpoint = userRole === 'admin' ? 'adminCreate' : 'create';
            return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/' + endpoint, data));

          case 2:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function apiCreateProject(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var apiGetListCustomers = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('get', '/profile/listCustomers'));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function apiGetListCustomers() {
    return _ref2.apply(this, arguments);
  };
}();

var apiGetProject = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(projectID) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('get', '/v3/project/get/' + projectID));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function apiGetProject(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

var apiUpdateProject = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(projectSettings) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/adminUpdate', projectSettings));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function apiUpdateProject(_x4) {
    return _ref4.apply(this, arguments);
  };
}();

// TODO add add, delete project

var apiProjectTaskCreate = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(task) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/task', task));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function apiProjectTaskCreate(_x5) {
    return _ref5.apply(this, arguments);
  };
}();

var apiProjectTaskRemove = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(projectID, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('delete', '/v3/project/' + projectID + '/task/' + id));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function apiProjectTaskRemove(_x6, _x7) {
    return _ref6.apply(this, arguments);
  };
}();

var apiUpdateUserTaskOrder = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(taskSortType) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/updateUserTaskOrder?sortType=' + taskSortType));

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function apiUpdateUserTaskOrder(_x8) {
    return _ref7.apply(this, arguments);
  };
}();

var apiUpdateUserCustomTaskOrder = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(projectID, dragedTaskList) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/' + projectID + '/tasks/reorder', { tasks: dragedTaskList }));

          case 1:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));

  return function apiUpdateUserCustomTaskOrder(_x9, _x10) {
    return _ref8.apply(this, arguments);
  };
}();

var apiGetTasks = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(projectID, sortType, cursor) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('get', '/v3/project/get/' + projectID + '/tasks?sort=' + sortType + '&limit=10&cursor=' + cursor));

          case 1:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, this);
  }));

  return function apiGetTasks(_x11, _x12, _x13) {
    return _ref9.apply(this, arguments);
  };
}();

var apiGetArchivedTasks = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(projectID, cursor) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('get', '/v3/project/get/' + projectID + '/archived-tasks?limit=10&cursor=' + cursor));

          case 1:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, this);
  }));

  return function apiGetArchivedTasks(_x14, _x15) {
    return _ref10.apply(this, arguments);
  };
}();

// TODO task update, get active list pagination

var apiProjectUserInvite = function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(user) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/inviteUserToProject', user));

          case 1:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, this);
  }));

  return function apiProjectUserInvite(_x16) {
    return _ref11.apply(this, arguments);
  };
}();

var apiProjectUserRemove = function () {
  var _ref12 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(projectID, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            return _context12.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('delete', '/v3/project/' + projectID + '/user/' + id));

          case 1:
          case 'end':
            return _context12.stop();
        }
      }
    }, _callee12, this);
  }));

  return function apiProjectUserRemove(_x17, _x18) {
    return _ref12.apply(this, arguments);
  };
}();

var apiProjectChatInit = function () {
  var _ref13 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(projectID) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            return _context13.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('get', '/chat/channel/' + projectID + '/init'));

          case 1:
          case 'end':
            return _context13.stop();
        }
      }
    }, _callee13, this);
  }));

  return function apiProjectChatInit(_x19) {
    return _ref13.apply(this, arguments);
  };
}();

var apiProjectUpdateClientCharacterNotes = function () {
  var _ref14 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(data) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            return _context14.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/updateClientCharacterNotes/', data));

          case 1:
          case 'end':
            return _context14.stop();
        }
      }
    }, _callee14, this);
  }));

  return function apiProjectUpdateClientCharacterNotes(_x20) {
    return _ref14.apply(this, arguments);
  };
}();

var apiProjectNotificationsSeen = function () {
  var _ref15 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(projectID) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            return _context15.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/notificationsSeen?id=' + projectID));

          case 1:
          case 'end':
            return _context15.stop();
        }
      }
    }, _callee15, this);
  }));

  return function apiProjectNotificationsSeen(_x21) {
    return _ref15.apply(this, arguments);
  };
}();

var apiStripeConfirmSubscription = function () {
  var _ref16 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(projectID, sessionId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            return _context16.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/stripe-payment/confirm-subscription?id=' + projectID + '&sessionId=' + sessionId));

          case 1:
          case 'end':
            return _context16.stop();
        }
      }
    }, _callee16, this);
  }));

  return function apiStripeConfirmSubscription(_x22, _x23) {
    return _ref16.apply(this, arguments);
  };
}();

var apiStripeConfirmPayAsYouGo = function () {
  var _ref17 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(projectID, sessionId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            return _context17.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/stripe-payment/confirm-pay-as-you-go-plan?id=' + projectID + '&sessionId=' + sessionId));

          case 1:
          case 'end':
            return _context17.stop();
        }
      }
    }, _callee17, this);
  }));

  return function apiStripeConfirmPayAsYouGo(_x24, _x25) {
    return _ref17.apply(this, arguments);
  };
}();

var apiGetUserProjects = function () {
  var _ref18 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(cursor) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            return _context18.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('get', '/v3/project/list-names?limit=20&cursor=' + cursor));

          case 1:
          case 'end':
            return _context18.stop();
        }
      }
    }, _callee18, this);
  }));

  return function apiGetUserProjects(_x26) {
    return _ref18.apply(this, arguments);
  };
}();

var apiGetProjectDesigners = function () {
  var _ref19 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19(projectId, taskId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            return _context19.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('get', '/v3/project/list-available-designer?projectId=' + projectId + '&taskId=' + taskId));

          case 1:
          case 'end':
            return _context19.stop();
        }
      }
    }, _callee19, this);
  }));

  return function apiGetProjectDesigners(_x27, _x28) {
    return _ref19.apply(this, arguments);
  };
}();

var apiPingJob = function () {
  var _ref20 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee20(projectId, taskId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            return _context20.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('get', '/v3/project/' + projectId + '/task/' + taskId + '/getZipLink'));

          case 1:
          case 'end':
            return _context20.stop();
        }
      }
    }, _callee20, this);
  }));

  return function apiPingJob(_x29, _x30) {
    return _ref20.apply(this, arguments);
  };
}();

var apiManualSetupPaymentPlan = function () {
  var _ref21 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee21(projectId, paymentPlan, paymentPlanCurrentPeriodEnd) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            return _context21.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/' + projectId + '/manual-setup-payment-plan', { paymentPlan: paymentPlan, paymentPlanCurrentPeriodEnd: paymentPlanCurrentPeriodEnd }));

          case 1:
          case 'end':
            return _context21.stop();
        }
      }
    }, _callee21, this);
  }));

  return function apiManualSetupPaymentPlan(_x31, _x32, _x33) {
    return _ref21.apply(this, arguments);
  };
}();

var apiUserRemoveAllInformation = function () {
  var _ref22 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee22() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            return _context22.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/gdprRequest'));

          case 1:
          case 'end':
            return _context22.stop();
        }
      }
    }, _callee22, this);
  }));

  return function apiUserRemoveAllInformation() {
    return _ref22.apply(this, arguments);
  };
}();

var apiPaymentExecute = function () {
  var _ref23 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee23(id, paymentPlan) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            return _context23.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/stripe-payment/create-subscription?id=' + id + '&paymentPlan=' + paymentPlan));

          case 1:
          case 'end':
            return _context23.stop();
        }
      }
    }, _callee23, this);
  }));

  return function apiPaymentExecute(_x34, _x35) {
    return _ref23.apply(this, arguments);
  };
}();

var apiUpdateFeedback = function () {
  var _ref24 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee24(projectId, taskId, designerFileUuid, feedback) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            return _context24.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/design-feedback/' + projectId + '/' + taskId + '/' + designerFileUuid, feedback));

          case 1:
          case 'end':
            return _context24.stop();
        }
      }
    }, _callee24, this);
  }));

  return function apiUpdateFeedback(_x36, _x37, _x38, _x39) {
    return _ref24.apply(this, arguments);
  };
}();

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(37);




__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);

var api = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(method, url, param) {
    var _ref2, data;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http[method](url, param);

          case 3:
            _ref2 = _context.sent;
            data = _ref2.data;
            return _context.abrupt('return', [null, data]);

          case 8:
            _context.prev = 8;
            _context.t0 = _context['catch'](0);
            return _context.abrupt('return', [_context.t0]);

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 8]]);
  }));

  return function api(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    checkUserRole: function checkUserRole(userRole, checkRoles) {
      return _.includes(checkRoles, userRole);
    }
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return apiArchiveTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return apiUnArchiveTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return apiAssigneeDesigner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiAddDesignsFileKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return apiAddChatFileKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return apiRemoveDesignFileKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return apiUpdateStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return apiUpdateTaskDeadline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return apiUpdatePriority; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return apiDesignerStartWorking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return apiUpdateEta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return apiDownloadAllDesigns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return apiUpdateTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return apiMarkAllAsSeen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return apiApproveStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return apiUpdateDesignFileOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return apiDesignSeen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return apiDesignCommentsSeen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_main_api__ = __webpack_require__(20);




var apiArchiveTask = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(projectId, taskId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/task/archive', { projectId: projectId, taskId: taskId }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function apiArchiveTask(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var apiUnArchiveTask = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(projectId, taskId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/task/unarchive', { projectId: projectId, taskId: taskId }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function apiUnArchiveTask(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var apiAssigneeDesigner = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(projectId, taskId, designerId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/assign-designer-on-task', { projectId: projectId, taskId: taskId, designerId: designerId }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function apiAssigneeDesigner(_x5, _x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();

var apiAddDesignsFileKeys = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(projectId, taskId, addedDesignsFileKeys) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/task/addDesign', { projectId: projectId, taskId: taskId, addedDesignsFileKeys: addedDesignsFileKeys }));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function apiAddDesignsFileKeys(_x8, _x9, _x10) {
    return _ref4.apply(this, arguments);
  };
}();

var apiAddChatFileKeys = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(projectId, chatFileKeys) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/addChatFile', { projectId: projectId, chatFileKeys: chatFileKeys }));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function apiAddChatFileKeys(_x11, _x12) {
    return _ref5.apply(this, arguments);
  };
}();

var apiRemoveDesignFileKey = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(projectId, taskId, removedDesignFileKey) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/task/removeDesign', { projectId: projectId, taskId: taskId, removedDesignFileKey: removedDesignFileKey }));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function apiRemoveDesignFileKey(_x13, _x14, _x15) {
    return _ref6.apply(this, arguments);
  };
}();

var apiUpdateStatus = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(projectId, taskId, taskStatus) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/task/updateStatus', { projectId: projectId, taskId: taskId, taskStatus: taskStatus }));

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function apiUpdateStatus(_x16, _x17, _x18) {
    return _ref7.apply(this, arguments);
  };
}();

var apiUpdateTaskDeadline = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(projectId, taskId, deadline) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/task/setOrUpdateTaskDeadline', { projectId: projectId, taskId: taskId, deadline: deadline }));

          case 1:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));

  return function apiUpdateTaskDeadline(_x19, _x20, _x21) {
    return _ref8.apply(this, arguments);
  };
}();

var apiUpdatePriority = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(projectId, taskId, taskPriority) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/task/updatePriority', { projectId: projectId, taskId: taskId, taskPriority: taskPriority }));

          case 1:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, this);
  }));

  return function apiUpdatePriority(_x22, _x23, _x24) {
    return _ref9.apply(this, arguments);
  };
}();

var apiDesignerStartWorking = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(projectId, taskId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/' + projectId + '/task/' + taskId + '/start-working-on-task/'));

          case 1:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, this);
  }));

  return function apiDesignerStartWorking(_x25, _x26) {
    return _ref10.apply(this, arguments);
  };
}();

var apiUpdateEta = function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(projectId, taskId, estimatedTimeOfCompletion, estimatedWork) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/task/updateETA', { projectId: projectId, taskId: taskId, estimatedTimeOfCompletion: estimatedTimeOfCompletion, estimatedWork: estimatedWork }));

          case 1:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, this);
  }));

  return function apiUpdateEta(_x27, _x28, _x29, _x30) {
    return _ref11.apply(this, arguments);
  };
}();

var apiDownloadAllDesigns = function () {
  var _ref12 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(projectId, taskId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            return _context12.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('get', '/v3/project/' + projectId + '/task/' + taskId + '/zipDesign'));

          case 1:
          case 'end':
            return _context12.stop();
        }
      }
    }, _callee12, this);
  }));

  return function apiDownloadAllDesigns(_x31, _x32) {
    return _ref12.apply(this, arguments);
  };
}();

var apiUpdateTask = function () {
  var _ref13 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(param) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            return _context13.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/task', param));

          case 1:
          case 'end':
            return _context13.stop();
        }
      }
    }, _callee13, this);
  }));

  return function apiUpdateTask(_x33) {
    return _ref13.apply(this, arguments);
  };
}();

var apiMarkAllAsSeen = function () {
  var _ref14 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(projectId, taskId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            return _context14.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/task/seen', { projectId: projectId, taskId: taskId }));

          case 1:
          case 'end':
            return _context14.stop();
        }
      }
    }, _callee14, this);
  }));

  return function apiMarkAllAsSeen(_x34, _x35) {
    return _ref14.apply(this, arguments);
  };
}();

var apiApproveStatus = function () {
  var _ref15 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(projectId, taskId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            return _context15.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/' + projectId + '/task/' + taskId + '/approve'));

          case 1:
          case 'end':
            return _context15.stop();
        }
      }
    }, _callee15, this);
  }));

  return function apiApproveStatus(_x36, _x37) {
    return _ref15.apply(this, arguments);
  };
}();

var apiUpdateDesignFileOrder = function () {
  var _ref16 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(projectId, taskId, designerFileList) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            return _context16.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/task/updateDesignFileOrder', { projectId: projectId, taskId: taskId, designerFileList: designerFileList }));

          case 1:
          case 'end':
            return _context16.stop();
        }
      }
    }, _callee16, this);
  }));

  return function apiUpdateDesignFileOrder(_x38, _x39, _x40) {
    return _ref16.apply(this, arguments);
  };
}();

var apiDesignSeen = function () {
  var _ref17 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(projectId, taskId, designerFileKey) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            return _context17.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/task/designSeen', { projectId: projectId, taskId: taskId, designerFileKey: designerFileKey }));

          case 1:
          case 'end':
            return _context17.stop();
        }
      }
    }, _callee17, this);
  }));

  return function apiDesignSeen(_x41, _x42, _x43) {
    return _ref17.apply(this, arguments);
  };
}();

var apiDesignCommentsSeen = function () {
  var _ref18 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(projectId, taskId, designerFileUuid) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            return _context18.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/comment/design/task/seen', { projectId: projectId, taskId: taskId, designerFileUuid: designerFileUuid }));

          case 1:
          case 'end':
            return _context18.stop();
        }
      }
    }, _callee18, this);
  }));

  return function apiDesignCommentsSeen(_x44, _x45, _x46) {
    return _ref18.apply(this, arguments);
  };
}();

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return apiGetUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return apiLogout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return apiLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return apiSignup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return apiGetInviteKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return apiPasswordReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return apiGetPasswordReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiUploadUserAvatar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return apiUpdateUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return apiUserPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return apiUserProfileUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return apiGetUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return apiCreateUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return apiDeleteUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_main_api__ = __webpack_require__(20);




var apiGetUserInfo = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('get', '/auth/info'));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function apiGetUserInfo() {
    return _ref.apply(this, arguments);
  };
}();

var apiLogout = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('get', '/auth/logout'));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function apiLogout() {
    return _ref2.apply(this, arguments);
  };
}();

var apiLogin = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(email, password) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/auth/login', { email: email, password: password }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function apiLogin(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();

var apiSignup = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(data) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/auth/register', data));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function apiSignup(_x3) {
    return _ref4.apply(this, arguments);
  };
}();

var apiGetInviteKey = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(inviteKey) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('get', '/auth/projectInviteKey', { params: { inviteKey: inviteKey } }));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function apiGetInviteKey(_x4) {
    return _ref5.apply(this, arguments);
  };
}();

var apiPasswordReset = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(email) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/auth/passwordReset', { email: email }));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function apiPasswordReset(_x5) {
    return _ref6.apply(this, arguments);
  };
}();

var apiGetPasswordReset = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(email, token) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('get', '/auth/passwordReset', { params: { email: email, token: token } }));

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function apiGetPasswordReset(_x6, _x7) {
    return _ref7.apply(this, arguments);
  };
}();

var apiUploadUserAvatar = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(param) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/upload/file', param));

          case 1:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));

  return function apiUploadUserAvatar(_x8) {
    return _ref8.apply(this, arguments);
  };
}();

var apiUpdateUser = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(param) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/user', param));

          case 1:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, this);
  }));

  return function apiUpdateUser(_x9) {
    return _ref9.apply(this, arguments);
  };
}();

var apiUserPayment = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(param) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/user/payment', param));

          case 1:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, this);
  }));

  return function apiUserPayment(_x10) {
    return _ref10.apply(this, arguments);
  };
}();

var apiUserProfileUpdate = function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(param) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/profile/update', param));

          case 1:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, this);
  }));

  return function apiUserProfileUpdate(_x11) {
    return _ref11.apply(this, arguments);
  };
}();

// users page
var apiGetUsers = function () {
  var _ref12 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            return _context12.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('get', '/user/list'));

          case 1:
          case 'end':
            return _context12.stop();
        }
      }
    }, _callee12, this);
  }));

  return function apiGetUsers() {
    return _ref12.apply(this, arguments);
  };
}();

var apiCreateUser = function () {
  var _ref13 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(param) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            return _context13.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/user', param));

          case 1:
          case 'end':
            return _context13.stop();
        }
      }
    }, _callee13, this);
  }));

  return function apiCreateUser(_x12) {
    return _ref13.apply(this, arguments);
  };
}();

var apiDeleteUser = function () {
  var _ref14 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            return _context14.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('delete', '/user/' + id));

          case 1:
          case 'end':
            return _context14.stop();
        }
      }
    }, _callee14, this);
  }));

  return function apiDeleteUser(_x13) {
    return _ref14.apply(this, arguments);
  };
}();

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(431),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  set: function set(key, data) {
    if (window.localStorage) {
      return window.localStorage.setItem(key, data);
    } else {
      this._localStorageFallback();
      return this.set(key, data);
    }
  },

  get: function get(key) {
    if (window.localStorage) {
      return window.localStorage.getItem(key);
    } else {
      this._localStorageFallback();
      return this.get(key);
    }
  },

  remove: function remove(key) {
    if (window.localStorage) {
      return window.localStorage.removeItem(key);
    } else {
      this._localStorageFallback();
      return this.remove(key);
    }
  },

  _localStorageFallback: function _localStorageFallback() {
    if (!window.localStorage) {
      Object.defineProperty(window, 'localStorage', new function () {
        var aKeys = [];
        var oStorage = {};
        Object.defineProperty(oStorage, 'getItem', {
          value: function value(sKey) {
            return sKey ? this[sKey] : null;
          },
          writable: false,
          configurable: false,
          enumerable: false
        });
        Object.defineProperty(oStorage, 'key', {
          value: function value(nKeyId) {
            return aKeys[nKeyId];
          },
          writable: false,
          configurable: false,
          enumerable: false
        });
        Object.defineProperty(oStorage, 'setItem', {
          value: function value(sKey, sValue) {
            if (!sKey) {
              return;
            }
            document.cookie = escape(sKey) + '=' + escape(sValue) + '; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/';
          },
          writable: false,
          configurable: false,
          enumerable: false
        });
        Object.defineProperty(oStorage, 'length', {
          get: function get() {
            return aKeys.length;
          },
          configurable: false,
          enumerable: false
        });
        Object.defineProperty(oStorage, 'removeItem', {
          value: function value(sKey) {
            if (!sKey) {
              return;
            }
            document.cookie = escape(sKey) + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
          },
          writable: false,
          configurable: false,
          enumerable: false
        });
        this.get = function () {
          var iThisIndx = void 0;
          for (var sKey in oStorage) {
            iThisIndx = aKeys.indexOf(sKey);
            if (iThisIndx === -1) {
              oStorage.setItem(sKey, oStorage[sKey]);
            } else {
              aKeys.splice(iThisIndx, 1);
            }
            delete oStorage[sKey];
          }
          for (aKeys; aKeys.length > 0; aKeys.splice(0, 1)) {
            oStorage.removeItem(aKeys[0]);
          }
          for (var aCouple, iKey, nIdx = 0, aCouples = document.cookie.split(/\s*;\s*/); nIdx < aCouples.length; nIdx++) {
            aCouple = aCouples[nIdx].split(/\s*=\s*/);
            if (aCouple.length > 1) {
              oStorage[iKey = unescape(aCouple[0])] = unescape(aCouple[1]);
              aKeys.push(iKey);
            }
          }
          return oStorage;
        };
        this.configurable = false;
        this.enumerable = true;
      }());
    }
  }
});

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "App", function() { return App; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Header__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Dropdown__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_directives_Focus__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_Router__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_index__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_resource__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_moment__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_cookie__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuefire__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vee_validate__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_raven_js__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_raven_js_plugins_vue__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_gtag__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_portal_vue__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_portal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_portal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_modules_filters_FormatTitleize__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_modules_filters_FormatNumber__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_modules_filters_FormatDecimals__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_modules_filters_FirstCharacter__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_modules_filters_FileName__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_modules_filters_UndefinedToString__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_modules_filters_FileNameWithExtension__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_toast_dist_vue_toast_min_css__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_toast_dist_vue_toast_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vue_toast_dist_vue_toast_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_assets_styles_style_scss__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_assets_styles_style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_assets_styles_style_scss__);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


/* Components */




/* Directives */


/* Router */


/*
 * Import Vuex
 * */


/*
 Modules
 */











/* Filters */








/* Styles */



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

/*
 * By extending the Vue prototype with a new '$bus' property
 * we can easily access our global event bus from any child component.
 */
Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype, '$bus', {
  get: function get() {
    return this.$root.bus;
  }
});

/* Components */
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('app', __WEBPACK_IMPORTED_MODULE_2__App___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('header-component', __WEBPACK_IMPORTED_MODULE_3__components_common_Header___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('dropdown', __WEBPACK_IMPORTED_MODULE_4__components_common_Dropdown___default.a);

/* Directives */
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive(__WEBPACK_IMPORTED_MODULE_5_modules_directives_Focus__["default"]);

/* Modules */
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_cookie___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_lodash___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_gtag__["a" /* default */], { config: { id: "G-44G522HDRL" } });
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_portal_vue___default.a);
__WEBPACK_IMPORTED_MODULE_14_raven_js___default.a.config('https://f7fffbb8aaa1402e87aa2218b00c930e@sentry.io/247426', {
  ignoreUrls: [/127\.0\.0\.1:3000/i, /localhost:3000/i]
}).addPlugin(__WEBPACK_IMPORTED_MODULE_15_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_1_vue__["default"]).install();

/* Filters */
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_modules_filters_FormatTitleize__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_modules_filters_FormatNumber__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_modules_filters_FormatDecimals__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_modules_filters_FirstCharacter__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_23_modules_filters_UndefinedToString__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_22_modules_filters_FileName__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_24_modules_filters_FileNameWithExtension__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.keyCodes = {
  // Numbers and Numpad Numbers
  numbers: [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105]
};

var App = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
  store: __WEBPACK_IMPORTED_MODULE_7__store_index__["a" /* store */], router: __WEBPACK_IMPORTED_MODULE_6_modules_Router__["a" /* router */] }, __WEBPACK_IMPORTED_MODULE_2__App___default.a));

App.$mount('#app');



/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return router; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_LocalStorage__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ga__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ga__);





var token = null;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{
  path: '/auth',
  name: 'auth',
  meta: {
    checkAuth: true
  },
  component: view('auth/Auth'),
  children: [{
    path: 'login',
    name: 'login',
    meta: {
      title: 'Login',
      checkAuth: true
    },
    component: view('auth/Login')
  }, {
    path: 'invite',
    name: 'invite',
    meta: {
      title: 'Invitation',
      checkAuth: true
    },
    component: view('auth/Invite')
  }, {
    path: 'reset',
    name: 'password-reset',
    meta: {
      title: 'Reset Password',
      checkAuth: true
    },
    component: view('auth/password/Reset')
  }, {
    path: 'signup',
    name: 'signup',
    meta: {
      title: 'Sign Up',
      checkAuth: true
    },
    component: view('auth/SignUp')
  }]
}, {
  path: '/schedule',
  name: 'schedule',
  meta: {
    title: 'Schedule'
  },
  component: view('schedule/Schedule')
}, {
  path: '/tasks',
  name: 'tasks',
  meta: {
    title: 'Tasks'
  },
  component: view('dashboard/Dashboard')
}, {
  path: '/projects',
  name: 'projects',
  meta: {
    title: 'Projects'
  },
  component: view('projects/Projects')
}, {
  path: '/messages',
  name: 'messages',
  meta: {
    title: 'Messages'
  },
  component: view('messages/Messages')
}, {
  path: '/designers',
  name: 'designers',
  meta: {
    title: 'Designers'
  },
  component: view('designers/Designers')
}, {
  path: '/project/:id',
  name: 'project',
  meta: {
    title: 'Project',
    bodyClass: 'background-gray-darkest-2'
  },
  component: view('project/Project')
}, {
  path: '/project/:id/subscription-completed',
  name: 'project-subscription-completed',
  meta: {
    title: 'Project',
    bodyClass: 'background-gray-darkest-2'
  },
  component: view('project/Project')
}, {
  path: '/project/:id/collect-payment-details',
  name: 'project-payment-details',
  meta: {
    title: 'Project',
    bodyClass: 'background-gray-darkest-2'
  },
  component: view('project/Project')
}, {
  path: '/users',
  name: 'users',
  meta: {
    title: 'Users'
  },
  component: view('users/Users')
}, {
  path: '/user',
  name: 'user',
  component: view('user/User'),
  children: [{
    path: 'settings',
    name: 'settings',
    meta: {
      title: 'Settings'
    },
    component: view('user/Settings')
  }]
}, {
  path: '/onboard',
  name: 'onboard',
  component: view('onboard/Onboard'),
  meta: {
    title: 'Onboard',
    checkAuth: true
  }
}];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  base: '/app/',
  routes: routes
});

router.beforeEach(function (to, from, next) {
  token = __WEBPACK_IMPORTED_MODULE_2_modules_LocalStorage__["a" /* default */].get('token');

  if (from.meta.bodyClass) {
    document.querySelector('body').classList.remove(from.meta.bodyClass);
  }

  if (!token && to.meta.checkAuth !== true) {
    next({ name: 'login' });
  } else if (to.path === '/') {
    next({ name: 'projects' });
  } else if (to.path === '/dashboard') {
    // TODO update temp solution
    next({ name: 'tasks' });
  } else {
    next();
  }
});

router.afterEach(function (transition) {
  __WEBPACK_IMPORTED_MODULE_3_ga___default()('send', 'pageview', '/app' + transition.path);

  if (transition.meta.bodyClass) {
    document.querySelector('body').classList.add(transition.meta.bodyClass);
  }
  document.querySelector('head title').innerHTML = 'Koncepted - ' + transition.meta.title;
});

function view(name, resolve) {
  return function (resolve) {
    __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(464)("./" + name + '.vue')]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  };
}

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('focus', {
  inserted: function inserted(el) {
    el.focus();

    if (el.getAttribute('data-autoheight')) {
      el.style.height = '0px';
      el.style.height = el.scrollHeight + 'px';
    }
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
  var VueFileNameFilter = function VueFileNameFilter(value) {
    if (value || value === 0) {
      return value.replace(/^.*[\\/]/, '').split('.')[0];
    }
  };

  Vue.filter('fileName', VueFileNameFilter);
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
  var VueFileNameWithExtensionFilter = function VueFileNameWithExtensionFilter(value) {
    if (value || value === 0) {
      return value.replace(/^.*[\\/]/, '');
    }
  };

  Vue.filter('fileNameWithExtension', VueFileNameWithExtensionFilter);
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
  var VueFirstCharacterFilter = function VueFirstCharacterFilter(value) {
    if (value || value === 0) {
      return value[0];
    }
  };

  Vue.filter('firstCharacter', VueFirstCharacterFilter);
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
  var VueFormatDecimalsFilter = function VueFormatDecimalsFilter(value, number) {
    if (value || value === 0) {
      return parseFloat(value.toFixed(number));
    }
  };

  Vue.filter('formatDecimals', VueFormatDecimalsFilter);
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
  var VueFormatNumberFilter = function VueFormatNumberFilter(value) {
    if (value || value === 0) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  };

  Vue.filter('formatNumber', VueFormatNumberFilter);
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
  var VueFormatTitleize = function VueFormatTitleize(value) {
    return value.replace('_', ' ').replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };

  Vue.filter('titleize', VueFormatTitleize);
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
  var VueUndefinedToString = function VueUndefinedToString(value) {
    return value === undefined ? '' : value;
  };
  Vue.filter('undToStr', VueUndefinedToString);
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_User__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_Project__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_ProjectSortTask__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_Task__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_Tasks__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_Dashboard__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_Designers__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_CreateTask__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_Projectnotifications__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_Messages__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_WorkLog__ = __webpack_require__(323);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);













var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  modules: {
    User: __WEBPACK_IMPORTED_MODULE_2__modules_User__["a" /* User */],
    Project: __WEBPACK_IMPORTED_MODULE_3__modules_Project__["a" /* Project */],
    ProjectSortTask: __WEBPACK_IMPORTED_MODULE_4__modules_ProjectSortTask__["a" /* ProjectSortTask */],
    Task: __WEBPACK_IMPORTED_MODULE_5__modules_Task__["a" /* Task */],
    Tasks: __WEBPACK_IMPORTED_MODULE_6__modules_Tasks__["a" /* Tasks */],
    Dashboard: __WEBPACK_IMPORTED_MODULE_7__modules_Dashboard__["a" /* Dashboard */],
    Designers: __WEBPACK_IMPORTED_MODULE_8__modules_Designers__["a" /* Designers */],
    CreateTask: __WEBPACK_IMPORTED_MODULE_9__modules_CreateTask__["a" /* CreateTask */],
    ProjectNotifications: __WEBPACK_IMPORTED_MODULE_10__modules_Projectnotifications__["a" /* ProjectNotifications */],
    Messages: __WEBPACK_IMPORTED_MODULE_11__modules_Messages__["a" /* Messages */],
    WorkLog: __WEBPACK_IMPORTED_MODULE_12__modules_WorkLog__["a" /* WorkLog */]
  }
});

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(429),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(432),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(436),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(450),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(454),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(448),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 265 */,
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiGetDesigners; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return apiGetWorkLog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_main_api__ = __webpack_require__(20);




var apiGetDesigners = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('get', '/v3/project/designer/overview'));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function apiGetDesigners() {
    return _ref.apply(this, arguments);
  };
}();

var apiGetWorkLog = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('get', '/v3/designer-work-log/monthly'));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function apiGetWorkLog() {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return apiGetNotificationsToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiMarkAsReadNotifications; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_main_api__ = __webpack_require__(20);




var apiGetNotificationsToken = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('get', '/v3/platform-notification/init'));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function apiGetNotificationsToken() {
    return _ref.apply(this, arguments);
  };
}();

var apiMarkAsReadNotifications = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(projectID) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('delete', '/v3/platform-notification/' + projectID));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function apiMarkAsReadNotifications(_x) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiGetProjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return apiGetProjectsAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return apiUpdateProjectData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return apiProjectRemove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return apiProjectUpdateStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return apiGetDribbbleShots; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_main_api__ = __webpack_require__(20);




var apiGetProjects = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(state, sort, cursor) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('get', '/v3/project/list?projectState=' + state + '&sort=' + sort + '&limit=20&cursor=' + cursor));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function apiGetProjects(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var apiGetProjectsAll = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(state, sort) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('get', '/v3/project/list?projectState=' + state + '&sort=' + sort));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function apiGetProjectsAll(_x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

var apiUpdateProjectData = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(param) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/updateData', param));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function apiUpdateProjectData(_x6) {
    return _ref3.apply(this, arguments);
  };
}();

var apiProjectRemove = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(projectId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('delete', '/v3/project/' + projectId));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function apiProjectRemove(_x7) {
    return _ref4.apply(this, arguments);
  };
}();

var apiProjectUpdateStatus = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(id, state) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/changeState', { id: id, state: state }));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function apiProjectUpdateStatus(_x8, _x9) {
    return _ref5.apply(this, arguments);
  };
}();

var apiGetDribbbleShots = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(token) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('get', 'https://api.dribbble.com/v2/user/shots?access_token=' + token));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function apiGetDribbbleShots(_x10) {
    return _ref6.apply(this, arguments);
  };
}();

/***/ }),
/* 269 */,
/* 270 */,
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(442),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(433),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(424),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(428),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(430),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(444),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(438),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(441),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(437),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(439),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(455),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(435),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(453),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(425),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(426),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(427),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(449),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(446),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(434),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(451),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(452),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports = ga;

/***/ }),
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return apiGetPaymentClientToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return apiGetStripePlatformRedirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiCreateStripeCustomer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return apiCancelSubscription; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_main_api__ = __webpack_require__(20);




var apiGetPaymentClientToken = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(clientTokenId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/stripe-payment/clientToken?id=' + clientTokenId));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function apiGetPaymentClientToken(_x) {
    return _ref.apply(this, arguments);
  };
}();

var apiGetStripePlatformRedirect = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(clientId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('get', '/v3/project/stripe-payment/portal-session?id=' + clientId));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function apiGetStripePlatformRedirect(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var apiCreateStripeCustomer = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(customerId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/stripe-payment/create-or-update-customer?id=' + customerId));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function apiCreateStripeCustomer(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

var apiCancelSubscription = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_main_api__["a" /* api */])('post', '/v3/project/stripe-payment/cancel-subscription?id=' + id));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function apiCancelSubscription(_x4) {
    return _ref4.apply(this, arguments);
  };
}();

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreateTask; });
var CreateTask = {
  state: {
    showCreateTask: false
  },
  mutations: {
    setShowCreateTask: function setShowCreateTask(state, payload) {
      state.showCreateTask = payload;
    }
  },
  actions: {
    showCreateTask: function showCreateTask(_ref) {
      var commit = _ref.commit;

      commit("setShowCreateTask", true);
    },
    closeCreateTask: function closeCreateTask(_ref2) {
      var commit = _ref2.commit;

      commit("setShowCreateTask", false);
    },
    toggleCreateTask: function toggleCreateTask(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state;

      commit('setShowCreateTask', !state.showCreateTask);
    }
  },
  getters: {
    getShowCreateTask: function getShowCreateTask(state) {
      return state.showCreateTask;
    }
  }
};

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dashboard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);



var Dashboard = {
  state: {
    dasboardTasks: [],
    dasboardTasksCursor: ''
  },
  mutations: {
    setDasboardTasks: function setDasboardTasks(state, payload) {
      state.dasboardTasks = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(payload));
    },
    setDasboardTasksCursor: function setDasboardTasksCursor(state, payload) {
      state.dasboardTasksCursor = payload;
    },
    setDasboardTaskProperties: function setDasboardTaskProperties(state, payload) {
      var taskIndex = payload.taskIndex,
          properties = payload.properties;

      var updatedItem = {
        task: {},
        project: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.dasboardTasks[taskIndex].project)
      };
      updatedItem.task = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, state.dasboardTasks[taskIndex].task, properties);
      return state.dasboardTasks.splice(taskIndex, 1, updatedItem);
    }
  },
  actions: {
    updateDasboardTasks: function updateDasboardTasks(_ref, payload) {
      var commit = _ref.commit;

      commit("setDasboardTasks", payload);
    },
    updateDasboardTasksCursor: function updateDasboardTasksCursor(_ref2, payload) {
      var commit = _ref2.commit;

      commit("setDasboardTasksCursor", payload);
    },
    updateDashboardTaskProperties: function updateDashboardTaskProperties(_ref3, payload) {
      var commit = _ref3.commit,
          getters = _ref3.getters;
      var taskId = payload.taskId,
          properties = payload.properties;

      var taskIndex = getters.getDasboardTasks.findIndex(function (el) {
        return el.task.id === taskId;
      });
      if (taskIndex === -1) return false;
      return commit("setDasboardTaskProperties", { taskIndex: taskIndex, properties: properties });
    },
    clearDashboardTasks: function clearDashboardTasks(_ref4) {
      var commit = _ref4.commit;

      commit('setDasboardTasksCursor', '');
      return commit('setDasboardTasks', []);
    }
  },
  getters: {
    getDasboardTasks: function getDasboardTasks(state) {
      return state.dasboardTasks;
    },
    getDasboardTasksCursor: function getDasboardTasksCursor(state) {
      return state.dasboardTasksCursor;
    }
  }
};

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Designers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_task_api__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_Error__ = __webpack_require__(7);







var Designers = {
  state: {
    onProjectDesigners: [],
    othersDesigners: []
  },
  mutations: {
    setOnProjectDesigners: function setOnProjectDesigners(state, payload) {
      state.onProjectDesigners = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(payload));
    },
    setOthersDesigners: function setOthersDesigners(state, payload) {
      state.othersDesigners = payload;
    }
  },
  actions: {
    updateOnProjectDesigners: function updateOnProjectDesigners(_ref, payload) {
      var commit = _ref.commit;

      commit("setOnProjectDesigners", payload);
    },
    updateOthersDesigners: function updateOthersDesigners(_ref2, payload) {
      var commit = _ref2.commit;

      commit("setOthersDesigners", payload);
    },
    assigneeDesigner: function assigneeDesigner(_ref3, payload) {
      var _this = this;

      var dispatch = _ref3.dispatch,
          getters = _ref3.getters;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var projectId, taskId, designer, _ref4, _ref5, err, data, isNotOnProjectDesigners, assignedDesigner, isDesignerNotInProject;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                projectId = payload.projectId, taskId = payload.taskId, designer = payload.designer;
                _context.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_task_api__["q" /* apiAssigneeDesigner */])(projectId, taskId, designer.id);

              case 3:
                _ref4 = _context.sent;
                _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref4, 2);
                err = _ref5[0];
                data = _ref5[1];

                if (!err) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_modules_Error__["a" /* errorMessage */])(err, 'Unable to Assign Designer!'));

              case 9:
                isNotOnProjectDesigners = getters.getOnProjectDesigners.findIndex(function (user) {
                  return user.id === designer.id;
                }) === -1;


                if (isNotOnProjectDesigners) {
                  assignedDesigner = getters.getOthersDesigners.filter(function (user) {
                    return user.id === designer.id;
                  })[0];

                  assignedDesigner.onTask = true;
                  dispatch('updateOthersDesigners', getters.getOthersDesigners.filter(function (user) {
                    return user.id !== designer.id;
                  }));
                  dispatch('updateOnProjectDesigners', [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(getters.getOnProjectDesigners), [assignedDesigner]));
                }

                isDesignerNotInProject = getters.getProjectUsers && getters.getProjectUsers.findIndex(function (user) {
                  return user.id === designer.id;
                }) === -1;

                if (isDesignerNotInProject) {
                  dispatch('updateProjectProperties', { projectUsersFeData: [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(getters.getProjectUsers), [data]) });
                }

                dispatch('updateDashboardTaskProperties', { taskId: taskId,
                  properties: {
                    designerId: designer.id,
                    designerAvatarKey: designer.avatarKey,
                    designerFullName: designer.name + ' ' + designer.surname
                  }
                });

                return _context.abrupt('return', dispatch('updateActiveTaskProperties', { taskId: taskId,
                  properties: { designerId: designer.id }
                }));

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  getters: {
    getOnProjectDesigners: function getOnProjectDesigners(state) {
      return state.onProjectDesigners;
    },
    getOthersDesigners: function getOthersDesigners(state) {
      return state.othersDesigners;
    }
  }
};

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Messages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_Error__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_messages_api__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_firebase__);










var Messages = {
  state: {
    messageProjects: [],
    messageToken: null
  },
  mutations: {
    setMessageProjects: function setMessageProjects(state, payload) {
      state.messageProjects = [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(payload));
    },
    setMessageToken: function setMessageToken(state, payload) {
      state.messageToken = payload;
    }
  },
  actions: {
    initMessages: function initMessages(_ref) {
      var _this = this;

      var commit = _ref.commit,
          getters = _ref.getters;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref2, _ref3, err, data, messageDB;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!getters.getUser.role || !['admin', 'projectManager', 'designer'].includes(getters.getUser.role))) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', false);

              case 2:
                _context.next = 4;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__api_messages_api__["b" /* apiGetNotificationsToken */])();

              case 4:
                _ref2 = _context.sent;
                _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                err = _ref3[0];
                data = _ref3[1];

                if (!err) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_modules_Error__["a" /* errorMessage */])(err, 'Unable to get messages token!'));

              case 10:
                commit('setMessageToken', data);
                _context.prev = 11;

                __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.initializeApp(getters.getMessageToken);
                _context.next = 15;
                return __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.auth().signInWithCustomToken(getters.getMessageToken.customToken);

              case 15:
                messageDB = __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.database().ref('/per-user-notifications/' + getters.getUser.id);

                messageDB.on("value", function (snapshot) {
                  commit('setMessageProjects', []);
                  var projects = [];
                  var val = snapshot.val();
                  if (!val) return projects;

                  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(val).forEach(function (projectId) {
                    var project = { id: projectId, name: null, messages: [] };
                    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(val[projectId]).forEach(function (messageId) {
                      var message = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, val[projectId][messageId]);
                      if (!project.name && message.pn) project.name = message.pn;
                      project.messages.push({
                        id: messageId,
                        senderName: message.sn,
                        text: message.txt,
                        timestamp: message.ts,
                        link: message.ln,
                        type: message.t
                      });
                    });
                    projects.push(project);
                  });
                  commit('setMessageProjects', projects);
                });

                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](11);

                _context.t0.message ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_modules_Error__["a" /* errorMessage */])(_context.t0, 'Error: ' + _context.t0.message) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_modules_Error__["a" /* errorMessage */])(_context.t0, 'Unable to get messages from Firebase!');

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[11, 19]]);
      }))();
    },
    clearMessages: function clearMessages(_ref4) {
      var commit = _ref4.commit,
          dispatch = _ref4.dispatch;

      return commit('setMessageProjects', []);
    }
  },
  getters: {
    getMessageProjects: function getMessageProjects(state) {
      return state.messageProjects;
    },
    getMessagesCount: function getMessagesCount(state) {
      var count = 0;
      state.messageProjects.forEach(function (project) {
        count = count + project.messages.length;
      });
      return count;
    },
    getMessageToken: function getMessageToken(state) {
      return state.messageToken;
    }
  }
};

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Project; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(37);



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

var Project = {
  state: {
    project: {}
  },
  mutations: {
    setProject: function setProject(state, payload) {
      state.project = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payload);
    },
    addUser: function addUser(state, payload) {
      state.project.projectUsersFeData.push(payload);
    },
    removeUser: function removeUser(state, payload) {
      state.project.projectUsersFeData = _.filter(state.project.projectUsersFeData, function (user) {
        return user.id !== payload;
      });
    }
  },
  actions: {
    addUserToProject: function addUserToProject(_ref, payload) {
      var commit = _ref.commit;

      commit('addUser', payload);
    },
    removeUserFromProject: function removeUserFromProject(_ref2, payload) {
      var commit = _ref2.commit;

      commit('removeUser', payload);
    },
    updateProject: function updateProject(_ref3, payload) {
      var commit = _ref3.commit;

      commit('setProject', payload);
    },
    updateProjectProperties: function updateProjectProperties(_ref4, payload) {
      var commit = _ref4.commit,
          getters = _ref4.getters;

      commit('setProject', _.assign(getters.getProject, payload));
    },
    clearProject: function clearProject(_ref5) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch;

      dispatch('clearActiveTasks');
      dispatch('clearArchiveTasks');
      dispatch('clearCustomTasks');
      dispatch('clearSortTask');
      dispatch('clearTasksDragDisabled');
      dispatch('closeCreateTask');
      return commit('setProject', {});
    }
  },
  getters: {
    getActiveProjectUsers: function getActiveProjectUsers(state) {
      var activeProjectUsers = _.filter(state.project.projectUsersFeData, ['userActiveOnProject', true]);
      return _.orderBy(activeProjectUsers, function (user) {
        return user.userProjectRole === 'owner' ? 0 : 1;
      });
    },
    getProjectUsers: function getProjectUsers(state) {
      return state.project.projectUsersFeData;
    },
    getCountProjectDesigners: function getCountProjectDesigners(state, getters) {
      var designers = getters.getProjectUsers.filter(function (user) {
        return user.role === 'designer';
      });
      return designers.length;
    },
    getPotentialProjectOwners: function getPotentialProjectOwners(state) {
      return _.filter(state.project.projectUsersFeData, function (user) {
        return user.userActiveOnProject === true && user.role === 'customer';
      });
    },
    getProject: function getProject(state) {
      return state.project;
    }
  }
};

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProjectSortTask; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(37);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

var ProjectSortTask = {
  state: {
    sortTasksBy: {
      selected: 'created',
      options: [{
        name: 'priority',
        value: 'priority'
      }, {
        name: 'date added',
        value: 'created'
      }, {
        name: 'task status',
        value: 'status'
      }, {
        name: 'custom',
        value: 'custom'
      }]
    },
    isTasksDragDisabled: false
  },
  mutations: {
    setSortTaskBy: function setSortTaskBy(state, payload) {
      state.sortTasksBy.selected = payload;
    },
    setIsTasksDragDisabled: function setIsTasksDragDisabled(state, payload) {
      state.isTasksDragDisabled = payload;
    }
  },
  actions: {
    updateSortTaskBy: function updateSortTaskBy(_ref, payload) {
      var commit = _ref.commit;

      commit('setSortTaskBy', payload);
    },
    toggleIsTasksDragDisabled: function toggleIsTasksDragDisabled(_ref2, payload) {
      var commit = _ref2.commit;

      commit('setIsTasksDragDisabled', payload);
    },
    clearSortTask: function clearSortTask(_ref3) {
      var commit = _ref3.commit;

      commit('setSortTaskBy', 'created');
    },
    clearTasksDragDisabled: function clearTasksDragDisabled(_ref4) {
      var commit = _ref4.commit;

      commit('setIsTasksDragDisabled', false);
    }
  },
  getters: {
    getSortTasksBy: function getSortTasksBy(state) {
      return state.sortTasksBy;
    },
    getIsTasksDragDisabled: function getIsTasksDragDisabled(state) {
      return state.isTasksDragDisabled;
    }
  }
};

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProjectNotifications; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

var sortNotification = function sortNotification(arr) {
  return _(arr)
  // group by notificationsSeen
  .sortBy('notificationsSeen').groupBy('notificationsSeen').map(function (el, key) {
    return key === 'true' ? _.orderBy(el, 'commentTime', 'desc') : _(el).groupBy('commentType').map(function (obj, index) {
      return index == 'addFile' ? _.orderBy(obj, 'commentTime', 'desc')
      // count comments
      : _(obj).orderBy('commentTime', 'desc').groupBy('userFullName').map(function (task) {
        return _(task).groupBy('link').map(function (link) {
          link = _.orderBy(link, 'commentTime', 'desc');
          link[0].commentCount = link.length;
          return link[0];
        }).flatten().value();
      }).flatten().value();
    }).flatten().orderBy('commentTime', 'desc').value();
  }).flatten().orderBy('commentTime', 'desc').value();
};

var ProjectNotifications = {
  state: {},
  mutations: {},
  actions: {},
  getters: {
    getProjectNotifications: function getProjectNotifications(state, rootGetters) {
      var taskList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(rootGetters.getActiveTaskList));
      var notifications = [];

      var notificationComments = [];
      var item = {};

      var notificationFiles = [];
      var itemFile = {};

      if (taskList) {
        _.forEach(taskList, function (task) {
          _.forEach(task.designerFileList, function (designerFile) {
            // add comments file
            itemFile = {
              'taskName': task.title,
              'taskId': task.id,
              'commentTime': designerFile.created,
              'userFirstName': designerFile.userFirstName,
              'userSecondName': designerFile.userSecondName,
              'userFullName': designerFile.userFirstName + ' ' + designerFile.userSecondName,
              'commentType': 'addFile',
              'link': designerFile.uuid,
              'notificationsSeen': designerFile.seenDesignerFile,
              'fileName': designerFile.designerFileKey
            };
            notificationFiles.push(itemFile);
            // add comments
            _.forEach(designerFile.fileCommentList, function (commentList) {
              item = {
                'taskName': task.title,
                'taskId': task.id,
                'commentTime': commentList.timestamp,
                'userFirstName': commentList.userFirstName,
                'userSecondName': commentList.userSecondName,
                'userFullName': commentList.userFirstName + ' ' + commentList.userSecondName,
                'comment': commentList.comment,
                'commentType': 'addComment',
                'link': designerFile.uuid,
                'notificationsSeen': commentList.seenComment
              };
              notificationComments.push(item);
              _.forEach(commentList.fileCommentReplyList, function (commentListReplay) {
                item = {
                  'taskName': task.title,
                  'taskId': task.id,
                  'commentTime': commentListReplay.timestamp,
                  'userFirstName': commentListReplay.userFirstName,
                  'userSecondName': commentListReplay.userSecondName,
                  'userFullName': commentListReplay.userFirstName + ' ' + commentListReplay.userSecondName,
                  'comment': commentListReplay.comment,
                  'commentType': 'addComment',
                  'link': designerFile.uuid,
                  'notificationsSeen': commentList.seenComment
                };
                notificationComments.push(item);
              });
            });
          });
        });
      }

      notifications = sortNotification(notificationComments.concat(notificationFiles));

      return notifications;
    }
  }
};

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Task; });
var Task = {
  state: {
    task: {},
    fileCommentList: []
  },
  mutations: {
    setFileCommentList: function setFileCommentList(state, payload) {
      state.fileCommentList = payload.fileCommentList;
    },
    updateFileCommentList: function updateFileCommentList(state, payload) {
      state.fileCommentList = _.assign(state.fileCommentList, payload.fileCommentList);
    },
    toggleFileCommentListActive: function toggleFileCommentListActive(state, payload) {
      state.fileCommentList = _.forEach(state.fileCommentList, function (comment) {
        if (comment.id !== payload.currentComment.id) {
          comment.activeComment = false;
        }
      });
    }
  }
};

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tasks; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_task_api__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_Error__ = __webpack_require__(7);








var Tasks = {
  state: {
    activeTasks: [],
    activeTasksCursor: '',
    archivedTasks: [],
    archivedTasksCursor: '',
    customTaskList: []
  },
  mutations: {
    setActiveTasks: function setActiveTasks(state, payload) {
      state.activeTasks = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(payload));
    },
    setActiveTasksCursor: function setActiveTasksCursor(state, payload) {
      state.activeTasksCursor = payload;
    },
    setActiveTaskProperties: function setActiveTaskProperties(state, payload) {
      var taskIndex = payload.taskIndex,
          properties = payload.properties;

      var updatedTask = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.activeTasks[taskIndex], properties);
      return state.activeTasks.splice(taskIndex, 1, updatedTask);
    },
    setActiveTask: function setActiveTask(state, payload) {
      var taskIndex = payload.taskIndex,
          updatedTask = payload.updatedTask;

      return state.activeTasks.splice(taskIndex, 1, updatedTask);
    },
    setArchivedTasks: function setArchivedTasks(state, payload) {
      state.archivedTasks = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(payload));
    },
    setArchivedTaskProperties: function setArchivedTaskProperties(state, payload) {
      var taskIndex = payload.taskIndex,
          properties = payload.properties;

      var updatedTask = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.archivedTasks[taskIndex], properties);
      return state.archivedTasks.splice(taskIndex, 1, updatedTask);
    },
    setArchivedTasksCursor: function setArchivedTasksCursor(state, payload) {
      state.archivedTasksCursor = payload;
    },
    setCustomTaskList: function setCustomTaskList(state, payload) {
      state.customTaskList = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(payload));
    }
  },
  actions: {
    addActiveTask: function addActiveTask(_ref, payload) {
      var commit = _ref.commit,
          getters = _ref.getters,
          dispatch = _ref.dispatch;

      dispatch('updateProjectProperties', { taskCount: getters.getProject.taskCount + 1 });
      commit('setActiveTasks', [payload].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(getters.getActiveTaskList)));
    },
    updateStatus: function updateStatus(_ref2, payload) {
      var _this = this;

      var dispatch = _ref2.dispatch;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var projectId, taskId, status, _ref3, _ref4, err, data, id, priority;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                projectId = payload.projectId, taskId = payload.taskId, status = payload.status;
                _context.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__api_task_api__["r" /* apiUpdateStatus */])(projectId, taskId, status);

              case 3:
                _ref3 = _context.sent;
                _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);
                err = _ref4[0];
                data = _ref4[1];

                if (!err) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_modules_Error__["a" /* errorMessage */])(err, 'Unable to update task status!'));

              case 9:
                id = data.id, priority = data.priority;

                dispatch('updateDashboardTaskProperties', { taskId: id,
                  properties: { status: status, priority: priority.textValue }
                });
                return _context.abrupt('return', dispatch('updateActiveTaskProperties', { taskId: id,
                  properties: { status: status, priority: priority }
                }));

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    updateActiveTasks: function updateActiveTasks(_ref5, payload) {
      var commit = _ref5.commit;

      commit("setActiveTasks", payload);
    },
    updateActiveTask: function updateActiveTask(_ref6, payload) {
      var commit = _ref6.commit,
          getters = _ref6.getters;

      var taskIndex = getters.getActiveTaskList.findIndex(function (task) {
        return task.id === payload.id;
      });
      var updatedTask = _.assign(getters.getActiveTaskList[taskIndex], payload);
      commit("setActiveTask", { taskIndex: taskIndex, updatedTask: updatedTask });
    },
    updateActiveTaskProperties: function updateActiveTaskProperties(_ref7, payload) {
      var commit = _ref7.commit,
          getters = _ref7.getters;
      var taskId = payload.taskId,
          properties = payload.properties;

      var taskIndex = getters.getActiveTaskList.findIndex(function (task) {
        return task.id === taskId;
      });
      if (taskIndex === -1) return false;
      return commit("setActiveTaskProperties", { taskIndex: taskIndex, properties: properties });
    },
    updateActiveTaskDesignerFileProperty: function updateActiveTaskDesignerFileProperty(_ref8, payload) {
      var getters = _ref8.getters,
          dispatch = _ref8.dispatch;
      var taskId = payload.taskId,
          uuid = payload.uuid,
          properties = payload.properties;

      var taskIndex = getters.getActiveTaskList.findIndex(function (task) {
        return task.id === taskId;
      });
      if (taskIndex === -1) return false;
      var designerFileList = getters.getActiveTaskList[taskIndex].designerFileList;
      var fileIndex = designerFileList.findIndex(function (file) {
        return file.uuid === uuid;
      });
      if (fileIndex === -1) return false;

      var updatedDesignerFile = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, designerFileList[fileIndex], properties);
      designerFileList.splice(fileIndex, 1, updatedDesignerFile);
      return dispatch('updateActiveTaskProperties', { taskId: taskId, properties: { designerFileList: designerFileList } });
    },
    updateActiveTasksCursor: function updateActiveTasksCursor(_ref9, payload) {
      var commit = _ref9.commit;

      commit('setActiveTasksCursor', payload);
    },
    updateArchivedTasks: function updateArchivedTasks(_ref10, payload) {
      var commit = _ref10.commit;

      commit('setArchivedTasks', payload);
    },
    updateArchivedTaskProperties: function updateArchivedTaskProperties(_ref11, payload) {
      var commit = _ref11.commit,
          getters = _ref11.getters;
      var taskId = payload.taskId,
          properties = payload.properties;

      var taskIndex = getters.getArchivedTaskList.findIndex(function (task) {
        return task.id === taskId;
      });
      if (taskIndex === -1) return false;
      return commit("setArchivedTaskProperties", { taskIndex: taskIndex, properties: properties });
    },
    updateArchivedTasksCursor: function updateArchivedTasksCursor(_ref12, payload) {
      var commit = _ref12.commit;

      commit('setArchivedTasksCursor', payload);
    },
    updateCustomSortTask: function updateCustomSortTask(_ref13, payload) {
      var commit = _ref13.commit,
          dispatch = _ref13.dispatch;

      var customTasklist = []; // TODO remove after endpoint will be ready
      payload.forEach(function (task, index) {
        task.customSortIndex = index;
        customTasklist.push(task);
      });
      commit('setCustomTaskList', payload);
      dispatch('updateSortTaskBy', 'custom');
    },
    removeTask: function removeTask(_ref14, payload) {
      var commit = _ref14.commit,
          dispatch = _ref14.dispatch,
          getters = _ref14.getters;

      dispatch('updateProjectProperties', { taskCount: getters.getProject.taskCount - 1 });
      commit('setActiveTasks', getters.getActiveTaskList.filter(function (task) {
        return task.id !== payload;
      }));
    },
    archiveTask: function archiveTask(_ref15, payload) {
      var dispatch = _ref15.dispatch,
          getters = _ref15.getters;

      var archivedTask = getters.getActiveTaskList.find(function (task) {
        return task.id === payload;
      });
      archivedTask.taskArchived = true;
      dispatch('updateActiveTasks', getters.getActiveTaskList.filter(function (task) {
        return task.id !== payload;
      }));
      dispatch('updateArchivedTasks', [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(getters.getArchivedTaskList), [archivedTask]));
      var updatedCountArchivedTasks = getters.getProject.countArchivedTasks ? getters.getProject.countArchivedTasks + 1 : 1;
      dispatch('updateProjectProperties', { countArchivedTasks: updatedCountArchivedTasks });
    },
    unArchiveTask: function unArchiveTask(_ref16, payload) {
      var dispatch = _ref16.dispatch,
          getters = _ref16.getters;

      var unArchivedTask = getters.getArchivedTaskList.find(function (task) {
        return task.id === payload;
      });
      unArchivedTask.taskArchived = false;
      dispatch('updateActiveTasks', [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(getters.getActiveTaskList), [unArchivedTask]));
      dispatch('updateArchivedTasks', getters.getArchivedTaskList.filter(function (task) {
        return task.id !== payload;
      }));
      dispatch('updateProjectProperties', { countArchivedTasks: getters.getProject.countArchivedTasks - 1 });
    },
    clearMarkAllAsReed: function clearMarkAllAsReed(_ref17) {
      var dispatch = _ref17.dispatch,
          getters = _ref17.getters;

      var taslList = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(getters.getActiveTaskList));
      taslList.forEach(function (task) {
        task.designsAndCommentsSeen = true;
        task.designerFileList.forEach(function (designerFile) {
          designerFile.seenDesignerFile = true;
          designerFile.seenComments = true;
          designerFile.fileCommentList.forEach(function (comment) {
            comment.seenComment = true;
          });
        });
      });
      dispatch("updateActiveTasks", taslList);
    },
    clearActiveTasks: function clearActiveTasks(_ref18) {
      var commit = _ref18.commit;

      commit('setActiveTasks', []);
      commit('setActiveTasksCursor', '');
    },
    clearArchiveTasks: function clearArchiveTasks(_ref19) {
      var commit = _ref19.commit;

      commit('setArchivedTasks', []);
      commit('setArchivedTasksCursor', '');
    },
    clearCustomTasks: function clearCustomTasks(_ref20) {
      var commit = _ref20.commit;

      commit('setCustomTaskList', []);
    }
  },
  getters: {
    getActiveTaskList: function getActiveTaskList(state) {
      return state.activeTasks;
    },
    getActiveTasksCursor: function getActiveTasksCursor(state) {
      return state.activeTasksCursor;
    },
    getArchivedTaskList: function getArchivedTaskList(state) {
      return state.archivedTasks;
    },
    getArchivedTasksCursor: function getArchivedTasksCursor(state) {
      return state.archivedTasksCursor;
    },


    getTaskDesignerFileFeedback: function getTaskDesignerFileFeedback(state) {
      return function (taskId, uuid) {
        var task = state.activeTasks.find(function (task) {
          return task.id === taskId;
        });
        if (task === undefined) return 'NO_FEEDBACK';
        var file = task.designerFileList.find(function (file) {
          return file.uuid === uuid;
        });
        if (file === undefined) return 'NO_FEEDBACK';
        return file.feedback ? file.feedback : 'NO_FEEDBACK';
      };
    }
    // getTasksReport (state) {
    //   // TODO origin code from project, refactor or remove ...
    //   let taskList = _.forEach(this.activeTaskList, (el) => {
    //     el.taskChargedAmount = el.taskHourRate ? el.chargedHours * el.taskHourRate : el.chargedHours * this.project.projectHourRate
    //   })

    //   let report = this.project.chargedHoursPerTask
    //   report = _.forEach(report, (el) => {
    //     el.data = parseInt(this.$moment(el.timestamp).format('YYYYMMDD'))
    //     el.taskChargedAmount = _.find(taskList, (o) => o.id === el.taskId).taskChargedAmount
    //     el.timestamp = parseInt(el.timestamp)
    //   })

    //   report = _(report)
    //             .groupBy('data')
    //             .map((el, key) => ({
    //               data: parseInt(key),
    //               timestamp: parseInt(el[0].timestamp),
    //               report: _(el)
    //                         .groupBy('taskId')
    //                         .map((o) => ({
    //                           taskName: o[0].taskName,
    //                           sum: _.sumBy(o, 'amount'),
    //                           timestamp: (_.orderBy(o, 'timestamp', 'desc')[0].timestamp)
    //                         }))
    //                         .orderBy('timestamp', 'desc')
    //                         .value()
    //             }))
    //             .orderBy('data', 'desc')
    //             .value()

    //   return report
    // }
  }
};

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return User; });
var User = {
  state: {
    user: {},
    users: []
  },
  mutations: {
    /* Current User */
    setUser: function setUser(state, payload) {
      state.user = payload;
    },
    updateUserProperties: function updateUserProperties(state, payload) {
      state.user = _.assign(state.user, payload.user);
    },

    /* User List */
    setUsers: function setUsers(state, payload) {
      state.users = payload.users;
    },
    addUserToUsers: function addUserToUsers(state, payload) {
      state.users.push(payload.user);
    },
    removeUserFromUsers: function removeUserFromUsers(state, payload) {
      state.users = _.filter(state.users, function (user) {
        return user.id !== payload.userId;
      });
    }
  },
  actions: {
    updateUser: function updateUser(_ref, payload) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      if (payload.taskSortType) dispatch('updateSortTaskBy', payload.taskSortType);
      if (payload.role === 'designer' && payload.dailyAvailability === undefined) {
        payload.dailyAvailability = 8; // TODO temp solution to add new property dailyAvailability
      }
      commit('setUser', payload);
    }
  },
  getters: {
    getUser: function getUser(state) {
      return state.user;
    },
    getUsers: function getUsers(state) {
      return state.users;
    }
  }
};

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WorkLog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_designers_api__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_Error__ = __webpack_require__(7);







function byDateDesc(a, b) {
  return b.fromTs - a.fromTs;
}

var WorkLog = {
  state: {
    workLogData: null,
    isLoading: false
  },
  mutations: {
    setWorkLogData: function setWorkLogData(state, payload) {
      state.workLogData = payload;
      state.isLoading = false;
    },
    "WorkLog/setIsLoading": function WorkLogSetIsLoading(state, payload) {
      state.isLoading = payload;
    }
  },
  actions: {
    getWorkLog: function getWorkLog(_ref) {
      var _this = this;

      var commit = _ref.commit;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref2, _ref3, err, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit("WorkLog/setIsLoading", true);

                _context.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_designers_api__["b" /* apiGetWorkLog */])();

              case 3:
                _ref2 = _context.sent;
                _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                err = _ref3[0];
                data = _ref3[1];

                if (!err) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_modules_Error__["a" /* errorMessage */])(err, 'Unabled to load work log!'));

              case 9:
                return _context.abrupt('return', commit("setWorkLogData", [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(data.items)).sort(byDateDesc)));

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  getters: {
    getWorkLogData: function getWorkLogData(state) {
      return state.workLogData;
    },
    getCurrentPeriodAmount: function getCurrentPeriodAmount(state) {
      return state.workLogData[0].amount;
    },
    getCurrentPeriodStartDate: function getCurrentPeriodStartDate(state) {
      return state.workLogData[0].fromTs;
    },
    getIsWorkLogDataLoading: function getIsWorkLogDataLoading(state) {
      return state.isLoading;
    },
    getAmountSum: function getAmountSum(state) {
      return state.workLogData.reduce(function (acc, amount) {
        var sum = acc + amount;
        return sum;
      }, 0);
    }
  }
};

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_toast__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_common_Modal__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_common_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_common_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_common_Loader__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_LocalStorage__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_modules_mixins_CheckUserRole__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_user_api__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_modules_Error__ = __webpack_require__(7);




//
//
//
//
//
//
//
//
//
//
//
//
//
//











var bus = new __WEBPACK_IMPORTED_MODULE_4_vue__["default"]({});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',

  mixins: [__WEBPACK_IMPORTED_MODULE_10_modules_mixins_CheckUserRole__["a" /* default */]],

  data: function data() {
    return {
      bus: bus,
      token: null
    };
  },


  components: {
    'vue-toast': __WEBPACK_IMPORTED_MODULE_5_vue_toast___default.a,
    'app-modal': __WEBPACK_IMPORTED_MODULE_7_components_common_Modal___default.a,
    'app-loader': __WEBPACK_IMPORTED_MODULE_8_components_common_Loader___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])({
    user: 'getUser'
  }), {
    isDesigner: function isDesigner() {
      return this.checkUserRole(this.user.role, ['designer']);
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(['updateUser', 'initMessages']), {
    /*
     * Init
     * It's initiated on lifecycle hook created() - when app is created
     * */
    init: function init() {
      this.addInterceptor();
      this.bindEvents();

      this.getAuthToken();
    },


    /*
     * Bind Events
     * Global state functions or events
     * */
    bindEvents: function bindEvents() {
      var _this = this;

      this.$bus.$on('modalShow', function (component) {
        _this.$refs.modal.onShow(component);
      });

      this.$bus.$on('modalClose', function () {
        _this.$refs.modal.onClose();
      });

      this.$bus.$on('loaderShow', function () {
        _this.$refs.loader.onShow();
      });

      this.$bus.$on('loaderClose', function () {
        _this.$refs.loader.onClose();
      });

      this.$bus.$on('toast', function (msg) {
        _this.$refs.toast.showToast(msg, {
          theme: 'info',
          timeLife: 4000,
          closeBtn: false
        });
      });

      this.$bus.$on('toastSuccess', function (msg) {
        _this.$refs.toast.showToast('<i class="checkmark icon"></i> ' + msg, {
          theme: 'success',
          timeLife: 4000,
          closeBtn: false
        });
      });

      this.$bus.$on('toastError', function (msg) {
        _this.$refs.toast.showToast('<i class="remove icon"></i> ' + msg, {
          theme: 'error',
          timeLife: 4000,
          closeBtn: false
        });
      });

      this.$bus.$on('checkPageAccess', function () {
        _this.checkPageAccess();
      });

      this.$bus.$on('checkAccessAndLogin', function () {
        _this.checkAccessAndLogin();
      });

      this.$bus.$on('setAuthToken', function (token) {
        _this.setAuthToken(token);
      });

      this.$bus.$on('logout', function () {
        _this.onLogout();
      });

      this.$bus.$on('bodyOverflow', function () {
        _this.toggleBodyOverflow();
      });

      this.$bus.$on('textareaAutoresize', function (event) {
        _this.textareaAutoresize(event);
      });

      this.$bus.$on('enterShiftNewline', function (event) {
        _this.enterShiftNewline(event);
      });
    },


    /*
     * Interceptor of HTTP requests
     * */
    addInterceptor: function addInterceptor() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].http.interceptors.push(function (request, next) {
        var isRegGetDribbbleShots = request.url.includes('https://api.dribbble.com');

        if (_this2.token && !isRegGetDribbbleShots) {
          request.headers.set('Auth-Token', _this2.token);
        }

        next(function (res) {
          /*
           * Response status 401 - Not authorized
           * Logout user if he runs in the response with status 401 as he has authorization
           * */
          if (res.status === 401) {
            _this2.onLogout();
          }

          if (res.status === 412 || res.status === 500) {
            _this2.$bus.$emit('loaderClose');
          }
        });
      });
    },


    /*
     * Get Authorization token from local storage
     * */
    getAuthToken: function getAuthToken() {
      var token = __WEBPACK_IMPORTED_MODULE_9_modules_LocalStorage__["a" /* default */].get('token');

      if (token) {
        this.setAuthToken(token);
      }
    },


    /*
     * Set Authorization token
     * @param {string} token A param with session auth token which is always needed for user
     * to be logged in and be able to obtain data
     * */
    setAuthToken: function setAuthToken(token) {
      this.token = token;
      __WEBPACK_IMPORTED_MODULE_9_modules_LocalStorage__["a" /* default */].set('token', token);
      this.getUserInfo();
    },


    /*
     * Get Current user data
     * Save it to shared storage so other components are able to get and watch user data as well
     * */
    getUserInfo: function getUserInfo() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, _ref2, err, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__api_user_api__["h" /* apiGetUserInfo */])();

              case 2:
                _ref = _context.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);
                err = _ref2[0];
                data = _ref2[1];

                if (!err) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_modules_Error__["a" /* errorMessage */])(err, 'Unable to access user info'));

              case 8:

                _this3.updateUser(data);
                if (!_this3.$route.path.includes('/project/')) {
                  _this3.initMessages();
                }
                if (_this3.isDesigner) {
                  _this3.$store.dispatch('getWorkLog');
                }

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },


    /*
     * Check Page Access
     * If user has access(token) and is on auth route, redirect user to main route
     * */
    checkPageAccess: function checkPageAccess() {
      var token = __WEBPACK_IMPORTED_MODULE_9_modules_LocalStorage__["a" /* default */].get('token');

      if (token && this.$route.meta.checkAuth === true) {
        this.checkAccessAndLogin();
      }
    },
    checkAccessAndLogin: function checkAccessAndLogin() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref3, _ref4, err, user;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__api_user_api__["h" /* apiGetUserInfo */])();

              case 2:
                _ref3 = _context2.sent;
                _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);
                err = _ref4[0];
                user = _ref4[1];

                if (!err) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_modules_Error__["a" /* errorMessage */])(err, 'Unable to access user info'));

              case 8:

                _this4.updateUser(user);

                if (!(user.role === 'designer')) {
                  _context2.next = 11;
                  break;
                }

                return _context2.abrupt('return', _this4.$router.push({ name: 'schedule' }));

              case 11:
                return _context2.abrupt('return', ['admin', 'projectManager'].includes(user.role) ? _this4.$router.push({ name: 'tasks' }) : _this4.$router.push({ name: 'projects' }));

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },


    /*
     * Logout
     * Removes the auth token from local storage, redirects to main app route and refresh the page
     * to reset all states within the app
     * */
    onLogout: function onLogout() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref5, _ref6, err;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__api_user_api__["n" /* apiLogout */])();

              case 2:
                _ref5 = _context3.sent;
                _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref5, 1);
                err = _ref6[0];

                if (!err) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_modules_Error__["a" /* errorMessage */])(err, 'Unable to logout'));

              case 7:

                __WEBPACK_IMPORTED_MODULE_9_modules_LocalStorage__["a" /* default */].remove('token');
                _this5.$cookie.delete('PersistentCookie');
                window.top.location.href = '/';
                return _context3.abrupt('return', window.location.reload());

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },


    /*
     * Body Overflow
     * Toggles body css property overflow: 'hidden' so page cannot be scrolled
     * */
    toggleBodyOverflow: function toggleBodyOverflow() {
      document.body.classList.toggle('overflow');
    },


    /*
     * Textarea Autoresize
     * Autorizes textarea based on content inside
     * */
    textareaAutoresize: function textareaAutoresize(event) {
      var el = event.target;

      if (el.value) {
        el.style.height = '0px';
        el.style.height = el.scrollHeight + 'px';
      } else {
        el.style.height = '';
      }
    },


    /*
     * Enter + Shit is new line
     * Prevent actions with only enter, if shift pressed as well, go to new line
     * */
    enterShiftNewline: function enterShiftNewline(event) {
      if (event.keyCode === 13 && !event.shiftKey) {
        event.preventDefault();
      }
    }
  }),

  /*
   * Lifecycle Hooks
   * */
  /* Created */
  created: function created() {
    this.init();
  }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Datepicker',
  props: {
    taskDeadline: {
      type: Number
    },
    useInSeconds: {
      type: Boolean,
      default: false
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["mixin"]],
  data: function data() {
    return {
      date: '',
      activeDate: '201901',
      activeDay: '',
      showDatepicker: false,
      days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      months: {
        '01': 'January',
        '02': 'February',
        '03': 'March',
        '04': 'April',
        '05': 'May',
        '06': 'June',
        '07': 'July',
        '08': 'August',
        '09': 'September',
        '10': 'October',
        '11': 'November',
        '12': 'December'
      },
      calendarDays: [],
      swipeLeft: false,
      swipeRight: false
    };
  },

  filters: {
    trimThreeChar: function trimThreeChar(item) {
      return item.substr(0, 3);
    }
  },
  computed: {
    monthYearFormatted: function monthYearFormatted() {
      return this.months[this.activeDate.substr(4, 2)] + ' ' + this.activeDate.substr(0, 4);
    }
  },
  methods: {
    onToggle: function onToggle() {
      this.showDatepicker = !this.showDatepicker;
    },
    onClose: function onClose() {
      this.showDatepicker = false;
    },
    getCurrentDate: function getCurrentDate() {
      return new Date().toJSON().slice(0, 10).replace(/-/g, '/');
    },
    getCurrentDay: function getCurrentDay() {
      return new Date().getDate();
    },
    getCurrentMonth: function getCurrentMonth() {
      return ("0" + (new Date().getMonth() + 1)).slice(-2);
    },
    getPreviousMonth: function getPreviousMonth(month) {
      if (parseInt(month) == 1) {
        return '12';
      } else {
        return ("0" + (parseInt(month) - 1)).slice(-2);
      }
    },
    getNextMonth: function getNextMonth(month) {
      if (parseInt(month) == 12) {
        return '01';
      } else {
        return ("0" + (parseInt(month) + 1)).slice(-2);
      }
    },
    getCurrentYear: function getCurrentYear() {
      return new Date().getFullYear();
    },
    getNumberOfDaysInMonth: function getNumberOfDaysInMonth(year, month) {
      return new Date(year, month, 0).getDate();
    },
    getNumberOfDaysInPreviousMonth: function getNumberOfDaysInPreviousMonth(year, month) {
      if (month == '01') {
        return new Date(year - 1, this.getPreviousMonth(month), 0).getDate();
      } else {
        return new Date(year, this.getPreviousMonth(month), 0).getDate();
      }
    },
    getNumberOfDaysInNextMonth: function getNumberOfDaysInNextMonth() {
      if (this.getNextMonth() == '12') {
        return new Date(this.getCurrentYear() + 1, this.getNextMonth(), 0).getDate();
      } else {
        return new Date(this.getCurrentYear(), this.getNextMonth(), 0).getDate();
      }
    },
    getFirstDayOfMonth: function getFirstDayOfMonth(year, month) {
      if (new Date(year, parseInt(month) - 1, 1).getDay() - 1 == -1) {
        return 6;
      } else {
        return new Date(year, parseInt(month) - 1, 1).getDay() - 1;
      }
    },
    getLastDayOfMonth: function getLastDayOfMonth(year, month) {
      return new Date(year, parseInt(month) + 1, 0).getDay();
    },
    populateCalendar: function populateCalendar(year, month) {
      this.calendarDays = [];
      var firstDayOfMonth = this.getFirstDayOfMonth(year, month);
      var numberOfRows = Math.ceil(this.getNumberOfDaysInMonth(year, month) / 7);
      var dayNumber = 1;
      var increment = 1;
      for (var x = 0; x <= numberOfRows; x++) {
        var decrement = 0;
        var row = [];

        if (x == 0) {
          for (var i = 0; i < firstDayOfMonth; i++) {
            if (parseInt(month) == 1) {
              row.push({
                day: this.getNumberOfDaysInPreviousMonth(year, month) - decrement,
                month: this.getPreviousMonth(month),
                year: parseInt(year) - 1
              });
            } else {
              row.push({
                day: this.getNumberOfDaysInPreviousMonth(year, month) - decrement,
                month: this.getPreviousMonth(month),
                year: parseInt(year)
              });
            }
            decrement++;
          }
          row.reverse();
        }
        for (var y = row.length; y < 7 && y < this.getNumberOfDaysInMonth(year, month); y++) {
          if (dayNumber <= this.getNumberOfDaysInMonth(year, month)) {
            row.push({ day: dayNumber, month: month, year: year });
            dayNumber++;
          } else {
            for (var j = row.length; j < 7; j++) {
              if (parseInt(month) == 12) {
                row.push({
                  day: increment,
                  month: this.getNextMonth(month),
                  year: parseInt(year) + 1
                });
              } else {
                row.push({
                  day: increment,
                  month: this.getNextMonth(month),
                  year: year
                });
              }
              increment++;
            }
          }
        }
        this.calendarDays.push(row);
      }
    },
    setPreviousMonth: function setPreviousMonth() {
      var activeYear = this.activeDate.substr(0, 4);
      var activeMonth = this.activeDate.substr(4, 2);
      if (parseInt(activeMonth) == 1) {
        activeYear = parseInt(activeYear) - 1;
        activeMonth = '12';
      } else {
        activeMonth = ('0' + (parseInt(activeMonth) - 1)).slice(-2);
      }
      this.activeDate = activeYear + activeMonth;
      this.populateCalendar(activeYear, activeMonth);
      this.animeSwipeRight();
    },
    setNextMonth: function setNextMonth() {
      var activeYear = this.activeDate.substr(0, 4);
      var activeMonth = this.activeDate.substr(4, 2);
      if (parseInt(activeMonth) == 12) {
        activeYear = parseInt(activeYear) + 1;
        activeMonth = '01';
      } else {
        activeMonth = ('0' + (parseInt(activeMonth) + 1)).slice(-2);
      }
      this.activeDate = activeYear + activeMonth;
      this.populateCalendar(activeYear, activeMonth);
      this.animeSwipeLeft();
    },
    selectDay: function selectDay(cell) {
      if (cell.month == this.getPreviousMonth(this.activeDate.substr(4, 2))) {
        this.setPreviousMonth();
      } else if (cell.month == this.getNextMonth(this.activeDate.substr(4, 2))) {
        this.setNextMonth();
      }
      this.activeDay = ("0" + cell.day).slice(-2) + cell.month + cell.year;
      this.date = ("0" + cell.day).slice(-2) + '/' + cell.month + '/' + cell.year;
      this.showDatepicker = false;
      var day = ("0" + cell.day).slice(-2);
      var deadline = this.useInSeconds ? this.$moment(cell.year + '-' + cell.month + '-' + day + ' 23:59:59.000').utc().unix() : this.$moment(cell.year + '-' + cell.month + '-' + day + ' 23:59:59.000').utc().unix() * 1000;
      this.$emit("updateDeadline", deadline);
    },
    isSelected: function isSelected(cell) {
      if (("0" + cell.day).slice(-2) + cell.month + cell.year == this.activeDay) {
        return true;
      }
    },
    isDisabled: function isDisabled(cell) {
      if (parseInt(cell.month) !== parseInt(this.activeDate.substr(4, 2))) {
        return true;
      }
    },
    animeSwipeLeft: function animeSwipeLeft() {
      var _this = this;

      this.swipeLeft = true;
      setTimeout(function () {
        _this.swipeLeft = false;
      }, 300);
    },
    animeSwipeRight: function animeSwipeRight() {
      var _this2 = this;

      this.swipeRight = true;
      setTimeout(function () {
        _this2.swipeRight = false;
      }, 300);
    }
  },
  created: function created() {
    this.populateCalendar(this.getCurrentYear(), this.getCurrentMonth());
    this.activeDate = this.getCurrentYear() + this.getCurrentMonth();
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_pages_project_task_Eta__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_pages_project_task_Eta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_pages_project_task_Eta__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dropdown',

  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["mixin"]],

  data: function data() {
    return {
      collapsed: false
    };
  },


  components: {
    'eta-progress': __WEBPACK_IMPORTED_MODULE_1_components_pages_project_task_Eta___default.a
  },

  props: {
    dropdownList: {
      type: Array
    },
    buttonIcon: {
      type: Boolean,
      required: false,
      default: true
    },
    buttonIconSize: {
      type: String,
      required: false,
      default: ''
    },
    buttonIconName: {
      type: String,
      required: false,
      default: ''
    },
    buttonIconColor: {
      type: String,
      required: false,
      default: ''
    },
    buttonIconLeft: {
      type: Boolean,
      required: false,
      default: false
    },
    buttonText: {
      type: String,
      required: false,
      default: ''
    },
    buttonEtaShow: {
      type: Boolean,
      required: false,
      default: false
    },
    buttonTextEta: {
      type: Number,
      required: false,
      default: 0
    },
    buttonPercentageEta: {
      type: Number,
      required: false,
      default: 0
    },
    selectable: {
      type: Boolean,
      required: false,
      default: true
    },
    contentList: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  methods: {
    bindEvents: function bindEvents() {
      var _this = this;

      this.$bus.$on('closeEtaSlider', function () {
        _this.collapsed = false;
      });
    },
    unbindEvents: function unbindEvents() {
      this.$bus.$off('closeEtaSlider');
    },
    onToggle: function onToggle() {
      this.collapsed = !this.collapsed;
    },
    onClose: function onClose() {
      this.collapsed = false;
    }
  },

  created: function created() {
    this.bindEvents();
  },
  beforeDestroy: function beforeDestroy() {
    this.unbindEvents();
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dropdown',

  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["mixin"]],

  data: function data() {
    return {
      collapsed: false
    };
  },


  props: {
    btnClass: {
      type: String,
      required: false,
      default: ''
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    onToggle: function onToggle() {
      return this.disabled ? true : this.collapsed = !this.collapsed;
    },
    onClose: function onClose() {
      this.collapsed = false;
    }
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_mixins_CheckUserRole__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_clickaway__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_clickaway__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_common_DropdownSimple__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_common_DropdownSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_common_DropdownSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_common_Tooltip__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_common_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_common_Tooltip__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-header',

  mixins: [__WEBPACK_IMPORTED_MODULE_1_modules_mixins_CheckUserRole__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4_vue_clickaway__["mixin"]],

  components: {
    'dropdown-simple': __WEBPACK_IMPORTED_MODULE_5_components_common_DropdownSimple___default.a,
    Tooltip: __WEBPACK_IMPORTED_MODULE_6_components_common_Tooltip___default.a
  },

  data: function data() {
    return {
      open: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    user: 'getUser',
    isWorkLogDataLoading: 'getIsWorkLogDataLoading',
    workLogData: 'getWorkLogData',
    currentPeriodAmount: 'getCurrentPeriodAmount',
    currentPeriodStartDate: 'getCurrentPeriodStartDate',
    amountSum: 'getAmountSum',
    messagesCount: 'getMessagesCount'
  }), {
    linkToMainPage: function linkToMainPage() {
      return this.checkUserRole(this.user.role, ['admin', 'projectManager', 'designer']) ? 'tasks' : 'projects';
    }
  }),

  methods: {
    onLogout: function onLogout() {
      this.$bus.$emit('logout');
    },
    toggleMenu: function toggleMenu() {
      this.open = !this.open;
    }
  },

  filters: {
    shortDate: function shortDate(val) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default.a.utc(val).format('D. MMM');
    },
    shortMonth: function shortMonth(val) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default.a.utc(val).format('MMM');
    }
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loader',

  data: function data() {
    return {
      showLoader: false
    };
  },


  methods: {
    onShow: function onShow() {
      this.showLoader = true;
    },
    onClose: function onClose() {
      this.showLoader = false;
    }
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_pages_project_task_modals_TaskAssigneeDesignerModal__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_pages_project_task_modals_TaskAssigneeDesignerModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_pages_project_task_modals_TaskAssigneeDesignerModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_pages_projects_modals_ProjectRemoveModal__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_pages_projects_modals_ProjectRemoveModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_pages_projects_modals_ProjectRemoveModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_pages_projects_modals_ProjectCreateModal__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_pages_projects_modals_ProjectCreateModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_pages_projects_modals_ProjectCreateModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_pages_projects_modals_ProjectArchiveModal__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_pages_projects_modals_ProjectArchiveModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_pages_projects_modals_ProjectArchiveModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_pages_project_modals_RemoveUserModal__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_pages_project_modals_RemoveUserModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_pages_project_modals_RemoveUserModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_pages_project_modals_ProjectSettingsModal__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_pages_project_modals_ProjectSettingsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_pages_project_modals_ProjectSettingsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_pages_project_modals_ProjectTopUpModal__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_pages_project_modals_ProjectTopUpModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_pages_project_modals_ProjectTopUpModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_pages_project_modals_ProjectTeamModal__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_pages_project_modals_ProjectTeamModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_pages_project_modals_ProjectTeamModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_pages_project_modals_DownloadZipModal__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_pages_project_modals_DownloadZipModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_pages_project_modals_DownloadZipModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_pages_project_modals_ClientCharacterNotes__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_pages_project_modals_ClientCharacterNotes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_pages_project_modals_ClientCharacterNotes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_pages_project_modals_RemoveTaskModal__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_pages_project_modals_RemoveTaskModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_pages_project_modals_RemoveTaskModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_pages_project_modals_RemoveDesignerFilesModal__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_pages_project_modals_RemoveDesignerFilesModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_pages_project_modals_RemoveDesignerFilesModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_pages_project_modals_RemoveDescriptionFilesModal__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_pages_project_modals_RemoveDescriptionFilesModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_pages_project_modals_RemoveDescriptionFilesModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_pages_project_task_modals_UploadDesignerFilesModal__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_pages_project_task_modals_UploadDesignerFilesModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_components_pages_project_task_modals_UploadDesignerFilesModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_pages_project_task_modals_UpdateStatusModal__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_pages_project_task_modals_UpdateStatusModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_components_pages_project_task_modals_UpdateStatusModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_pages_user_modals_RemoveAllUserInformation__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_pages_user_modals_RemoveAllUserInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_components_pages_user_modals_RemoveAllUserInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_pages_users_modals_AddUserModal__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_pages_users_modals_AddUserModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_components_pages_users_modals_AddUserModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_pages_users_modals_UpdateUserModal__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_pages_users_modals_UpdateUserModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_components_pages_users_modals_UpdateUserModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_pages_users_modals_RemoveUserModal__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_pages_users_modals_RemoveUserModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_components_pages_users_modals_RemoveUserModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_pages_users_modals_PaymentUserModal__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_pages_users_modals_PaymentUserModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_components_pages_users_modals_PaymentUserModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_common_gallery_GalleryRemoveCommentModal__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_common_gallery_GalleryRemoveCommentModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_components_common_gallery_GalleryRemoveCommentModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_common_modals_UserInfoModal__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_common_modals_UserInfoModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_components_common_modals_UserInfoModal__);

//
//
//
//
//
//
//
//
//
//
//

/*
 Dashboard
 */


/*
 Projects
 */




/*
 Project
 */







/* Task */






/*
 User
 */


/*
 Users
 */





/*
 Gallery
 */


/*
 Common Modals
 */


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal',

  data: function data() {
    return {
      showModal: false,
      currentModal: null,
      args: null
    };
  },


  components: {
    /*
     * Dashboard
     * */
    'project-remove-modal': __WEBPACK_IMPORTED_MODULE_2_components_pages_projects_modals_ProjectRemoveModal___default.a,
    'project-archive-modal': __WEBPACK_IMPORTED_MODULE_4_components_pages_projects_modals_ProjectArchiveModal___default.a,

    /*
     * DashboardNew
     * */
    'task-assignee-designer-modal': __WEBPACK_IMPORTED_MODULE_1_components_pages_project_task_modals_TaskAssigneeDesignerModal___default.a,

    /*
     * Project
     * */
    'project-remove-user-modal': __WEBPACK_IMPORTED_MODULE_5_components_pages_project_modals_RemoveUserModal___default.a,
    'project-settings-modal': __WEBPACK_IMPORTED_MODULE_6_components_pages_project_modals_ProjectSettingsModal___default.a,
    'project-top-up-modal': __WEBPACK_IMPORTED_MODULE_7_components_pages_project_modals_ProjectTopUpModal___default.a,
    'project-team-modal': __WEBPACK_IMPORTED_MODULE_8_components_pages_project_modals_ProjectTeamModal___default.a,
    'project-create-modal': __WEBPACK_IMPORTED_MODULE_3_components_pages_projects_modals_ProjectCreateModal___default.a,
    'download-zip-modal': __WEBPACK_IMPORTED_MODULE_9_components_pages_project_modals_DownloadZipModal___default.a,
    'clients-character-notes': __WEBPACK_IMPORTED_MODULE_10_components_pages_project_modals_ClientCharacterNotes___default.a,

    /* Project Task */
    'project-remove-task-modal': __WEBPACK_IMPORTED_MODULE_11_components_pages_project_modals_RemoveTaskModal___default.a,
    'project-remove-task-designer-files-modal': __WEBPACK_IMPORTED_MODULE_12_components_pages_project_modals_RemoveDesignerFilesModal___default.a,
    'project-remove-task-description-files-modal': __WEBPACK_IMPORTED_MODULE_13_components_pages_project_modals_RemoveDescriptionFilesModal___default.a,
    'task-upload-designer-files-modal': __WEBPACK_IMPORTED_MODULE_14_components_pages_project_task_modals_UploadDesignerFilesModal___default.a,
    'task-update-status-modal': __WEBPACK_IMPORTED_MODULE_15_components_pages_project_task_modals_UpdateStatusModal___default.a,

    /*
     * User
     * */
    'add-user-modal': __WEBPACK_IMPORTED_MODULE_17_components_pages_users_modals_AddUserModal___default.a,
    'update-user-modal': __WEBPACK_IMPORTED_MODULE_18_components_pages_users_modals_UpdateUserModal___default.a,
    'remove-user-modal': __WEBPACK_IMPORTED_MODULE_19_components_pages_users_modals_RemoveUserModal___default.a,
    'payment-user-modal': __WEBPACK_IMPORTED_MODULE_20_components_pages_users_modals_PaymentUserModal___default.a,

    /*
     * User
     *  Settings */
    'remove-all-user-information': __WEBPACK_IMPORTED_MODULE_16_components_pages_user_modals_RemoveAllUserInformation___default.a,

    /*
     * Common
     * */
    /* Gallery */
    'gallery-remove-comment-modal': __WEBPACK_IMPORTED_MODULE_21_components_common_gallery_GalleryRemoveCommentModal___default.a,

    /* Common */
    'user-info-modal': __WEBPACK_IMPORTED_MODULE_22_components_common_modals_UserInfoModal___default.a
  },

  methods: {
    onModalClose: function onModalClose(event) {
      return event.keyCode === 27 ? this.onClose() : false;
    },


    /*
     * On Show
     * @param {string} component A name of the modal component which you want to show
     * @param {object} args An object with arguments passed from injected modal components to main modal component,
     * can be a simple property or something else as an object as well
     * */
    onShow: function onShow(_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          component = _ref2[0],
          args = _ref2[1];

      this.showModal = true;
      this.currentModal = component;
      this.args = args;

      /* Emit body overflow to prevent scroll */
      this.$bus.$emit('bodyOverflow');
    },


    /*
     * On Close
     * */
    onClose: function onClose() {
      /* If modal is showed, emit body overflow to allow user to scroll again */
      if (this.showModal) {
        this.$bus.$emit('bodyOverflow');
      }
      this.showModal = false;
    }
  },

  created: function created() {
    window.addEventListener('keyup', this.onModalClose);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('keyup', this.onModalClose);
  }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__popperjs_core__ = __webpack_require__(265);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tooltip',

  data: function data() {
    return {
      isOpen: false,
      popper: null,
      isTouchOnly: false,
      closeTimeoutId: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.resizeHandler();
    window.addEventListener('resize', this.resizeHandler);
    // Init the popper after the DOM was updated so we get the correct refs 
    this.$nextTick().then(function () {
      return _this.initPopper();
    });
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.resizeHandler);
  },


  computed: {
    getTouchEventHandlers: function getTouchEventHandlers() {
      if (this.isOpen) {
        return { click: this.clickHandler };
      } else {
        return { click: this.clickHandler };
      }
    }
  },

  methods: {
    open: function open() {
      clearTimeout(this.closeTimeoutId);
      this.isOpen = true;
    },
    handleMouseLeave: function handleMouseLeave() {
      this.closeTimeoutId = setTimeout(this.close, 150);
    },
    close: function close() {
      this.isOpen = false;
    },
    initPopper: function initPopper() {
      if (!this.$refs.reference || !this.$refs.popper) return;

      this.popper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__popperjs_core__["a" /* createPopper */])(this.$refs.reference, this.$refs.popper, {
        placement: 'bottom-end',
        modifiers: [{
          name: 'preventOverflow',
          options: {
            padding: 15 // Needs to be the same value as `$gutter-container`
          }
        }, {
          name: 'offset',
          options: {
            offset: [0, 10] // 10px vertical offset
          }
        }]
      });
    },
    resizeHandler: function resizeHandler() {
      this.isTouchOnly = window.matchMedia("(any-hover: none)").matches;
    },
    clickHandler: function clickHandler(e) {
      // For instances where tooltip is wrapped in an <a>
      e.preventDefault();
      if (this.isOpen) this.close();else this.open();
    }
  }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_common_Loader__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_common_Loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({

  props: ['args'],

  data: function data() {
    return {};
  },


  components: {
    'app-loader': __WEBPACK_IMPORTED_MODULE_0_components_common_Loader___default.a
  },

  methods: {
    onConfirm: function onConfirm() {
      this.onLoaderShow();
      this.$bus.$emit('removeComment', this.args.currentFile.uuid, this.args.comment, this.args.commentReply);
    },
    onLoaderShow: function onLoaderShow() {
      this.$refs.loader.onShow();
    },
    onLoaderClose: function onLoaderClose() {
      this.$refs.loader.onClose();
    }
  }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_mixins_CheckUserRole__ = __webpack_require__(38);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserInfoModal',

  props: {
    args: {
      type: Object,
      required: true
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0_modules_mixins_CheckUserRole__["a" /* default */]]
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_Error__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_project_api__ = __webpack_require__(15);




//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      clientCharacterNotes: ""
    };
  },


  props: ['args'],

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['updateProjectProperties']), {
    init: function init() {
      this.clientCharacterNotes = this.args.project.clientCharacterNotes ? this.args.project.clientCharacterNotes : "";
    },
    editNotes: function editNotes() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var note, _ref, _ref2, err, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                note = {
                  projectId: _this.args.project.id,
                  clientCharacterNotes: _this.clientCharacterNotes
                };


                _this.$bus.$emit('loaderShow');

                _context.next = 4;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_project_api__["m" /* apiProjectUpdateClientCharacterNotes */])(note);

              case 4:
                _ref = _context.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);
                err = _ref2[0];
                data = _ref2[1];

                _this.$bus.$emit('loaderClose');

                if (!err) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__modules_Error__["a" /* errorMessage */])(err, 'Unable to edit client character notes in this project. Try again later!'));

              case 11:

                _this.updateProjectProperties({ clientCharacterNotes: data.clientCharacterNotes });
                return _context.abrupt('return', _this.$bus.$emit('toastSuccess', 'Notes sucessfully updated!'));

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }),

  created: function created() {
    this.init();
  }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Error__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_project_api__ = __webpack_require__(15);



//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      content: 'Your zip is getting ready',
      linkDisabled: true,
      link: ''
    };
  },
  created: function created() {},


  props: {
    args: {
      projectId: null,
      taskId: null
    }
  },

  mounted: function mounted() {
    this.pingJob();
  },


  methods: {
    pingJob: function pingJob() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _args, projectId, taskId, _ref, _ref2, err, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _args = _this.args, projectId = _args.projectId, taskId = _args.taskId;
                _context.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_project_api__["l" /* apiPingJob */])(projectId, taskId);

              case 3:
                _ref = _context.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);
                err = _ref2[0];
                data = _ref2[1];

                if (!err) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_Error__["a" /* errorMessage */])(err, 'Failed to ping Koncepted'));

              case 9:
                if (!(data.success && data.zipCreated)) {
                  _context.next = 14;
                  break;
                }

                _this.content = 'Your zip is ready';
                _this.linkDisabled = false;
                _this.link = '/serve/s/' + data.linkToZip;
                return _context.abrupt('return', _this.$bus.$emit('downloadZipLink', taskId, data.linkToZip));

              case 14:
                if (!(data.success && !data.designerFilesUploaded)) {
                  _context.next = 17;
                  break;
                }

                _this.$bus.$emit('modalClose');
                return _context.abrupt('return', _this.$bus.$emit('toastError', 'No designer files on task'));

              case 17:
                return _context.abrupt('return', setTimeout(_this.pingJob.bind(_this), 1000));

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_project_api__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_Error__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_common_DatePicker__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_common_DatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_common_DatePicker__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'datepicker': __WEBPACK_IMPORTED_MODULE_7_components_common_DatePicker___default.a
  },
  data: function data() {
    return {
      projectSettings: {
        id: null,
        name: null,
        customerEmail: null,
        dropboxShareLinkToFolder: null
      },
      planList: {
        selected: 'none',
        options: [{
          name: 'None',
          value: 'none'
        }, {
          name: 'Pro',
          value: 'PRO_MONTHLY'
        }, {
          name: 'Pro Annual',
          value: 'PRO_YEARLY'
        }, {
          name: 'Pro Legacy',
          value: 'PRO_PLUS'
        }, {
          name: 'Premium',
          value: 'PREMIUM_MONTHLY'
        }, {
          name: 'Premium Annual',
          value: 'PREMIUM_YEARLY'
        }, {
          name: 'Premium Legacy',
          value: 'PREMIUM'
        }, {
          name: 'Diamond',
          value: 'DIAMOND_MONTHLY'
        }, {
          name: 'Diamond Annual',
          value: 'DIAMOND_YEARLY'
        }]
      },
      projectDeadline: null
    };
  },


  props: ['args'],

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
    projectUsers: 'getPotentialProjectOwners'
  }), {
    showSubscriptionPlan: function showSubscriptionPlan() {
      var isAdminPm = this.args.loggedInUserProjectRole === 'admin' || this.args.loggedInUserProjectRole === 'projectManager';
      return isAdminPm && !this.args.activeStripeSubscription;
    },
    disabledChangePlan: function disabledChangePlan() {
      var customerPaymentPlanCurrentPeriodEnd = this.args.customerPaymentPlanCurrentPeriodEnd;

      return customerPaymentPlanCurrentPeriodEnd && customerPaymentPlanCurrentPeriodEnd * 1000 < new Date().getTime();
    },
    disabledUpdatePlan: function disabledUpdatePlan() {
      return this.planList.selected === 'none' || this.planList.selected === this.args.customerPaymentPlan || this.projectDeadline === this.args.customerPaymentPlanCurrentPeriodEnd;
    }
  }),

  created: function created() {
    this.projectSettings = {
      id: this.args.id,
      name: this.args.name,
      customerEmail: this.args.customerEmail,
      dropboxShareLinkToFolder: this.args.dropboxShareLinkToFolder
    };
    if (this.args.customerPaymentPlan) {
      this.planList.selected = this.args.customerPaymentPlan;
    }
    this.setProjectDeadline();
  },


  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['updateProjectProperties']), {
    setProjectDeadline: function setProjectDeadline() {
      var currentDay = Math.round(Date.now() / 1000);
      this.projectDeadline = this.args.customerPaymentPlanCurrentPeriodEnd ? this.args.customerPaymentPlanCurrentPeriodEnd : currentDay;
      // TEMP disabled
      // const monthPlusDay = 86400 + 2629743
      // const yearPlusDay = 86400 + 31556926
      // const isYearlyPlan = ['PRO_YEARLY', 'PREMIUM_YEARLY', 'DIAMOND_YEARLY'].includes(this.planList.selected)
      // isYearlyPlan 
      //   ? (this.projectDeadline = currentPeriodEnd + yearPlusDay)
      //   : (this.projectDeadline = currentPeriodEnd + monthPlusDay) 
      // TEMP disabled
      return this.projectDeadline;
    },
    onUpdateProperties: function onUpdateProperties() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, _ref2, err;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__api_project_api__["j" /* apiUpdateProject */])(_this.projectSettings);

              case 2:
                _ref = _context.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 1);
                err = _ref2[0];

                if (!err) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_modules_Error__["a" /* errorMessage */])(err, 'Unable to update project settings!'));

              case 7:

                _this.updateProjectProperties(_this.projectSettings);
                _this.$bus.$emit('modalClose');
                return _context.abrupt('return', _this.$bus.$emit('toastSuccess', 'Project sucessfully updated!'));

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    updatePlan: function updatePlan() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref3, _ref4, err;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__api_project_api__["k" /* apiManualSetupPaymentPlan */])(_this2.args.id, _this2.planList.selected, _this2.projectDeadline);

              case 2:
                _ref3 = _context2.sent;
                _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 1);
                err = _ref4[0];

                if (!err) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_modules_Error__["a" /* errorMessage */])(err, 'Unable to update plan!'));

              case 7:
                _this2.updateProjectProperties({
                  id: _this2.args.id,
                  customerPaymentPlan: _this2.planList.selected,
                  customerPaymentPlanCurrentPeriodEnd: _this2.projectDeadline
                });
                _this2.$bus.$emit('modalClose');
                return _context2.abrupt('return', _this2.$bus.$emit('toastSuccess', 'Project plan sucessfully updated!'));

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    onUpdateDeadline: function onUpdateDeadline(deadline) {
      this.projectDeadline = deadline;
    },
    onDatepickerClose: function onDatepickerClose(e) {
      var isClickOutsideDatepicker = e.target.closest('.datepicker') == null;
      var datepickerEl = this.$refs.projectSettingsDatepicker;
      if (datepickerEl.showDatepicker && isClickOutsideDatepicker) {
        datepickerEl.onClose();
      }
    }
  })
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_mixins_CheckUserRole__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_Error__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_project_api__ = __webpack_require__(15);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4_modules_mixins_CheckUserRole__["a" /* default */]],

  data: function data() {
    return {
      roles: [{
        name: 'Designer',
        value: 'designer',
        canBeSelectedBy: ['admin', 'projectManager']
      }, {
        name: 'Project Manager',
        value: 'projectManager',
        canBeSelectedBy: ['admin', 'projectManager']
      }, {
        name: 'Editor',
        value: 'editor',
        canBeSelectedBy: ['admin', 'projectManager', 'customer', 'editor']
      }, {
        name: 'Viewer',
        value: 'viewer',
        canBeSelectedBy: ['admin', 'projectManager', 'customer', 'editor']
      }],
      userInvite: {
        email: null,
        selectedRole: null
      },
      currentUserRole: null
    };
  },


  props: ['args'],

  computed: {
    userRoles: function userRoles() {
      var _this = this;

      return _.filter(this.roles, function (role) {
        return _.includes(role.canBeSelectedBy, _this.currentUserRole);
      });
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['addUserToProject']), {
    init: function init() {
      if (this.args.role === 'customer') {
        this.userInvite.selectedRole = 'viewer';
      } else {
        this.userInvite.selectedRole = 'designer';
      }

      if (this.args.projectRole === 'editor') {
        this.currentUserRole = this.args.projectRole;
      } else {
        this.currentUserRole = this.args.role;
      }
    },
    onConfirm: function onConfirm() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var projectUser, isValid, _ref, _ref2, err, data, newUser;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.$bus.$emit('loaderShow');
                projectUser = {
                  role: _this2.userInvite.selectedRole,
                  email: _this2.userInvite.email,
                  projectId: _this2.$route.params.id
                };
                _context.next = 4;
                return _this2.$validator.validateAll();

              case 4:
                isValid = _context.sent;

                if (isValid) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt('return', _this2.$bus.$emit('loaderClose'));

              case 7:
                _context.next = 9;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__api_project_api__["i" /* apiProjectUserInvite */])(projectUser);

              case 9:
                _ref = _context.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);
                err = _ref2[0];
                data = _ref2[1];

                _this2.$bus.$emit('loaderClose');

                if (!err) {
                  _context.next = 16;
                  break;
                }

                return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_modules_Error__["a" /* errorMessage */])(err, 'Unable to add user to project. Try again later!'));

              case 16:

                if (data.invitedExistingUser) {
                  newUser = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, data.invitedExistingUser);

                  newUser.userProjectRole = _this2.userInvite.selectedRole;
                  _this2.addUserToProject(newUser);
                }

                _this2.$bus.$emit('modalClose');
                return _context.abrupt('return', _this2.$bus.$emit('toastSuccess', 'User ' + _this2.userInvite.email + ' was successfully invited'));

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    userSurname: function userSurname(surname) {
      return this.checkUserRole(this.args.role, ['admin']) ? surname : surname.slice(0, 1) + ".";
    }
  }),

  created: function created() {
    this.init();
  }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_common_Loader__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_CountryList_json__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_CountryList_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_modules_CountryList_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_projects_api__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_project_api__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_stripe_api__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_modules_Error__ = __webpack_require__(7);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'app-loader': __WEBPACK_IMPORTED_MODULE_5_components_common_Loader___default.a,
    Countries: __WEBPACK_IMPORTED_MODULE_6_modules_CountryList_json___default.a
  },

  props: {
    args: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    }
  },

  data: function data() {
    return {
      // paymentSteps: 0, TODO temp disabled crypto
      paymentSteps: 1,
      userInformation: {
        customerFirstName: null,
        customerLastName: null,
        customerCompanyName: null,
        customerAddress: null,
        customerPost: null,
        customerPostCode: null,
        customerCountry: null,
        customerType: 'COMPANY',
        customerPaymentPlan: null
      },
      customerPaymentPlanPeriod: 'YEARLY', // TODO check this data property name
      clientToken: null,
      stripeManageSubscriptionRedirectUrl: "https://billing.stripe.com/session/_IMfVxZKe2YG47NlbG9NwFdNcFKU3zq3",
      countries: null,
      country: null,
      // paymentFailed: false,
      currentPlan: 'none',
      selectedPlan: 'none',
      planList: [{
        name: 'Diamond',
        description: 'Full-stack enterprise design',
        valueMonth: 'DIAMOND_MONTHLY',
        valueYear: 'DIAMOND_YEARLY',
        icon: 'icon-diamond',
        badges: ['240hrs', 'Performance design', 'Blockchain games', '+18'],
        pricePerMonth: 15995,
        pricePerYear: 13250
      }, {
        name: 'Premium',
        description: 'Self-managed design team',
        valueMonth: 'PREMIUM_MONTHLY',
        valueYear: 'PREMIUM_YEARLY',
        icon: 'icon-cup',
        badges: ['120hrs', 'NFT art', 'Brand design', 'Art direction', '+16'],
        pricePerMonth: 7995,
        pricePerYear: 6650
      }, {
        name: 'Pro',
        description: 'Industry-grade design quality',
        valueMonth: 'PRO_MONTHLY',
        valueYear: 'PRO_YEARLY',
        icon: 'icon-ship',
        badges: ['60hrs', 'Blockchain design', '3d', 'Project managment', '+13'],
        pricePerMonth: 3995,
        pricePerYear: 3350
      }],
      legacyPlans: [{
        name: 'Premium (legacy)',
        value: 'PREMIUM',
        pricePerMonth: 6000
      }, {
        name: 'Pro (legacy)',
        value: 'PRO_PLUS',
        pricePerMonth: 2995
      }, {
        name: 'Essential (legacy)',
        value: 'ESSENTIAL_PLUS',
        pricePerMonth: 1995
      }, {
        name: 'Flexible (legacy)',
        value: 'PAY_AS_YOU_GO',
        pricePerMonth: null,
        pricePerHour: 80
      }]
    };
  },
  created: function created() {
    this.init();
  },


  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])(['updateProjectProperties']), {
    init: function init() {
      var _this = this;

      this.userInformation = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(this.userInformation, this.args);

      this.countries = _.orderBy(__WEBPACK_IMPORTED_MODULE_6_modules_CountryList_json___default.a, 'countryName', 'asc');
      if (this.userInformation.customerCountry) {
        this.country = _.find(this.countries, function (country) {
          return country.countryName === _this.userInformation.customerCountry;
        });
      }
      this.getPaymentClientToken();
      this.setCurrentPlan();
      if (this.userInformation.customerPaymentPlan) {
        this.getStripePlatformRedirect();
      }
    },
    setCurrentPlan: function setCurrentPlan() {
      return this.userInformation.customerPaymentPlan ? this.currentPlan = this.userInformation.customerPaymentPlan : this.currentPlan = 'none';
    },
    onCountrySelect: function onCountrySelect() {
      this.userInformation.customerCountry = this.country.countryName;
    },
    onSelectedPlan: function onSelectedPlan(plan) {
      this.customerPaymentPlanPeriod == 'YEARLY' ? this.selectedPlan = plan.valueYear : this.selectedPlan = plan.valueMonth;

      return this.onPaymentExecute(this.selectedPlan);
    },
    onPaymentInformationUpdate: function onPaymentInformationUpdate() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isValid, param, _ref, _ref2, err, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$validator.validateAll();

              case 2:
                isValid = _context.sent;

                if (isValid) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return', false);

              case 5:
                param = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this2.userInformation);

                param.projectId = _this2.userInformation.id;

                _context.next = 9;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__api_projects_api__["f" /* apiUpdateProjectData */])(param);

              case 9:
                _ref = _context.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);
                err = _ref2[0];
                data = _ref2[1];

                if (!err) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_modules_Error__["a" /* errorMessage */])(err, 'Enable to update user information'));

              case 15:
                _this2.updateProjectProperties(data);

                return _context.abrupt('return', _this2.createStripeCustomer());

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    createStripeCustomer: function createStripeCustomer() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref3, _ref4, err;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.$refs.loader.onShow();

                _context2.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__api_stripe_api__["a" /* apiCreateStripeCustomer */])(_this3.args.id);

              case 3:
                _ref3 = _context2.sent;
                _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 1);
                err = _ref4[0];

                _this3.$refs.loader.onClose();

                if (!err) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_modules_Error__["a" /* errorMessage */])(err, 'Unable to create Stripe Customer. Try again later!'));

              case 9:
                return _context2.abrupt('return', _this3.paymentSteps = 2);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    getPaymentClientToken: function getPaymentClientToken() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref5, _ref6, err, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__api_stripe_api__["b" /* apiGetPaymentClientToken */])(_this4.args.id);

              case 2:
                _ref5 = _context3.sent;
                _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);
                err = _ref6[0];
                data = _ref6[1];

                if (!err) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_modules_Error__["a" /* errorMessage */])(err, 'Unable to get client token. Try again later!'));

              case 8:
                return _context3.abrupt('return', _this4.clientToken = data.token);

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    getStripePlatformRedirect: function getStripePlatformRedirect() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _ref7, _ref8, err, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__api_stripe_api__["c" /* apiGetStripePlatformRedirect */])(_this5.args.id);

              case 2:
                _ref7 = _context4.sent;
                _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref7, 2);
                err = _ref8[0];
                data = _ref8[1];

                if (!err) {
                  _context4.next = 8;
                  break;
                }

                return _context4.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_modules_Error__["a" /* errorMessage */])(err, 'Unable to get client token. Try again later!'));

              case 8:
                return _context4.abrupt('return', _this5.stripeManageSubscriptionRedirectUrl = data.url);

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },


    // TODO add redirectToPlatform to control (button)
    redirectToPlatform: function redirectToPlatform() {
      this.getStripePlatformRedirect();
      window.location = this.stripeManageSubscriptionRedirectUrl;
    },
    onPaymentExecute: function onPaymentExecute(paymentPlan) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var _ref9, _ref10, err, data, stripe;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                // TODO test this 
                _this6.$refs.loader.onShow();
                _context5.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__api_project_api__["h" /* apiPaymentExecute */])(_this6.args.id, paymentPlan);

              case 3:
                _ref9 = _context5.sent;
                _ref10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref9, 2);
                err = _ref10[0];
                data = _ref10[1];

                _this6.$refs.loader.onClose();

                if (!err) {
                  _context5.next = 10;
                  break;
                }

                return _context5.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_modules_Error__["a" /* errorMessage */])(err, 'Unable to create an subscription!'));

              case 10:
                if (data.success) {
                  _context5.next = 12;
                  break;
                }

                return _context5.abrupt('return', _this6.$bus.$emit('toastError', 'Failed to complete payment. Please try again.'));

              case 12:
                if (!data.redirectToStripe) {
                  _context5.next = 15;
                  break;
                }

                stripe = Stripe(_this6.clientToken);
                return _context5.abrupt('return', stripe.redirectToCheckout({
                  // Make the id field from the Checkout Session creation API response
                  // available to this file, so you can provide it as parameter here
                  // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
                  sessionId: data.sessionId
                }).then(function (result) {
                  // If `redirectToCheckout` fails due to a browser or network
                  // error, display the localized error message to your customer
                  // using `result.error.message`.
                }));

              case 15:
                _this6.$bus.$emit('modalClose');
                return _context5.abrupt('return', _this6.$bus.$emit('toastSuccess', 'Your "Flexible plan" subscription successfully saved!'));

              case 17:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    cancelSubscription: function cancelSubscription() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var _ref11, _ref12, err, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this7.$refs.loader.onShow();
                _context6.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__api_stripe_api__["d" /* apiCancelSubscription */])(id);

              case 3:
                _ref11 = _context6.sent;
                _ref12 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref11, 2);
                err = _ref12[0];
                data = _ref12[1];

                _this7.$refs.loader.onClose();

                if (!err) {
                  _context6.next = 10;
                  break;
                }

                return _context6.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_modules_Error__["a" /* errorMessage */])(err, 'Failed to cancel subscription. Please contact your project manager.'));

              case 10:
                if (data.success) {
                  _context6.next = 12;
                  break;
                }

                return _context6.abrupt('return', _this7.$bus.$emit('toastError', 'Failed to cancel subscription. Please contact your project manager.'));

              case 12:

                _this7.$refs.loader.onClose();
                _this7.$bus.$emit('modalClose');
                window.location.reload();
                return _context6.abrupt('return', _this7.$bus.$emit('toastSuccess', 'Your subscription successfully canceled!'));

              case 16:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    filterPrice: function filterPrice(price) {
      var length = price.toString().length;
      return price.toString().length > 1 ? price.toString().slice(0, length - 3) + ',' + price.toString().slice(length - 3, length) : '' + price;
    },
    filterPlanName: function filterPlanName(planName) {
      var plan = this.planList.filter(function (el) {
        return el.valueMonth === planName;
      })[0];
      var period = 'monthly';
      if (plan === undefined) {
        plan = this.planList.filter(function (el) {
          return el.valueYear === planName;
        })[0];
        period = 'yearly';
      }
      if (plan === undefined) {
        plan = this.legacyPlans.filter(function (el) {
          return el.value === planName;
        })[0];
        period = '';
      }
      return plan.name + ' ' + period;
    }
  })
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      descriptionFileKeys: []
    };
  },


  props: ['args'],

  created: function created() {},


  methods: {
    onConfirm: function onConfirm() {
      this.$bus.$emit('removeDescriptionFile', this.args.task, this.args.fileKey, this.args.tagName);
    }
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_task_api__ = __webpack_require__(39);




//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },


  props: {
    args: {
      type: Object,
      required: true
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['updateActiveTaskProperties']), {
    onConfirm: function onConfirm() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var projectID, _args, key, taskId, _ref, _ref2, err, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                projectID = _this.$route.params.id;
                _args = _this.args, key = _args.key, taskId = _args.taskId;
                _context.next = 4;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__api_task_api__["m" /* apiRemoveDesignFileKey */])(projectID, taskId, key);

              case 4:
                _ref = _context.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);
                err = _ref2[0];
                data = _ref2[1];


                _this.$bus.$emit('modalClose');

                if (!err) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt('return', errorMessage(err, 'Unable to add design!'));

              case 11:
                return _context.abrupt('return', _this.updateActiveTaskProperties({ taskId: taskId,
                  properties: { designerFileList: data.designerFileList }
                }));

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  })
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_project_api__ = __webpack_require__(15);




//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },


  props: ["args"],

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['removeTask']), {
    onConfirm: function onConfirm() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var projectID, _ref, _ref2, err;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$bus.$emit('loaderShow');
                projectID = _this.$route.params.id;
                _context.next = 4;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__api_project_api__["g" /* apiProjectTaskRemove */])(projectID, _this.args);

              case 4:
                _ref = _context.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 1);
                err = _ref2[0];

                if (!err) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt('return', errorMessage(err, 'Unable to delete task. Try again later!'));

              case 9:

                _this.$bus.$emit('modalClose');

                _this.removeTask(_this.args);

                _this.$bus.$emit('loaderClose');
                _this.$bus.$emit('toastSuccess', 'Task successfully removed');

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  })
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_project_api__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(8);




//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },


  props: ['args'],

  created: function created() {},


  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['removeUserFromProject']), {
    onConfirmRemoveUser: function onConfirmRemoveUser() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var projectID, _ref, _ref2, err;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                projectID = _this.$route.params.id;

                _this.$bus.$emit('loaderShow');

                _context.next = 4;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_project_api__["f" /* apiProjectUserRemove */])(projectID, _this.args.id);

              case 4:
                _ref = _context.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 1);
                err = _ref2[0];

                if (!err) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt('return', errorMessage(err, 'Unable to delete user. Try again later!'));

              case 9:

                _this.removeUserFromProject(_this.args.id);
                _this.$bus.$emit('loaderClose');
                _this.$bus.$emit('modalClose');
                _this.$bus.$emit('toastSuccess', 'User successfully removed from project');

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  })
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'eta',

  props: {
    sliderValue: {
      type: Number,
      required: true
    },
    sliderPercentage: {
      type: Number,
      required: true
    }
  },

  data: function data() {

    return {
      rotateStyle: { transform: 'rotate(0deg)' },
      fixStyle: { transform: 'rotate(0deg)' }
    };
  },


  computed: {
    rotateDeg: function rotateDeg() {
      var deg = Math.abs(Math.floor((1 - this.sliderPercentage) * 180));
      this.rotateStyle.transform = 'rotate(' + deg + 'deg)';
      return this.rotateStyle;
    },
    rotateDegFix: function rotateDegFix() {
      var deg = Math.abs(Math.floor((1 - this.sliderPercentage) * 180));
      this.fixStyle.transform = 'rotate(' + deg * 2 + 'deg)';
      return this.fixStyle;
    }
  }
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(8);



//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },


  props: {
    args: {
      type: Object,
      required: true
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['assigneeDesigner']), {
    onConfirm: function onConfirm() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _args, projectId, taskId, designer;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _args = _this.args, projectId = _args.projectId, taskId = _args.taskId, designer = _args.designer;
                _context.next = 3;
                return _this.assigneeDesigner({ projectId: projectId, taskId: taskId, designer: designer });

              case 3:
                _this.$bus.$emit('modalClose');

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  })
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_RangeSlider__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_RangeSlider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_modules_RangeSlider__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'range-slider': __WEBPACK_IMPORTED_MODULE_2_modules_RangeSlider___default.a
  },

  data: function data() {
    return {
      etaValue: 0,
      etwValue: 0,
      estimatedTime: 0,
      etaRuler: [0, 12, 24, 36, 48, 60, 72],
      etwRuler: [0, 10, 20, 30, 40, '50+'],
      btnDisabled: false
    };
  },


  props: {
    args: {
      type: Object,
      required: true
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['updateStatus']), {
    init: function init() {
      this.bindEvents();
      this.setEta();
    },
    onConfirm: function onConfirm() {
      this.updateStatus({ projectId: this.args.projectId, taskId: this.args.taskId, status: 'inProgress' });
      this.btnDisabled = true;
      this.$bus.$emit('modalClose');
    },
    bindEvents: function bindEvents() {
      var _this = this;

      this.$bus.$on('updateTaskEtaValue', function (taskId, projectId, value, etaType) {
        if (_this.args.taskId == taskId && _this.args.projectId == projectId) {
          _this.onUpdateEtaValue(value, etaType);
        }
      });
    },
    unbindEvents: function unbindEvents() {
      this.$bus.$off('updateTaskEtaValue');
      this.$bus.$off('updateTaskEta');
    },
    setEta: function setEta() {
      this.etaValue = this.args.etaValue;
      this.etwValue = this.args.etwValue;
    },
    onUpdateEtaValue: function onUpdateEtaValue(value, etaType) {
      if (etaType === 'estimatedTimeOfCompletion') {
        this.etaValue = value;
      } else {
        this.etwValue = value;
      }
    }
  }),
  created: function created() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    this.unbindEvents();
  }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_task_api__ = __webpack_require__(39);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Dropzone: __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone___default.a
  },

  data: function data() {
    return {
      addedDesignsFileKeys: [],
      uploading: false,
      dropzoneOptions: {
        dictDefaultMessage: '<span class="icon-arrow-up-bold-circle text-color-green h4"></span><span class="dz-drop-text">Drop your files here</span>',
        previewTemplate: '<div class="dz-preview dz-file-preview">' + '<div class="dz-image"><img data-dz-thumbnail /></div>' + '<div class="dz-details">' + '<div class="dz-filename"><span data-dz-name></span></div>' + '<div class="dz-size" data-dz-size></div>' + '</div>' + '<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>' + '<div class="dz-success-mark dz-success-mark--modal-upload"><span class="icon-check"></span></div>' + '<div class="dz-error-mark dz-error-mark--modal-upload"><span class="icon-remove"></span></div>' + '<div class="dz-error-message"><span data-dz-errormessage></span></div>' + '<div class="dz-remove" data-dz-remove><span class="icon-remove"></span></div>' + '</div>'
      }
    };
  },


  props: {
    args: {
      type: Object,
      required: true
    }
  },

  created: function created() {},


  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['updateActiveTaskProperties']), {
    onSending: function onSending() {
      this.uploading = true;
    },
    onUploaded: function onUploaded() {
      this.uploading = false;
    },
    showSuccess: function showSuccess(file, response) {
      this.addedDesignsFileKeys.unshift(response.key);
    },
    onConfirm: function onConfirm() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var projectID, _ref, _ref2, err, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.uploading = true;
                projectID = _this.$route.params.id;
                _context.next = 4;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_task_api__["a" /* apiAddDesignsFileKeys */])(projectID, _this.args.taskId, _this.addedDesignsFileKeys);

              case 4:
                _ref = _context.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);
                err = _ref2[0];
                data = _ref2[1];

                if (!err) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt('return', errorMessage(err, 'Unable to add design!'));

              case 10:

                _this.$bus.$emit('modalClose');
                return _context.abrupt('return', _this.updateActiveTaskProperties({
                  taskId: _this.args.taskId,
                  properties: { designerFileList: data.designerFileList, designZipLink: '' }
                }));

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    onFileRemove: function onFileRemove(file) {
      if (file.xhr.response) {
        var response = JSON.parse(file.xhr.response);
        this.addedDesignsFileKeys = _.filter(this.addedDesignsFileKeys, function (key) {
          return key !== response.key;
        });
      }
    }
  })
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['args'],

  data: function data() {
    return {};
  },


  computed: {
    archiveText: function archiveText() {
      return this.args.state === 'inProgress' ? 'archive' : 'unarchive';
    },
    projectState: function projectState() {
      return this.args.state === 'inProgress' ? 'archived' : 'inProgress';
    }
  },

  methods: {
    onConfirm: function onConfirm() {
      this.$bus.$emit('projectUpdateStatus', this.args.id, this.projectState);
    }
  }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sha256__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sha256___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sha256__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_project_api__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_Error__ = __webpack_require__(7);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      project: {
        customerFirstName: null,
        customerLastName: null,
        customerEmail: null,
        customerCompanyName: null,
        customerPasswordPlainText: null,
        isExistingCustomer: true
      },
      user: null,
      users: null,
      selectedUser: null,
      disabledSubmit: false
    };
  },


  props: {
    args: {
      type: Object,
      required: true
    }
  },

  created: function created() {
    this.init();
  },


  methods: {
    init: function init() {
      if (this.args.userRole !== 'customer') {
        this.getUsers();
      }
    },
    getUsers: function getUsers() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, _ref2, err, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_project_api__["b" /* apiGetListCustomers */])();

              case 2:
                _ref = _context.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);
                err = _ref2[0];
                data = _ref2[1];

                if (!err) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_modules_Error__["a" /* errorMessage */])(err, 'Unable to access user info'));

              case 8:
                return _context.abrupt('return', _this.users = data.list);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    onProjectCreate: function onProjectCreate() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var param, _ref3, _ref4, err, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.disabledSubmit = true;
                param = _this2.project;


                if (_this2.selectedUser) {
                  param = {
                    customerEmail: _this2.selectedUser,
                    customerCompanyName: _this2.project.customerCompanyName
                  };
                }

                if (_this2.selectedUser && _this2.args.userRole === 'projectManager') {
                  param = {
                    customerEmail: _this2.selectedUser,
                    name: _this2.project.customerCompanyName
                  };
                }

                if (_this2.args.userRole === 'customer') {
                  param = {
                    customerEmail: _this2.args.userEmail,
                    name: _this2.project.customerCompanyName
                  };
                }

                if (param.customerPasswordPlainText) {
                  param.customerPassword = __WEBPACK_IMPORTED_MODULE_3_sha256___default()(param.customerPasswordPlainText);
                }

                _this2.$bus.$emit('loaderShow');

                _context2.next = 9;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_project_api__["c" /* apiCreateProject */])(_this2.args.userRole, param);

              case 9:
                _ref3 = _context2.sent;
                _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);
                err = _ref4[0];
                data = _ref4[1];

                _this2.$bus.$emit('loaderClose');
                _this2.$bus.$emit('modalClose');

                if (!err) {
                  _context2.next = 18;
                  break;
                }

                _this2.disabledSubmit = false;
                return _context2.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_modules_Error__["a" /* errorMessage */])(err, 'Unable to create project!'));

              case 18:
                return _context2.abrupt('return', _this2.$router.push({ name: 'project', params: { id: data.id } }));

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },


  props: ['args'],

  methods: {
    onConfirm: function onConfirm() {
      this.$bus.$emit('projectRemove', this.args);
    }
  }
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_project_api__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Error__ = __webpack_require__(7);



//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['args'],
  data: function data() {
    return {};
  },
  created: function created() {},

  methods: {
    onUserRemoveAllInformation: function onUserRemoveAllInformation() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, _ref2, err, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_project_api__["a" /* apiUserRemoveAllInformation */])();

              case 2:
                _ref = _context.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);
                err = _ref2[0];
                data = _ref2[1];

                if (!err) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_modules_Error__["a" /* errorMessage */])(err, 'Unable delete your identity'));

              case 8:
                if (data.status) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt('return', _this.$bus.$emit('toastError', 'Error: ' + data.explanation));

              case 10:
                _this.$bus.$emit('toastSuccess', data.explanation);
                return _context.abrupt('return', setTimeout(function () {
                  _this.$bus.$emit('logout');
                }, 2000));

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }

});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_user_api__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Error__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sha256__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sha256___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sha256__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      user: {
        name: null,
        surname: null,
        email: null,
        passwordPlainText: null,
        password: null,
        hourRate: null,
        role: 'designer',
        avatarKey: null
      },
      userRoles: [{
        name: 'Designer',
        value: 'designer'
      }, {
        name: 'Project Manager',
        value: 'projectManager'
      }]
    };
  },


  props: ['args'],

  created: function created() {
    this.init();
  },


  methods: {
    init: function init() {
      if (this.args) {
        this.user = this.args;
      }
    },
    onUserAvatarUpload: function onUserAvatarUpload(e) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var param, _ref, _ref2, err, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                param = new FormData();

                param.append('file', e.target.files[0]);

                _context.next = 4;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_user_api__["a" /* apiUploadUserAvatar */])(param);

              case 4:
                _ref = _context.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);
                err = _ref2[0];
                data = _ref2[1];

                if (!err) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_modules_Error__["a" /* errorMessage */])(err, 'Unable to upload user avatar!'));

              case 10:
                return _context.abrupt('return', _this.user.avatarKey = data.key);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    onConfirm: function onConfirm() {
      this.user.password = __WEBPACK_IMPORTED_MODULE_5_sha256___default()(this.user.passwordPlainText);
      this.$bus.$emit('userCreate', this.user);
      this.$bus.$emit('loaderShow');
    }
  }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      paymentAmount: null,
      debtMoney: null
    };
  },


  props: {
    args: {
      type: Object,
      required: true
    }
  },

  created: function created() {
    this.init();
  },


  methods: {
    init: function init() {
      this.debtMoney = this.args.debtMoney;
    },
    onConfirm: function onConfirm() {
      this.$bus.$emit('userPayment', this.args.userId, this.paymentAmount, this.debtMoney);
    }
  }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },


  props: {
    args: {
      type: Object,
      required: true
    }
  },

  created: function created() {},


  methods: {
    onConfirm: function onConfirm() {
      this.$bus.$emit('userRemove', this.args.userId);
      this.$bus.$emit('loaderShow');
    }
  }
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_user_api__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Error__ = __webpack_require__(7);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      user: {
        name: null,
        surname: null,
        email: null,
        hourRate: null,
        role: 'designer',
        avatarKey: null
      },
      userRoles: [{
        name: 'Designer',
        value: 'designer'
      }, {
        name: 'Project Manager',
        value: 'projectManager'
      }]
    };
  },


  props: {
    args: {
      type: Object,
      required: true
    }
  },

  created: function created() {
    this.init();
  },


  methods: {
    init: function init() {
      this.user = _.cloneDeep(this.args);
    },
    onUserAvatarUpload: function onUserAvatarUpload(e) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var param, _ref, _ref2, err, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                param = new FormData();

                param.append('file', e.target.files[0]);

                _context.next = 4;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_user_api__["a" /* apiUploadUserAvatar */])(param);

              case 4:
                _ref = _context.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);
                err = _ref2[0];
                data = _ref2[1];

                if (!err) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_modules_Error__["a" /* errorMessage */])(err, 'Unable to upload user avatar!'));

              case 10:
                return _context.abrupt('return', _this.user.avatarKey = data.key);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    onConfirm: function onConfirm() {
      this.$bus.$emit('userUpdate', this.user);
    }
  }
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nouislider_distribute_nouislider__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nouislider_distribute_nouislider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_nouislider_distribute_nouislider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wNumb_wNumb__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wNumb_wNumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_wNumb_wNumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nouislider_distribute_nouislider_css__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nouislider_distribute_nouislider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_nouislider_distribute_nouislider_css__);
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rangeSlider',

  props: {
    taskId: {
      type: Number,
      required: true
    },
    projectId: {
      type: Number,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    etaType: {
      type: String,
      required: true
    },
    endpoint: {
      type: String
    }
  },

  data: function data() {
    return {
      slider: null,
      baseEndpoint: 'updateTaskEta',
      maxValue: 72
    };
  },


  methods: {
    init: function init() {
      var _this = this;

      if (this.endpoint) {
        this.baseEndpoint = this.endpoint;
      }

      if (this.etaType === 'estimatedWork') {
        this.maxValue = 50;
      }

      this.slider = this.$refs.rangeSlider;
      __WEBPACK_IMPORTED_MODULE_0_nouislider_distribute_nouislider___default.a.create(this.slider, {
        start: this.value,
        step: 1,
        format: __WEBPACK_IMPORTED_MODULE_1_wNumb_wNumb___default()({
          decimals: 0
        }),
        connect: [true, false],
        range: {
          min: 0,
          max: this.maxValue
        }
      });

      this.slider.noUiSlider.on('update', function (values, handle) {
        _this.$bus.$emit(_this.baseEndpoint + 'Value', _this.taskId, _this.projectId, Number(values[handle]), _this.etaType);
      });

      this.slider.noUiSlider.on('change', function () {
        _this.$bus.$emit('' + _this.baseEndpoint, _this.taskId, _this.projectId, _this.etaType);
      });
    }
  },

  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 108,
	"./af.js": 108,
	"./ar": 115,
	"./ar-dz": 109,
	"./ar-dz.js": 109,
	"./ar-kw": 110,
	"./ar-kw.js": 110,
	"./ar-ly": 111,
	"./ar-ly.js": 111,
	"./ar-ma": 112,
	"./ar-ma.js": 112,
	"./ar-sa": 113,
	"./ar-sa.js": 113,
	"./ar-tn": 114,
	"./ar-tn.js": 114,
	"./ar.js": 115,
	"./az": 116,
	"./az.js": 116,
	"./be": 117,
	"./be.js": 117,
	"./bg": 118,
	"./bg.js": 118,
	"./bm": 119,
	"./bm.js": 119,
	"./bn": 120,
	"./bn.js": 120,
	"./bo": 121,
	"./bo.js": 121,
	"./br": 122,
	"./br.js": 122,
	"./bs": 123,
	"./bs.js": 123,
	"./ca": 124,
	"./ca.js": 124,
	"./cs": 125,
	"./cs.js": 125,
	"./cv": 126,
	"./cv.js": 126,
	"./cy": 127,
	"./cy.js": 127,
	"./da": 128,
	"./da.js": 128,
	"./de": 131,
	"./de-at": 129,
	"./de-at.js": 129,
	"./de-ch": 130,
	"./de-ch.js": 130,
	"./de.js": 131,
	"./dv": 132,
	"./dv.js": 132,
	"./el": 133,
	"./el.js": 133,
	"./en-SG": 134,
	"./en-SG.js": 134,
	"./en-au": 135,
	"./en-au.js": 135,
	"./en-ca": 136,
	"./en-ca.js": 136,
	"./en-gb": 137,
	"./en-gb.js": 137,
	"./en-ie": 138,
	"./en-ie.js": 138,
	"./en-il": 139,
	"./en-il.js": 139,
	"./en-nz": 140,
	"./en-nz.js": 140,
	"./eo": 141,
	"./eo.js": 141,
	"./es": 144,
	"./es-do": 142,
	"./es-do.js": 142,
	"./es-us": 143,
	"./es-us.js": 143,
	"./es.js": 144,
	"./et": 145,
	"./et.js": 145,
	"./eu": 146,
	"./eu.js": 146,
	"./fa": 147,
	"./fa.js": 147,
	"./fi": 148,
	"./fi.js": 148,
	"./fo": 149,
	"./fo.js": 149,
	"./fr": 152,
	"./fr-ca": 150,
	"./fr-ca.js": 150,
	"./fr-ch": 151,
	"./fr-ch.js": 151,
	"./fr.js": 152,
	"./fy": 153,
	"./fy.js": 153,
	"./ga": 154,
	"./ga.js": 154,
	"./gd": 155,
	"./gd.js": 155,
	"./gl": 156,
	"./gl.js": 156,
	"./gom-latn": 157,
	"./gom-latn.js": 157,
	"./gu": 158,
	"./gu.js": 158,
	"./he": 159,
	"./he.js": 159,
	"./hi": 160,
	"./hi.js": 160,
	"./hr": 161,
	"./hr.js": 161,
	"./hu": 162,
	"./hu.js": 162,
	"./hy-am": 163,
	"./hy-am.js": 163,
	"./id": 164,
	"./id.js": 164,
	"./is": 165,
	"./is.js": 165,
	"./it": 167,
	"./it-ch": 166,
	"./it-ch.js": 166,
	"./it.js": 167,
	"./ja": 168,
	"./ja.js": 168,
	"./jv": 169,
	"./jv.js": 169,
	"./ka": 170,
	"./ka.js": 170,
	"./kk": 171,
	"./kk.js": 171,
	"./km": 172,
	"./km.js": 172,
	"./kn": 173,
	"./kn.js": 173,
	"./ko": 174,
	"./ko.js": 174,
	"./ku": 175,
	"./ku.js": 175,
	"./ky": 176,
	"./ky.js": 176,
	"./lb": 177,
	"./lb.js": 177,
	"./lo": 178,
	"./lo.js": 178,
	"./lt": 179,
	"./lt.js": 179,
	"./lv": 180,
	"./lv.js": 180,
	"./me": 181,
	"./me.js": 181,
	"./mi": 182,
	"./mi.js": 182,
	"./mk": 183,
	"./mk.js": 183,
	"./ml": 184,
	"./ml.js": 184,
	"./mn": 185,
	"./mn.js": 185,
	"./mr": 186,
	"./mr.js": 186,
	"./ms": 188,
	"./ms-my": 187,
	"./ms-my.js": 187,
	"./ms.js": 188,
	"./mt": 189,
	"./mt.js": 189,
	"./my": 190,
	"./my.js": 190,
	"./nb": 191,
	"./nb.js": 191,
	"./ne": 192,
	"./ne.js": 192,
	"./nl": 194,
	"./nl-be": 193,
	"./nl-be.js": 193,
	"./nl.js": 194,
	"./nn": 195,
	"./nn.js": 195,
	"./pa-in": 196,
	"./pa-in.js": 196,
	"./pl": 197,
	"./pl.js": 197,
	"./pt": 199,
	"./pt-br": 198,
	"./pt-br.js": 198,
	"./pt.js": 199,
	"./ro": 200,
	"./ro.js": 200,
	"./ru": 201,
	"./ru.js": 201,
	"./sd": 202,
	"./sd.js": 202,
	"./se": 203,
	"./se.js": 203,
	"./si": 204,
	"./si.js": 204,
	"./sk": 205,
	"./sk.js": 205,
	"./sl": 206,
	"./sl.js": 206,
	"./sq": 207,
	"./sq.js": 207,
	"./sr": 209,
	"./sr-cyrl": 208,
	"./sr-cyrl.js": 208,
	"./sr.js": 209,
	"./ss": 210,
	"./ss.js": 210,
	"./sv": 211,
	"./sv.js": 211,
	"./sw": 212,
	"./sw.js": 212,
	"./ta": 213,
	"./ta.js": 213,
	"./te": 214,
	"./te.js": 214,
	"./tet": 215,
	"./tet.js": 215,
	"./tg": 216,
	"./tg.js": 216,
	"./th": 217,
	"./th.js": 217,
	"./tl-ph": 218,
	"./tl-ph.js": 218,
	"./tlh": 219,
	"./tlh.js": 219,
	"./tr": 220,
	"./tr.js": 220,
	"./tzl": 221,
	"./tzl.js": 221,
	"./tzm": 223,
	"./tzm-latn": 222,
	"./tzm-latn.js": 222,
	"./tzm.js": 223,
	"./ug-cn": 224,
	"./ug-cn.js": 224,
	"./uk": 225,
	"./uk.js": 225,
	"./ur": 226,
	"./ur.js": 226,
	"./uz": 228,
	"./uz-latn": 227,
	"./uz-latn.js": 227,
	"./uz.js": 228,
	"./vi": 229,
	"./vi.js": 229,
	"./x-pseudo": 230,
	"./x-pseudo.js": 230,
	"./yo": 231,
	"./yo.js": 231,
	"./zh-cn": 232,
	"./zh-cn.js": 232,
	"./zh-hk": 233,
	"./zh-hk.js": 233,
	"./zh-tw": 234,
	"./zh-tw.js": 234
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 408;

/***/ }),
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(445),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(443),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(440),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(447),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 424 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal__content"
  }, [_c('p', {
    staticClass: "text-center mb20"
  }, [_vm._v(_vm._s(_vm.content))]), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center"
  }, [_c('a', {
    staticClass: "btn btn--wide",
    class: {
      'btn--disabled': _vm.linkDisabled
    },
    attrs: {
      "href": _vm.link,
      "download": "",
      "disabled": _vm.linkDisabled
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("Download")])])])])
},staticRenderFns: []}

/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__content"
  }, [_c('p', {
    staticClass: "text-center mb20"
  }, [_vm._v("Are you sure you want to " + _vm._s(_vm.archiveText) + " this project?")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center"
  }, [_c('button', {
    staticClass: "btn btn--wide btn--gray-2 mr10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--wide",
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("Yes")])])])
},staticRenderFns: []}

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__content"
  }, [_c('form', [(_vm.args.userRole !== 'customer') ? _c('div', {
    staticClass: "form-row"
  }, [_c('label', {
    attrs: {
      "for": "existing-user"
    }
  }, [_vm._v("Select existing user")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedUser),
      expression: "selectedUser"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "existing-user",
      "id": "existing-user"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedUser = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select User")]), _vm._v(" "), _vm._l((_vm.users), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.email
      }
    }, [_vm._v(_vm._s(option.email))])
  })], 2)]) : _vm._e(), _vm._v(" "), (!_vm.selectedUser && _vm.args.userRole !== 'customer') ? _c('div', {
    staticClass: "form-row"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.customerFirstName),
      expression: "project.customerFirstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name",
      "placeholder": "Steve"
    },
    domProps: {
      "value": (_vm.project.customerFirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "customerFirstName", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.selectedUser && _vm.args.userRole !== 'customer') ? _c('div', {
    staticClass: "form-row"
  }, [_c('label', {
    attrs: {
      "for": "surname"
    }
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.customerLastName),
      expression: "project.customerLastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "surname",
      "id": "surname",
      "placeholder": "Jobs"
    },
    domProps: {
      "value": (_vm.project.customerLastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "customerLastName", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('label', {
    attrs: {
      "for": "company"
    }
  }, [_vm._v("Company")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.customerCompanyName),
      expression: "project.customerCompanyName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "company",
      "id": "company",
      "placeholder": "Apple"
    },
    domProps: {
      "value": (_vm.project.customerCompanyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "customerCompanyName", $event.target.value)
      }
    }
  })]), _vm._v(" "), (!_vm.selectedUser && _vm.args.userRole !== 'customer') ? _c('div', {
    staticClass: "form-row"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.customerEmail),
      expression: "project.customerEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email",
      "placeholder": "steve@apple.com"
    },
    domProps: {
      "value": (_vm.project.customerEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "customerEmail", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.selectedUser && _vm.args.userRole !== 'customer') ? _c('div', {
    staticClass: "form-row"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.customerPasswordPlainText),
      expression: "project.customerPasswordPlainText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.project.customerPasswordPlainText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "customerPasswordPlainText", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center mt20"
  }, [_c('button', {
    staticClass: "btn btn--gray-2 mr10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "submit",
      "disabled": _vm.disabledSubmit
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onProjectCreate($event)
      }
    }
  }, [_vm._v("Submit")])])])])
},staticRenderFns: []}

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__content"
  }, [_c('p', {
    staticClass: "text-center mb20"
  }, [_vm._v("Are you sure you want to delete this project?")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center"
  }, [_c('button', {
    staticClass: "btn btn--wide btn--gray-2 mr10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--wide",
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("Yes")])])])
},staticRenderFns: []}

/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__content",
    on: {
      "click": _vm.onDatepickerClose
    }
  }, [(_vm.showSubscriptionPlan) ? _c('div', {
    staticClass: "form-row flex-nowrap flex--align-vertical"
  }, [_c('div', {
    staticClass: "flex-grow-1 pr10"
  }, [_c('label', {
    attrs: {
      "for": "dropbox-link"
    }
  }, [_vm._v("Subscription plan")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.planList.selected),
      expression: "planList.selected"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.disabledChangePlan
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.planList, "selected", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.planList.options), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "flex-none pl10"
  }, [_c('label', {
    attrs: {
      "for": "dropbox-link"
    }
  }, [_vm._v("select date")]), _vm._v(" "), _c('datepicker', {
    ref: "projectSettingsDatepicker",
    staticClass: "datepicker--settings h-100",
    attrs: {
      "taskDeadline": _vm.projectDeadline,
      "useInSeconds": true
    },
    on: {
      "updateDeadline": _vm.onUpdateDeadline
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.showSubscriptionPlan) ? _c('button', {
    staticClass: "btn w-100 mb20",
    attrs: {
      "disabled": _vm.disabledUpdatePlan
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updatePlan()
      }
    }
  }, [_vm._v("Change Plan")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('label', {
    attrs: {
      "for": "project-name"
    }
  }, [_vm._v("Project Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectSettings.name),
      expression: "projectSettings.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "project-name"
    },
    domProps: {
      "value": (_vm.projectSettings.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projectSettings, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('label', {
    attrs: {
      "for": "project-customer-email"
    }
  }, [_vm._v("Project Owner")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectSettings.customerEmail),
      expression: "projectSettings.customerEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "existing-user",
      "id": "project-customer-email"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.projectSettings, "customerEmail", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select User")]), _vm._v(" "), _vm._l((_vm.projectUsers), function(projectUser) {
    return _c('option', {
      key: projectUser.email,
      attrs: {
        "disabled": projectUser.email === _vm.projectSettings.customerEmail
      },
      domProps: {
        "value": projectUser.email
      }
    }, [_vm._v(_vm._s(projectUser.email))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('label', {
    attrs: {
      "for": "dropbox-link"
    }
  }, [_vm._v("Source Link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectSettings.dropboxShareLinkToFolder),
      expression: "projectSettings.dropboxShareLinkToFolder"
    }],
    staticClass: "form-control form-control--text-overflow",
    attrs: {
      "type": "text",
      "id": "dropbox-link"
    },
    domProps: {
      "value": (_vm.projectSettings.dropboxShareLinkToFolder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projectSettings, "dropboxShareLinkToFolder", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center mt20"
  }, [_c('button', {
    staticClass: "btn btn--gray-2 mr10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.onUpdateProperties
    }
  }, [_vm._v("Submit")])])])
},staticRenderFns: []}

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view'), _vm._v(" "), _c('vue-toast', {
    ref: "toast",
    staticStyle: {
      "z-index": "1000"
    }
  }), _vm._v(" "), _c('app-modal', {
    ref: "modal"
  }), _vm._v(" "), _c('portal-target', {
    attrs: {
      "name": "popper-root"
    }
  }), _vm._v(" "), _c('app-loader', {
    ref: "loader",
    staticClass: "loader-overlay--dark"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__content modal__content--project-team pl0 pr0 pt30 pb20"
  }, [_c('div', {
    staticClass: "border-bottom-lightest2 pl30 pr30 mb30"
  }, [_c('h5', {
    staticClass: "text-size-11 text-space-12 text-color-gray-dark text-medium text-uppercase pt2 mb5"
  }, [_vm._v("add your team members")]), _vm._v(" "), _c('form', {
    staticClass: "flex-nowrap flex--align-vertical mb15",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onConfirm($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.userInvite.email),
      expression: "userInvite.email",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control form-control--small mr10",
    class: {
      'has-error': _vm.errors.has('email')
    },
    attrs: {
      "type": "text",
      "name": "email",
      "id": "email",
      "placeholder": "name@email.com"
    },
    domProps: {
      "value": (_vm.userInvite.email)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.userInvite, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInvite.selectedRole),
      expression: "userInvite.selectedRole"
    }],
    staticClass: "form-control form-control--small mr10",
    attrs: {
      "name": "user-role",
      "id": "user-role"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.userInvite, "selectedRole", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.userRoles), function(option) {
    return _c('option', {
      key: option.name,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.name))])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn--plus-green"
  }, [_vm._v("+")])]), _vm._v(" "), (_vm.userInvite.selectedRole === 'editor') ? _c('p', {
    staticClass: "text-size-15 text-medium text-height-14 mb25"
  }, [_vm._v("Editor can view tasks, add new tasks, write comments, see task costs"), _c('br', {
    staticClass: "hidden-xs-down"
  }), _vm._v(" and see project balance. Can not top up the balance.")]) : _vm._e(), _vm._v(" "), (_vm.userInvite.selectedRole === 'viewer') ? _c('p', {
    staticClass: "text-size-15 text-medium text-height-14 mb25"
  }, [_vm._v("Viewer can view tasks, add new tasks and write comments. Can not"), _c('br', {
    staticClass: "hidden-xs-down"
  }), _vm._v(" see task costs, see project balance, top up the balance.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pl30 pr30"
  }, [_c('h5', {
    staticClass: "text-size-11 text-space-12 text-color-gray-dark text-medium text-uppercase"
  }, [_vm._v("current members")]), _vm._v(" "), _c('ul', {
    staticClass: "project-users-list"
  }, _vm._l((_vm.args.projectUsers), function(projectUser) {
    return _c('li', {
      key: projectUser.id,
      staticClass: "flex flex--justify-space-between border-bottom-lightest2 mb10 pb15 pt1"
    }, [_c('div', {
      staticClass: "flex flex--align-vertical project-users-list__avatar mr10 pr15"
    }, [(projectUser.avatarKey) ? _c('img', {
      staticClass: "img-circle img-circle--40 mr10",
      attrs: {
        "src": '/serve/s/' + projectUser.avatarKey + '?w=80&h=80',
        "alt": "User Avatar"
      }
    }) : _c('div', {
      staticClass: "img-circle img-circle--40 mr10 flex-nowrap flex--align-vertical"
    }, [_c('span', {
      staticClass: "text-color-white text-uppercase text-size-16 text-lh-1 text-center"
    }, [_vm._v("\n              " + _vm._s(_vm._f("firstCharacter")(projectUser.name)) + _vm._s(_vm._f("firstCharacter")(projectUser.surname)) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "pt5"
    }, [_c('h5', {
      staticClass: "text-size-18 text-medium text-height-1 mb0 text-color-black pt2"
    }, [_vm._v(_vm._s(projectUser.name) + " " + _vm._s(_vm.userSurname(projectUser.surname)))]), _vm._v(" "), (_vm.checkUserRole(_vm.args.role, ['admin', 'projectManager']) || (_vm.checkUserRole(_vm.args.userProjectRole, ['owner', 'editor', 'viewer']) && _vm.checkUserRole(projectUser.userProjectRole, ['owner', 'editor', 'viewer', 'admin', 'projectManager']))) ? _c('a', {
      staticClass: "text-size-13 text-height-1",
      attrs: {
        "href": 'mailto:' + projectUser.email
      }
    }, [_vm._v(_vm._s(projectUser.email))]) : _vm._e()]), _vm._v(" "), (_vm.args.userId !== projectUser.id && (_vm.checkUserRole(_vm.args.role, ['admin', 'projectManager']) || _vm.checkUserRole(_vm.args.role, ['customer']) && _vm.checkUserRole(projectUser.userProjectRole, ['editor', 'viewer']))) ? _c('span', {
      staticClass: "remove icon-remove",
      on: {
        "click": function($event) {
          _vm.$bus.$emit('modalClose') && _vm.$bus.$emit('modalShow', ['project-remove-user-modal', {
            id: projectUser.id,
            name: projectUser.name
          }])
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "flex flex--align-vertical w-100 w-auto-sm"
    }, [_c('h5', {
      staticClass: "text-medium mb0 ml20-sm text-color-dark-3"
    }, [_vm._v(_vm._s(projectUser.userProjectRoleText))])])])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "loader"
    }
  }, [(_vm.showLoader) ? _c('div', {
    staticClass: "loader-overlay"
  }, [_c('div', {
    staticClass: "loader"
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 432 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.onClose),
      expression: "onClose"
    }],
    staticClass: "dropdown",
    class: {
      collapsed: _vm.collapsed, 'dropdown--selectable': _vm.selectable
    }
  }, [_c('div', {
    staticClass: "dropdown__btn",
    class: {
      'flex flex--align-vertical': _vm.buttonIconName, 'flex--row-reverse': _vm.buttonIconLeft
    },
    on: {
      "click": _vm.onToggle
    }
  }, [(_vm.buttonText) ? _c('span', {
    staticClass: "text-size-13 text-height-1"
  }, [_vm._v(_vm._s(_vm.buttonText))]) : _vm._e(), _vm._v(" "), (_vm.buttonEtaShow) ? _c('eta-progress', {
    attrs: {
      "sliderValue": _vm.buttonTextEta,
      "sliderPercentage": _vm.buttonPercentageEta
    }
  }) : _vm._e(), _vm._v(" "), (_vm.buttonIconName && _vm.buttonIconName !== 'icon--chevron-down') ? _c('span', {
    staticClass: "icon text-height-1",
    class: [{
      ml5: _vm.buttonText && !_vm.buttonIconLeft
    }, _vm.buttonIconName, _vm.buttonIconSize, _vm.buttonIconColor]
  }) : _vm._e(), _vm._v(" "), (_vm.buttonIconName && _vm.buttonIconName == 'icon--chevron-down') ? _c('svg', {
    staticClass: "icon icon--chevron-down ml4",
    attrs: {
      "width": "8",
      "height": "4",
      "viewBox": "0 0 8 4",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M3.99896 2.84506L0.927172 0.141524C0.715077 -0.0452716 0.371131 -0.0452167 0.159037 0.141609C-0.0530122 0.328181 -0.0530122 0.630769 0.159037 0.817645L3.6159 3.86004C3.82805 4.04669 4.17204 4.04661 4.38404 3.86004C4.39318 3.85198 4.40193 3.84372 4.41028 3.83525L7.84081 0.815987C8.05309 0.62933 8.05305 0.326607 7.84076 0.139951C7.62871 -0.0466503 7.28497 -0.0466503 7.07258 0.139951L3.99896 2.84506Z"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "dropdown"
    }
  }, [(_vm.collapsed && _vm.contentList) ? _c('ul', {
    staticClass: "dropdown__content",
    on: {
      "click": _vm.onClose
    }
  }, [_c('button', {
    staticClass: "btn btn--mobile-close",
    on: {
      "click": _vm.onClose
    }
  }, [_c('span', {
    staticClass: "icon-remove"
  })]), _vm._v(" "), _vm._l((_vm.dropdownList), function(item) {
    return (_vm.dropdownList) ? _vm._t("item", null, {
      "item": item
    }) : _vm._e()
  }), _vm._v(" "), (!_vm.dropdownList) ? _vm._t("items") : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.collapsed && !_vm.contentList) ? _c('div', {
    staticClass: "dropdown__content"
  }, [_c('button', {
    staticClass: "btn btn--mobile-close",
    on: {
      "click": _vm.onClose
    }
  }, [_c('span', {
    staticClass: "icon-remove"
  })]), _vm._v(" "), _vm._t("content")], 2) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__content modal__content--max p20 pt30"
  }, [_c('h3', {
    staticClass: "text-medium text-uppercase text-size-16 text-left text-height-12 mb15 text-center-xs-down"
  }, [_vm._v("project notes:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientCharacterNotes),
      expression: "clientCharacterNotes"
    }],
    staticClass: "mb20 form-control form-control--no-resize form-control--placeholder-gray form-control--notes",
    attrs: {
      "type": "text",
      "placeholder": _vm.clientCharacterNotes
    },
    domProps: {
      "value": (_vm.clientCharacterNotes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientCharacterNotes = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn--block text-uppercase",
    on: {
      "click": function($event) {
        return _vm.editNotes()
      }
    }
  }, [_vm._v("Save")])])
},staticRenderFns: []}

/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal__content"
  }, [_c('p', {
    staticClass: "mb20"
  }, [_vm._v("Amount that we need to pay: $" + _vm._s(_vm.debtMoney))]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('label', {
    attrs: {
      "for": "pay"
    }
  }, [_vm._v("Amount that we already paid")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymentAmount),
      expression: "paymentAmount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "pay",
      "placeholder": "$0"
    },
    domProps: {
      "value": (_vm.paymentAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paymentAmount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('button', {
    staticClass: "btn btn--gray-2 flex__fill-gap mr10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("Close\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn flex__fill-gap",
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("Confirm")])])])])
},staticRenderFns: []}

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__content modal__content-adddesigns pl30 pr30 pb20"
  }, [_c('h2', {
    staticClass: "text-size-20 text-regular mb20"
  }, [_vm._v("Let’s give our client some information")]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-lighter pb20"
  }, [_c('h3', {
    staticClass: "text-size-16 text-regular mb5"
  }, [_vm._v("First design will be live in "), _c('span', {
    staticClass: "text-color-purple text-medium"
  }, [_vm._v(_vm._s(_vm.etaValue) + " hours")])]), _vm._v(" "), _c('range-slider', {
    staticClass: "mb5",
    attrs: {
      "taskId": _vm.args.taskId,
      "projectId": _vm.args.projectId,
      "value": _vm.etaValue,
      "etaType": 'estimatedTimeOfCompletion'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-space-between"
  }, _vm._l((_vm.etaRuler), function(count) {
    return _c('span', {
      staticClass: "text-size-12 text-regular"
    }, [_vm._v("\n        " + _vm._s(count) + "\n      ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-lighter pt25 pb20 mb20"
  }, [_c('h3', {
    staticClass: "text-size-16 text-regular mb5"
  }, [_vm._v("I estimate to spend "), _c('span', {
    staticClass: "text-color-purple text-medium"
  }, [_vm._v(_vm._s(_vm.etwValue) + " hours")]), _vm._v(" on this task")]), _vm._v(" "), _c('range-slider', {
    staticClass: "mb5",
    attrs: {
      "taskId": _vm.args.taskId,
      "projectId": _vm.args.projectId,
      "value": _vm.etwValue,
      "etaType": 'estimatedWork'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-space-between"
  }, _vm._l((_vm.etwRuler), function(count) {
    return _c('span', {
      staticClass: "text-size-12 text-regular"
    }, [_vm._v("\n        " + _vm._s(count) + "\n      ")])
  }), 0)], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn--block text-uppercase mb0",
    attrs: {
      "disabled": _vm.btnDisabled
    },
    on: {
      "click": function($event) {
        return _vm.onConfirm()
      }
    }
  }, [_vm._v("Start this task")])])
},staticRenderFns: []}

/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "header header--main container-fluid flex-nowrap flex--justify-space-between"
  }, [_c('div', {
    staticClass: "header__item flex flex--align-vertical"
  }, [_c('div', {
    staticClass: "header__logo mr10"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.linkToMainPage
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/logo/logo-icon-v2.svg",
      "alt": "Koncepted Platform"
    }
  })])], 1), _vm._v(" "), _c('nav', {
    class: [{
      closed: !_vm.open
    }, {
      open: _vm.open
    }, {
      closing: !_vm.open
    }],
    attrs: {
      "role": "navigation"
    }
  }, [_c('ul', {
    staticClass: "flex mb0 ml10 ml0-sm-down pl0"
  }, [(_vm.checkUserRole(_vm.user.role, ['admin', 'projectManager', 'designer'])) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'schedule'
      },
      "tag": "li"
    }
  }, [_vm._v("Schedule")]) : _vm._e(), _vm._v(" "), (_vm.checkUserRole(_vm.user.role, ['admin', 'projectManager', 'designer'])) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'tasks'
      },
      "tag": "li"
    }
  }, [_vm._v("Tasks")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'projects'
      },
      "tag": "li"
    }
  }, [_vm._v("Projects")]), _vm._v(" "), (_vm.checkUserRole(_vm.user.role, ['admin', 'projectManager', 'designer'])) ? _c('router-link', {
    staticClass: "relative",
    attrs: {
      "to": {
        name: 'messages'
      },
      "tag": "li"
    }
  }, [_vm._v("Messages  \n            "), (_vm.messagesCount !== 0) ? _c('span', {
    staticClass: "badge badge--messages text-space-05 text-uppercase ml2 mb0"
  }, [_vm._v("\n              " + _vm._s(_vm.messagesCount) + "\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.checkUserRole(_vm.user.role, ['admin', 'projectManager'])) ? _c('li', {
    staticClass: "flex flex--align-vertical flex--justify-center"
  }, [_c('dropdown', {
    staticClass: "dropdown--header-links",
    attrs: {
      "selectable": false,
      "buttonText": 'Users',
      "buttonIconName": 'text-size-15 icon-chevron-down'
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'users'
            },
            "tag": "li"
          }
        }, [_vm._v("Users")]), _vm._v(" "), _c('router-link', {
          attrs: {
            "to": {
              name: 'designers'
            },
            "tag": "li"
          }
        }, [_vm._v("Designers")])]
      }
    }], null, false, 3419029881)
  })], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'settings'
      },
      "tag": "li"
    }
  }, [_vm._v("Settings")]), _vm._v(" "), ((_vm.$route.name === 'tasks' || _vm.$route.name === 'projects') && _vm.checkUserRole(_vm.user.role, ['admin', 'projectManager', 'customer'])) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalShow', ['project-create-modal', {
          userRole: _vm.user.role,
          userEmail: _vm.user.email
        }])
      }
    }
  }, [_c('span', {
    staticClass: "icon-plus ml0 mr5"
  }), _vm._v("\n            New Project\n          ")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "header__item header__item--middle flex-nowrap flex--align-vertical flex-nowrap mr20-xs-down mr30-sm-down"
  }, [(_vm.$route.name === 'users') ? _c('a', {
    staticClass: "link link--gray text-size-12 hidden-sm-down text-medium text-uppercase text-spase-2 mr20",
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalShow', ['add-user-modal'])
      }
    }
  }, [_c('span', {
    staticClass: "icon-plus ml0 mr5"
  }), _vm._v("\n        Add User\n      ")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "link link--gray text-size-12 text-medium text-uppercase text-spase-2 mr20",
    on: {
      "click": _vm.onLogout
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _c('div', {
    staticClass: "header__user flex flex--row flex--align-vertical"
  }, [_c('router-link', {
    staticClass: "flex flex--align-vertical\n          flex-nowrap",
    attrs: {
      "to": {
        name: 'settings'
      }
    }
  }, [(_vm.user.avatarKey) ? _c('img', {
    staticClass: "img-circle img-circle--24 mr10",
    attrs: {
      "src": '/serve/s/' + _vm.user.avatarKey + '?w=48&h=48',
      "alt": "User Avatar"
    }
  }) : _c('img', {
    staticClass: "img-circle img-circle--24 mr10",
    attrs: {
      "src": "/static/images/user/user-avatar-demo@2x.png",
      "alt": "User Avatar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-ellipsis-wrap"
  }, [_c('p', {
    staticClass: "header__user--username text-ellipsis-block"
  }, [_vm._v(_vm._s(_vm.user.name) + " " + _vm._s(_vm.user.surname))]), _vm._v(" "), (_vm.isWorkLogDataLoading) ? _c('i', {
    staticClass: "icon--rectangle icon--rectangle-tall icon--rectange-dark-gray"
  }) : (_vm.workLogData) ? _c('tooltip', [_c('template', {
    slot: "reference"
  }, [_c('h6', {
    staticClass: "header__user--hours w-100 cursor-pointer text-ellipsis-block"
  }, [_vm._v(_vm._s(_vm._f("shortMonth")(_vm.currentPeriodStartDate)) + " " + _vm._s(_vm.currentPeriodAmount) + "h")])]), _vm._v(" "), _c('template', {
    slot: "content"
  }, [_c('ul', {
    staticClass: "header__user-worklog header__worklog-dropdown"
  }, _vm._l((_vm.workLogData), function(item) {
    return _c('li', {
      key: item.fromTs,
      class: {
        'pointer-events-none': item.amount === 0
      }
    }, [_c('details', {
      staticClass: "w-100"
    }, [_c('summary', {
      class: ['w-100', 'header__worklog-summary', {
        'header__worklog-summary-disabled': item.amount === 0
      }]
    }, [_c('div', {
      class: ['header__worklog-item', {
        'header__worklog-item-no-hours': _vm.amountSum === 0
      }]
    }, [_vm._v(_vm._s(_vm._f("shortDate")(item.fromTs)) + " - " + _vm._s(_vm._f("shortDate")(item.toTs))), _c('span', {
      staticClass: "text-color-white mlauto"
    }, [_vm._v(_vm._s(item.amount))])])]), _vm._v(" "), _vm._l((item.perProject), function(amount, projectName) {
      return _c('div', {
        key: projectName,
        staticClass: "header__worklog-project-item"
      }, [_vm._v("\n                            " + _vm._s(projectName) + " "), _c('span', {
        staticClass: "text-color-white mlauto"
      }, [_vm._v(_vm._s(amount))])])
    })], 2)])
  }), 0)])], 2) : _vm._e()], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "header__item flex-nowrap flex--align-vertical visible-sm-down-flex"
  }, [(_vm.$route.name === 'users') ? _c('button', {
    staticClass: "btn-simple flex-none visible-sm-down-block",
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalShow', ['add-user-modal'])
      }
    }
  }, [_vm._v("Add User\n      ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "header__menu-btn",
    class: {
      open: _vm.open
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('span')])])])])
},staticRenderFns: []}

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__content"
  }, [_c('p', {
    staticClass: "text-center mb20"
  }, [_vm._v("Are you sure you want to remove task from this project?")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center"
  }, [_c('button', {
    staticClass: "btn btn--wide btn--gray-2 mr10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--wide",
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("Yes")])])])
},staticRenderFns: []}

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal__content"
  }, [_c('p', {
    staticClass: "text-center mb20"
  }, [_vm._v("Are you sure you want to remove designer file from this task?")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center"
  }, [_c('button', {
    staticClass: "btn btn--wide btn--gray-2 mr10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--wide",
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("Yes")])])])])
},staticRenderFns: []}

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal__content"
  }, [_c('p', {
    staticClass: "text-center mb20"
  }, [_vm._v("Are you sure you want to remove " + _vm._s(_vm.args.name) + " from this project?")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center"
  }, [_c('button', {
    staticClass: "btn btn--wide btn--gray-2 mr10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--wide",
    on: {
      "click": _vm.onConfirmRemoveUser
    }
  }, [_vm._v("Yes")])])])])
},staticRenderFns: []}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__content"
  }, [_c('p', {
    staticClass: "text-center mb20"
  }, [_vm._v("Are you sure you want to remove comment from this design?")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center"
  }, [_c('button', {
    staticClass: "btn btn--wide btn--gray-2 mr10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--wide",
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('app-loader', {
    ref: "loader",
    staticClass: "loader-overlay--inside loader-overlay--radius"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal__content"
  }, [_c('p', {
    staticClass: "text-center mb20"
  }, [_vm._v("Are you sure you want to remove designer file from this task?")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center"
  }, [_c('button', {
    staticClass: "btn btn--wide btn--gray-2 mr10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--wide",
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("Yes")])])])])
},staticRenderFns: []}

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.onClose),
      expression: "onClose"
    }],
    staticClass: "dropdown",
    class: {
      collapsed: _vm.collapsed
    }
  }, [_c('div', {
    staticClass: "dropdown__btn",
    class: _vm.btnClass,
    on: {
      "click": _vm.onToggle
    }
  }, [_vm._t("btn")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "dropdown"
    }
  }, [(_vm.collapsed) ? _c('div', {
    staticClass: "dropdown__content"
  }, [_c('button', {
    staticClass: "btn btn--mobile-close",
    on: {
      "click": _vm.onClose
    }
  }, [_c('span', {
    staticClass: "icon-remove"
  })]), _vm._v(" "), _vm._t("content")], 2) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', _vm._g({
    ref: "reference",
    staticClass: "tooltip__reference"
  }, _vm.isTouchOnly ? {
    click: _vm.clickHandler
  } : {
    mouseenter: _vm.open,
    mouseleave: _vm.handleMouseLeave
  }), [_vm._t("reference", [_vm._v("\n      Tooltip Reference\n    ")])], 2), _vm._v(" "), _c('portal', {
    attrs: {
      "to": "popper-root"
    }
  }, [_c('div', _vm._g({
    key: "popper",
    ref: "popper",
    staticClass: "tooltip__popper"
  }, _vm.isTouchOnly ? undefined : {
    mouseenter: _vm.open,
    mouseleave: _vm.handleMouseLeave
  }), [_c('transition', {
    attrs: {
      "name": "message"
    }
  }, [(_vm.isOpen) ? _c('div', {
    staticClass: "tooltip__content"
  }, [_vm._t("content", [_vm._v("\n            Tooltip\n          ")])], 2) : _vm._e()])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__content modal__content--top-up-modal modal__content--mobile-scroll pt30 pl30 pr30"
  }, [_c('button', {
    staticClass: "modal__close",
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_c('span', {
    staticClass: "icon-remove"
  })]), _vm._v(" "), _c('app-loader', {
    ref: "loader"
  }), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentSteps === 0),
      expression: "paymentSteps === 0"
    }]
  }, [_c('h2', {
    staticClass: "text-color-white text-medium text-size-24 text-center pb30 mb0"
  }, [_vm._v("Enter biling information ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-nowrap flex--justify-space-between"
  }, [_c('button', {
    staticClass: "btn--payment text-size-16 text-medium w-50 mr10",
    on: {
      "click": function($event) {
        _vm.paymentSteps = 1
      }
    }
  }, [_c('i', {
    staticClass: "icon--bank-card mlauto mrauto mb15"
  }), _vm._v(" "), _c('span', {
    staticClass: "mb0"
  }, [_vm._v("Credit card or bank transfer")])]), _vm._v(" "), _c('button', {
    staticClass: "btn--payment text-size-16 text-medium w-50 mr10",
    on: {
      "click": function($event) {
        _vm.paymentSteps = 1
      }
    }
  }, [_c('i', {
    staticClass: "icon--bitcoin mlauto mrauto mb10"
  }), _vm._v(" "), _c('span', {
    staticClass: "mb0"
  }, [_vm._v("Crypto payment (BTC)")])])])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentSteps === 1),
      expression: "paymentSteps === 1"
    }]
  }, [_c('h2', {
    staticClass: "text-color-white text-medium text-size-24 text-center pb30 mb0"
  }, [_vm._v("Select payment method")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-nowrap flex--justify-space-between pb30"
  }, [_c('button', {
    staticClass: "btn--payment text-size-16 text-medium w-50 mr10",
    class: {
      active: _vm.userInformation.customerType === 'COMPANY'
    },
    on: {
      "click": function($event) {
        _vm.userInformation.customerType = 'COMPANY'
      }
    }
  }, [_c('i', {
    staticClass: "icon--company mlauto mrauto mb10"
  }), _vm._v(" "), _c('span', [_vm._v("We're a Company")])]), _vm._v(" "), _c('button', {
    staticClass: "btn--payment text-size-16 text-medium w-50 ml10",
    class: {
      active: _vm.userInformation.customerType === 'INDIVIDUAL'
    },
    on: {
      "click": function($event) {
        _vm.userInformation.customerType = 'INDIVIDUAL'
      }
    }
  }, [_c('i', {
    staticClass: "icon--individual mlauto mrauto mb10"
  }), _vm._v(" "), _c('span', [_vm._v("I'm an individual")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group pb30"
  }, [_c('div', {
    staticClass: "w-50 pl5 pr10 mb20"
  }, [_c('label', {
    staticClass: "text-white-08 text-medium text-size-12 text-uppercase",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInformation.customerFirstName),
      expression: "userInformation.customerFirstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:2'),
      expression: "'required|min:2'"
    }],
    staticClass: "form-control",
    class: {
      'has-error': _vm.errors.has('name')
    },
    attrs: {
      "id": "name",
      "name": "name",
      "type": "text",
      "placeholder": "Albert"
    },
    domProps: {
      "value": (_vm.userInformation.customerFirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInformation, "customerFirstName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "w-50 pl10 pr5 mb20"
  }, [_c('label', {
    staticClass: "text-white-08 text-medium text-size-12 text-uppercase",
    attrs: {
      "for": "surname"
    }
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInformation.customerLastName),
      expression: "userInformation.customerLastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:2'),
      expression: "'required|min:2'"
    }],
    staticClass: "form-control",
    class: {
      'has-error': _vm.errors.has('surname')
    },
    attrs: {
      "id": "surname",
      "type": "text",
      "name": "surname",
      "placeholder": "Flores"
    },
    domProps: {
      "value": (_vm.userInformation.customerLastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInformation, "customerLastName", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.userInformation.customerType === 'COMPANY') ? _c('div', {
    staticClass: "w-100 pl5 pr5 mb20"
  }, [_c('label', {
    staticClass: "text-white-08 text-medium text-size-12 text-uppercase",
    attrs: {
      "for": "company"
    }
  }, [_vm._v("Company Full Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1'),
      expression: "'required|min:1'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.userInformation.customerCompanyName),
      expression: "userInformation.customerCompanyName"
    }],
    staticClass: "form-control",
    class: {
      'has-error': _vm.errors.has('company')
    },
    attrs: {
      "type": "text",
      "name": "company",
      "id": "company",
      "placeholder": "Apple"
    },
    domProps: {
      "value": (_vm.userInformation.customerCompanyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInformation, "customerCompanyName", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w-100 pl5 pr5 mb20"
  }, [_c('label', {
    staticClass: "text-white-08 text-medium text-size-12 text-uppercase",
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Street Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInformation.customerAddress),
      expression: "userInformation.customerAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1'),
      expression: "'required|min:1'"
    }],
    staticClass: "form-control",
    class: {
      'has-error': _vm.errors.has('address')
    },
    attrs: {
      "id": "address",
      "type": "text",
      "name": "address",
      "placeholder": "Street address"
    },
    domProps: {
      "value": (_vm.userInformation.customerAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInformation, "customerAddress", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "w-33 pl5 pr5"
  }, [_c('label', {
    staticClass: "text-white-08 text-medium text-size-12 text-uppercase",
    attrs: {
      "for": "city"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInformation.customerPost),
      expression: "userInformation.customerPost"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1'),
      expression: "'required|min:1'"
    }],
    staticClass: "form-control",
    class: {
      'has-error': _vm.errors.has('city')
    },
    attrs: {
      "id": "city",
      "type": "text",
      "name": "city",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.userInformation.customerPost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInformation, "customerPost", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "w-33 pl5 pr5"
  }, [_c('label', {
    staticClass: "text-white-08 text-medium text-size-12 text-uppercase",
    attrs: {
      "for": "country"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "form-row__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country),
      expression: "country"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'has-error': _vm.errors.has('country')
    },
    attrs: {
      "id": "country",
      "name": "country"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onCountrySelect]
    }
  }, _vm._l((_vm.countries), function(country) {
    return _c('option', {
      key: country.id,
      domProps: {
        "value": country
      }
    }, [_vm._v(_vm._s(country.countryName))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "w-33 pl5 pr5"
  }, [_c('label', {
    staticClass: "text-white-08 text-medium text-size-12 text-uppercase",
    attrs: {
      "for": "city"
    }
  }, [_vm._v("Post code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInformation.customerPostCode),
      expression: "userInformation.customerPostCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1'),
      expression: "'required|min:1'"
    }],
    staticClass: "form-control",
    class: {
      'has-error': _vm.errors.has('postcode')
    },
    attrs: {
      "id": "postcode",
      "type": "text",
      "name": "city",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.userInformation.customerPostCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInformation, "customerPostCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-nowrap flex--justify-space-between"
  }, [_c('button', {
    staticClass: "btn--dark-violet text-size-14 text-uppercase text-bold text-space-05 w-50 mr10",
    attrs: {
      "disabled": true
    },
    on: {
      "click": function($event) {
        _vm.paymentSteps = 0
      }
    }
  }, [_vm._v("back")]), _vm._v(" "), _c('button', {
    staticClass: "btn--green text-size-14 text-uppercase text-bold w-50 ml10",
    on: {
      "click": function($event) {
        return _vm.onPaymentInformationUpdate()
      }
    }
  }, [_vm._v("continue")])])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentSteps === 2),
      expression: "paymentSteps === 2"
    }]
  }, [_c('h2', {
    staticClass: "text-color-white text-medium text-size-24 text-center "
  }, [_vm._v("Pick your membership plan")]), _vm._v(" "), _c('a', {
    staticClass: "link link--green text-apercu text-color-green text-size-18 text-center pb30 flex flex--justify-center",
    class: {
      'border-bottom-lighter2': _vm.currentPlan !== 'none'
    },
    attrs: {
      "href": "https://koncepted.com/pricing",
      "target": "_blank"
    }
  }, [_vm._v("\n      View full pricing comparison\n    ")]), _vm._v(" "), (_vm.currentPlan === 'none') ? [_c('div', {
    staticClass: "flex"
  }, [_c('button', {
    staticClass: "btn--dark-violet text-size-16 w50",
    class: {
      active: _vm.customerPaymentPlanPeriod === 'YEARLY'
    },
    on: {
      "click": function($event) {
        _vm.customerPaymentPlanPeriod = 'YEARLY'
      }
    }
  }, [_c('span', [_vm._v("Yearly Billing")]), _vm._v(" "), _c('span', {
    staticClass: "badge--violet text-size-12 text-space-1 text-uppercase pr10 pl10 pt6 pb5 ml5 mb0"
  }, [_vm._v("2 months free")])]), _vm._v(" "), _c('button', {
    staticClass: "btn--dark-violet text-size-16 w50",
    class: {
      active: _vm.customerPaymentPlanPeriod === 'MONTHLY'
    },
    on: {
      "click": function($event) {
        _vm.customerPaymentPlanPeriod = 'MONTHLY'
      }
    }
  }, [_vm._v("\n          Monthly Billing\n        ")])]), _vm._v(" "), _vm._l((_vm.planList), function(plan, index) {
    return _c('div', {
      key: plan.id,
      staticClass: "flex flex--justify-space-between pt30 pb30",
      class: {
        'border-bottom-lighter2': index < 2
      }
    }, [_c('div', {
      staticClass: "mrauto"
    }, [_c('div', {
      staticClass: "flex flex--align-vertical"
    }, [_c('i', {
      class: plan.icon
    }), _vm._v(" "), _c('h2', {
      staticClass: "text-color-white text-medium text-size-24 pr10 pl7 mb0"
    }, [_vm._v(_vm._s(plan.name))])]), _vm._v(" "), _c('p', {
      staticClass: "text-white-08 text-regular text-size-16"
    }, [_vm._v(_vm._s(plan.description))])]), _vm._v(" "), _c('div', {
      staticClass: "flex flex--column flex--align-bottom"
    }, [_c('h2', {
      staticClass: "text-color-white text-medium text-size-24 mb0"
    }, [_vm._v("$\n            "), (_vm.customerPaymentPlanPeriod === 'YEARLY') ? [_vm._v(_vm._s(_vm.filterPrice(plan.pricePerYear)))] : _vm._e(), _vm._v(" "), (_vm.customerPaymentPlanPeriod === 'MONTHLY') ? [_vm._v(_vm._s(_vm.filterPrice(plan.pricePerMonth)))] : _vm._e()], 2), _vm._v(" "), (_vm.customerPaymentPlanPeriod === 'YEARLY') ? _c('p', {
      staticClass: "text-white-50 text-size-14"
    }, [_vm._v("per month/billed yearly")]) : _vm._e(), _vm._v(" "), (_vm.customerPaymentPlanPeriod === 'MONTHLY') ? _c('p', {
      staticClass: "text-white-50 text-size-14"
    }, [_vm._v("per month")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "flex flex--align-vertical w100"
    }, [_vm._l((plan.badges), function(badge, index) {
      return _c('span', {
        key: badge.id,
        staticClass: "text-white-50 text-size-14 badge mb0",
        class: {
          'mr2': index !== plan.badges.length - 1
        }
      }, [_vm._v(" \n            " + _vm._s(badge) + "\n          ")])
    }), _vm._v(" "), _c('button', {
      staticClass: "btn mlauto",
      on: {
        "click": function($event) {
          return _vm.onSelectedPlan(plan)
        }
      }
    }, [_vm._v("select")])], 2)])
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-nowrap flex--justify-space-between"
  }, [_c('button', {
    staticClass: "btn--dark-violet text-size-14 text-uppercase text-bold text-space-05 w-50 mr10",
    on: {
      "click": function($event) {
        _vm.paymentSteps = 1
      }
    }
  }, [_vm._v("back")])])] : [_c('h2', {
    staticClass: "text-color-white text-medium text-size-20 text-center text-uppercase text-space-05 pt20"
  }, [_vm._v(_vm._s(_vm.filterPlanName(_vm.currentPlan)))]), _vm._v(" "), (_vm.currentPlan !== 'PAY_AS_YOU_GO') ? _c('button', {
    staticClass: "btn btn--green text-size-14 text-uppercase text-bold w-100 mb10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redirectToPlatform()
      }
    }
  }, [_vm._v("\n        change billing")]) : _c('button', {
    staticClass: "btn btn--green text-size-14 text-uppercase text-bold w-100 mb10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancelSubscription()
      }
    }
  }, [_vm._v("\n        cancel plan")])]], 2), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentSteps === 3),
      expression: "paymentSteps === 3"
    }]
  }, [_c('h2', {
    staticClass: "text-color-white text-medium text-size-24 text-center pb30 mb0"
  }, [_vm._v("Payment order")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex--column flex--align-vertical"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn--dark-violet text-size-14 text-uppercase w50",
    on: {
      "click": function($event) {
        _vm.paymentSteps = 1
      }
    }
  }, [_vm._v("back")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card p30 mb30"
  }, [_c('i', {
    staticClass: "icon icon--qrcode"
  })])
}]}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.showModal) ? _c('div', {
    staticClass: "modal",
    on: {
      "click": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('button', {
    staticClass: "btn btn--mobile-close",
    on: {
      "click": _vm.onClose
    }
  }, [_c('span', {
    staticClass: "icon-remove"
  })]), _vm._v(" "), _c(_vm.currentModal, {
    tag: "component",
    attrs: {
      "args": _vm.args
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "modal__content pr100 pl100 pb40"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row flex--align-vertical"
  }, [_c('div', {
    staticClass: "col-md-4 mb20 pr45"
  }, [_c('label', {
    attrs: {
      "for": "user-profile-image"
    }
  }, [(_vm.user.avatarKey) ? _c('img', {
    staticClass: "img-circle mr15",
    attrs: {
      "src": '/serve/s/' + _vm.user.avatarKey + '?w=240&h=240',
      "alt": "user.name"
    }
  }) : _c('img', {
    staticClass: "img-circle mr15",
    attrs: {
      "src": "/static/images/user/user-avatar-demo-big@2x.png",
      "alt": "user.name"
    }
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "user-profile-image",
      "accept": "image/*",
      "hidden": ""
    },
    on: {
      "change": function($event) {
        return _vm.onUserAvatarUpload($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-6 form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.surname),
      expression: "user.surname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "surname",
      "placeholder": "Last name"
    },
    domProps: {
      "value": (_vm.user.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "surname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.user.role !== 'admin' && _vm.user.role !== 'customer') ? _c('div', {
    staticClass: "col-md-6 form-row form-row--select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.role),
      expression: "user.role"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "user-role",
      "id": "user-role"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.userRoles), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.name))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.passwordPlainText),
      expression: "user.passwordPlainText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password",
      "placeholder": "Password",
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.user.passwordPlainText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "passwordPlainText", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 form-row"
  }, [_c('div', {
    staticClass: "form-row__rate"
  }, [_c('label', {
    attrs: {
      "for": "hour-rate"
    }
  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.hourRate),
      expression: "user.hourRate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "hour-rate"
    },
    domProps: {
      "value": (_vm.user.hourRate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "hourRate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "hour-rate"
    }
  }, [_vm._v("per hour")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt20"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-4"
  }, [_c('button', {
    staticClass: "btn btn--wide btn--gray-2 mr10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--wide",
    attrs: {
      "disabled": _vm.user.passwordPlainText === null
    },
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("Add")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-4"
  }, [_c('h3', {
    staticClass: "text-regular mb40 ml20"
  }, [_vm._v("Add new user")])])])
}]}

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__content"
  }, [(_vm.args.projectUser.avatarKey) ? _c('div', {
    staticClass: "text-center mb30"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": '/serve/s/' + _vm.args.projectUser.avatarKey + '?w=96&h=96',
      "alt": _vm.args.projectUser.name
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center"
  }, [_c('div', {
    staticClass: "form-row mb0 mr30"
  }, [_c('label', [_vm._v("User Name")]), _vm._v(" "), _c('h4', {
    staticClass: "text-regular"
  }, [_vm._v(_vm._s(_vm.args.projectUser.name) + " " + _vm._s(_vm.args.projectUser.surname))])]), _vm._v(" "), (_vm.checkUserRole(_vm.args.userRole, ['admin', 'projectManager']) || (_vm.checkUserRole(_vm.args.userProjectRole, ['owner', 'editor', 'viewer']) && _vm.checkUserRole(_vm.args.projectUser.userProjectRole, ['owner', 'editor', 'viewer', 'admin', 'projectManager']))) ? _c('div', {
    staticClass: "form-row mb0 mr30"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('h4', {
    staticClass: "text-regular mb0"
  }, [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.args.projectUser.email
    }
  }, [_vm._v(_vm._s(_vm.args.projectUser.email))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-row mb0"
  }, [_c('label', [_vm._v("Role")]), _vm._v(" "), _c('h4', {
    staticClass: "text-regular"
  }, [_vm._v(_vm._s(_vm._f("titleize")(_vm.args.projectUser.userProjectRole)))])])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center mt30"
  }, [_c('button', {
    staticClass: "btn btn--wide btn--gray-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("Close")])])])
},staticRenderFns: []}

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "rangeSlider",
    staticClass: "range-slider"
  })
},staticRenderFns: []}

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal__content"
  }, [_c('p', {
    staticClass: "text-center mb20"
  }, [_vm._v("Are you sure you want to remove all information associated with your "), _c('span', {
    staticClass: "text-color-green"
  }, [_vm._v(_vm._s(_vm.args.name) + "  " + _vm._s(_vm.args.surname))]), _vm._v(" account?")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center"
  }, [_c('button', {
    staticClass: "btn btn--wide btn--gray-2 mr10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--wide",
    on: {
      "click": _vm.onUserRemoveAllInformation
    }
  }, [_vm._v("Yes")])])])])
},staticRenderFns: []}

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "eta"
  }, [_c('div', {
    staticClass: "eta__mask eta__mask-full",
    style: (_vm.rotateDeg)
  }, [_c('div', {
    staticClass: "eta__fill",
    style: (_vm.rotateDeg)
  })]), _vm._v(" "), _c('div', {
    staticClass: "eta__mask eta__mask-half"
  }, [_c('div', {
    staticClass: "eta__fill",
    style: (_vm.rotateDeg)
  }), _vm._v(" "), _c('div', {
    staticClass: "eta__fill eta__fill-fix",
    style: (_vm.rotateDegFix)
  })]), _vm._v(" "), _c('div', {
    staticClass: "eta__data"
  }, [_c('span', {
    staticClass: "text-gray-light"
  }, [_vm._v("ETA")]), _vm._v(" "), _c('span', {
    staticClass: "text-color-gray-dark-2 text-center"
  }, [_vm._v(_vm._s(_vm.sliderValue || 0) + "H")])])])
},staticRenderFns: []}

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal__content"
  }, [_c('p', {
    staticClass: "text-center mb20"
  }, [_vm._v("Are you sure you want to remove " + _vm._s(_vm.args.userEmail) + "?")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center"
  }, [_c('button', {
    staticClass: "btn btn--wide btn--gray-2 mr10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--wide",
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("Yes")])])])])
},staticRenderFns: []}

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "modal__content pr100 pl100 pb40"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-4"
  }, [_c('h3', {
    staticClass: "text-regular mb40 ml20"
  }, [_vm._v("Edit " + _vm._s(_vm.user.name) + " " + _vm._s(_vm.user.surname))])])]), _vm._v(" "), _c('div', {
    staticClass: "row flex--align-vertical"
  }, [_c('div', {
    staticClass: "col-md-4 mb20 pr45"
  }, [_c('label', {
    attrs: {
      "for": "user-profile-image"
    }
  }, [(_vm.user.avatarKey) ? _c('img', {
    staticClass: "img-circle mr15",
    attrs: {
      "src": '/serve/s/' + _vm.user.avatarKey + '?w=240&h=240',
      "alt": "user.name"
    }
  }) : _c('img', {
    staticClass: "img-circle mr15",
    attrs: {
      "src": "/static/images/user/user-avatar-demo-big@2x.png",
      "alt": "user.name"
    }
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "user-profile-image",
      "accept": "image/*",
      "hidden": ""
    },
    on: {
      "change": function($event) {
        return _vm.onUserAvatarUpload($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-6 form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.surname),
      expression: "user.surname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "surname",
      "placeholder": "Last name"
    },
    domProps: {
      "value": (_vm.user.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "surname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.user.role !== 'admin' && _vm.user.role !== 'customer') ? _c('div', {
    staticClass: "col-md-6 form-row form-row--select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.role),
      expression: "user.role"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "user-role",
      "id": "user-role"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.userRoles), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.name))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 form-row"
  }, [_c('div', {
    staticClass: "form-row__rate"
  }, [_c('label', {
    attrs: {
      "for": "hour-rate"
    }
  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.hourRate),
      expression: "user.hourRate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "hour-rate"
    },
    domProps: {
      "value": (_vm.user.hourRate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "hourRate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "hour-rate"
    }
  }, [_vm._v("per hour")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt20"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-4"
  }, [_c('button', {
    staticClass: "btn btn--wide btn--gray-2 mr10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--wide",
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("Update")])])])])])
},staticRenderFns: []}

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__content container"
  }, [_c('h3', {
    staticClass: "text-center text-regular mb20"
  }, [_vm._v("Upload your designs")]), _vm._v(" "), _c('dropzone', {
    ref: "dropzone",
    attrs: {
      "id": "projectDesignerFilesUpload",
      "url": "/upload/file",
      "useCustomDropzoneOptions": "",
      "dropzoneOptions": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-success": _vm.showSuccess,
      "vdropzone-removed-file": _vm.onFileRemove,
      "vdropzone-sending": _vm.onSending,
      "vdropzone-queue-complete": _vm.onUploaded
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center mt20"
  }, [_c('button', {
    staticClass: "btn btn--gray-2 mr5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    class: {
      'btn--disabled': _vm.uploading
    },
    attrs: {
      "disabled": _vm.uploading
    },
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("Submit\n    ")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.onClose),
      expression: "onClose"
    }],
    staticClass: "datepicker"
  }, [_c('input', {
    staticClass: "datepicker__input",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "datepicker__show",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onToggle($event)
      }
    }
  }, [(_vm.taskDeadline !== 0 && _vm.useInSeconds) ? _c('span', {
    staticClass: "flex-none"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.taskDeadline * 1000, 'D MMM YYYY')))]) : _vm._e(), _vm._v(" "), (_vm.taskDeadline !== 0 && !_vm.useInSeconds) ? _c('span', {
    staticClass: "flex-none"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.taskDeadline, 'D MMM')))]) : _vm._e(), _vm._v(" "), (_vm.taskDeadline == 0) ? _c('span', {
    staticClass: "flex-none"
  }, [_vm._v("None")]) : _vm._e(), _vm._v(" "), _c('svg', {
    staticClass: "icon icon--chevron-down ml4",
    attrs: {
      "width": "8",
      "height": "4",
      "viewBox": "0 0 8 4",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M3.99896 2.84506L0.927172 0.141524C0.715077 -0.0452716 0.371131 -0.0452167 0.159037 0.141609C-0.0530122 0.328181 -0.0530122 0.630769 0.159037 0.817645L3.6159 3.86004C3.82805 4.04669 4.17204 4.04661 4.38404 3.86004C4.39318 3.85198 4.40193 3.84372 4.41028 3.83525L7.84081 0.815987C8.05309 0.62933 8.05305 0.326607 7.84076 0.139951C7.62871 -0.0466503 7.28497 -0.0466503 7.07258 0.139951L3.99896 2.84506Z"
    }
  })])]), _vm._v(" "), (_vm.showDatepicker) ? _c('div', {
    staticClass: "datepicker__block"
  }, [_c('div', {
    staticClass: "datepicker__header"
  }, [_c('div', {
    staticClass: "datepicker__header-row"
  }, [_c('i', {
    staticClass: "datepicker__control icon-chevron-left",
    on: {
      "click": function($event) {
        return _vm.setPreviousMonth()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "datepicker__title"
  }, [_vm._v("\n          " + _vm._s(_vm.monthYearFormatted) + "\n        ")]), _vm._v(" "), _c('i', {
    staticClass: "datepicker__control icon-chevron-right",
    on: {
      "click": function($event) {
        return _vm.setNextMonth()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "datepicker__days"
  }, _vm._l((_vm.days), function(day) {
    return _c('div', {
      key: day,
      staticClass: "datepicker__day-title"
    }, [_vm._v("\n          " + _vm._s(_vm._f("trimThreeChar")(day)) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "datepicker__body"
  }, _vm._l((_vm.calendarDays), function(row, index) {
    return _c('div', {
      key: index,
      staticClass: "datepicker__body-row",
      class: {
        'swipe-left': _vm.swipeLeft, 'swipe-right': _vm.swipeRight
      }
    }, _vm._l((row), function(cell, index) {
      return _c('div', {
        key: index,
        staticClass: "datepicker__day",
        class: {
          disabled: _vm.isDisabled(cell), selected: _vm.isSelected(cell)
        },
        on: {
          "click": function($event) {
            return _vm.selectDay(cell)
          }
        }
      }, [_vm._v("\n          " + _vm._s(cell.day) + "\n        ")])
    }), 0)
  }), 0)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__content"
  }, [_c('h2', {
    staticClass: "text-size-13 text-uppercase text-regular text-center mb20"
  }, [_vm._v("Action required")]), _vm._v(" "), _c('p', {
    staticClass: "text-size-18 text-medium text-center mb20"
  }, [_vm._v("Do you want to add " + _vm._s(_vm.args.designer.name) + " " + _vm._s(_vm.args.designer.surname) + " to"), _c('br'), _vm._v("\n   " + _vm._s(_vm.args.projectName) + " as a designer ?")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center"
  }, [_c('button', {
    staticClass: "btn btn--wide btn--gray-2 mr10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--wide",
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("Confirm")])])])
},staticRenderFns: []}

/***/ }),
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */
/***/ (function(module, exports) {

module.exports = [{"countryCode":"AD","countryName":"Andorra","continent":"EU"},{"countryCode":"AE","countryName":"United Arab Emirates","continent":"AS"},{"countryCode":"AF","countryName":"Afghanistan","continent":"AS"},{"countryCode":"AG","countryName":"Antigua and Barbuda","continent":"NA"},{"countryCode":"AI","countryName":"Anguilla","continent":"NA"},{"countryCode":"AL","countryName":"Albania","continent":"EU"},{"countryCode":"AM","countryName":"Armenia","continent":"AS"},{"countryCode":"AO","countryName":"Angola","continent":"AF"},{"countryCode":"AQ","countryName":"Antarctica","continent":"AN"},{"countryCode":"AR","countryName":"Argentina","continent":"SA"},{"countryCode":"AS","countryName":"American Samoa","continent":"OC"},{"countryCode":"AT","countryName":"Austria","continent":"EU"},{"countryCode":"AU","countryName":"Australia","continent":"OC"},{"countryCode":"AW","countryName":"Aruba","continent":"NA"},{"countryCode":"AX","countryName":"Åland","continent":"EU"},{"countryCode":"AZ","countryName":"Azerbaijan","continent":"AS"},{"countryCode":"BA","countryName":"Bosnia and Herzegovina","continent":"EU"},{"countryCode":"BB","countryName":"Barbados","continent":"NA"},{"countryCode":"BD","countryName":"Bangladesh","continent":"AS"},{"countryCode":"BE","countryName":"Belgium","continent":"EU"},{"countryCode":"BF","countryName":"Burkina Faso","continent":"AF"},{"countryCode":"BG","countryName":"Bulgaria","continent":"EU"},{"countryCode":"BH","countryName":"Bahrain","continent":"AS"},{"countryCode":"BI","countryName":"Burundi","continent":"AF"},{"countryCode":"BJ","countryName":"Benin","continent":"AF"},{"countryCode":"BL","countryName":"Saint Barthélemy","continent":"NA"},{"countryCode":"BM","countryName":"Bermuda","continent":"NA"},{"countryCode":"BN","countryName":"Brunei","continent":"AS"},{"countryCode":"BO","countryName":"Bolivia","continent":"SA"},{"countryCode":"BQ","countryName":"Bonaire","continent":"NA"},{"countryCode":"BR","countryName":"Brazil","continent":"SA"},{"countryCode":"BS","countryName":"Bahamas","continent":"NA"},{"countryCode":"BT","countryName":"Bhutan","continent":"AS"},{"countryCode":"BV","countryName":"Bouvet Island","continent":"AN"},{"countryCode":"BW","countryName":"Botswana","continent":"AF"},{"countryCode":"BY","countryName":"Belarus","continent":"EU"},{"countryCode":"BZ","countryName":"Belize","continent":"NA"},{"countryCode":"CA","countryName":"Canada","continent":"NA"},{"countryCode":"CC","countryName":"Cocos [Keeling] Islands","continent":"AS"},{"countryCode":"CD","countryName":"Democratic Republic of the Congo","continent":"AF"},{"countryCode":"CF","countryName":"Central African Republic","continent":"AF"},{"countryCode":"CG","countryName":"Republic of the Congo","continent":"AF"},{"countryCode":"CH","countryName":"Switzerland","continent":"EU"},{"countryCode":"CI","countryName":"Ivory Coast","continent":"AF"},{"countryCode":"CK","countryName":"Cook Islands","continent":"OC"},{"countryCode":"CL","countryName":"Chile","continent":"SA"},{"countryCode":"CM","countryName":"Cameroon","continent":"AF"},{"countryCode":"CN","countryName":"China","continent":"AS"},{"countryCode":"CO","countryName":"Colombia","continent":"SA"},{"countryCode":"CR","countryName":"Costa Rica","continent":"NA"},{"countryCode":"CU","countryName":"Cuba","continent":"NA"},{"countryCode":"CV","countryName":"Cape Verde","continent":"AF"},{"countryCode":"CW","countryName":"Curacao","continent":"NA"},{"countryCode":"CX","countryName":"Christmas Island","continent":"OC"},{"countryCode":"CY","countryName":"Cyprus","continent":"EU"},{"countryCode":"CZ","countryName":"Czechia","continent":"EU"},{"countryCode":"DE","countryName":"Germany","continent":"EU"},{"countryCode":"DJ","countryName":"Djibouti","continent":"AF"},{"countryCode":"DK","countryName":"Denmark","continent":"EU"},{"countryCode":"DM","countryName":"Dominica","continent":"NA"},{"countryCode":"DO","countryName":"Dominican Republic","continent":"NA"},{"countryCode":"DZ","countryName":"Algeria","continent":"AF"},{"countryCode":"EC","countryName":"Ecuador","continent":"SA"},{"countryCode":"EE","countryName":"Estonia","continent":"EU"},{"countryCode":"EG","countryName":"Egypt","continent":"AF"},{"countryCode":"EH","countryName":"Western Sahara","continent":"AF"},{"countryCode":"ER","countryName":"Eritrea","continent":"AF"},{"countryCode":"ES","countryName":"Spain","continent":"EU"},{"countryCode":"ET","countryName":"Ethiopia","continent":"AF"},{"countryCode":"FI","countryName":"Finland","continent":"EU"},{"countryCode":"FJ","countryName":"Fiji","continent":"OC"},{"countryCode":"FK","countryName":"Falkland Islands","continent":"SA"},{"countryCode":"FM","countryName":"Micronesia","continent":"OC"},{"countryCode":"FO","countryName":"Faroe Islands","continent":"EU"},{"countryCode":"FR","countryName":"France","continent":"EU"},{"countryCode":"GA","countryName":"Gabon","continent":"AF"},{"countryCode":"GB","countryName":"United Kingdom","continent":"EU"},{"countryCode":"GD","countryName":"Grenada","continent":"NA"},{"countryCode":"GE","countryName":"Georgia","continent":"AS"},{"countryCode":"GF","countryName":"French Guiana","continent":"SA"},{"countryCode":"GG","countryName":"Guernsey","continent":"EU"},{"countryCode":"GH","countryName":"Ghana","continent":"AF"},{"countryCode":"GI","countryName":"Gibraltar","continent":"EU"},{"countryCode":"GL","countryName":"Greenland","continent":"NA"},{"countryCode":"GM","countryName":"Gambia","continent":"AF"},{"countryCode":"GN","countryName":"Guinea","continent":"AF"},{"countryCode":"GP","countryName":"Guadeloupe","continent":"NA"},{"countryCode":"GQ","countryName":"Equatorial Guinea","continent":"AF"},{"countryCode":"GR","countryName":"Greece","continent":"EU"},{"countryCode":"GS","countryName":"South Georgia and the South Sandwich Islands","continent":"AN"},{"countryCode":"GT","countryName":"Guatemala","continent":"NA"},{"countryCode":"GU","countryName":"Guam","continent":"OC"},{"countryCode":"GW","countryName":"Guinea-Bissau","continent":"AF"},{"countryCode":"GY","countryName":"Guyana","continent":"SA"},{"countryCode":"HK","countryName":"Hong Kong","continent":"AS"},{"countryCode":"HM","countryName":"Heard Island and McDonald Islands","continent":"AN"},{"countryCode":"HN","countryName":"Honduras","continent":"NA"},{"countryCode":"HR","countryName":"Croatia","continent":"EU"},{"countryCode":"HT","countryName":"Haiti","continent":"NA"},{"countryCode":"HU","countryName":"Hungary","continent":"EU"},{"countryCode":"ID","countryName":"Indonesia","continent":"AS"},{"countryCode":"IE","countryName":"Ireland","continent":"EU"},{"countryCode":"IL","countryName":"Israel","continent":"AS"},{"countryCode":"IM","countryName":"Isle of Man","continent":"EU"},{"countryCode":"IN","countryName":"India","continent":"AS"},{"countryCode":"IO","countryName":"British Indian Ocean Territory","continent":"AS"},{"countryCode":"IQ","countryName":"Iraq","continent":"AS"},{"countryCode":"IR","countryName":"Iran","continent":"AS"},{"countryCode":"IS","countryName":"Iceland","continent":"EU"},{"countryCode":"IT","countryName":"Italy","continent":"EU"},{"countryCode":"JE","countryName":"Jersey","continent":"EU"},{"countryCode":"JM","countryName":"Jamaica","continent":"NA"},{"countryCode":"JO","countryName":"Jordan","continent":"AS"},{"countryCode":"JP","countryName":"Japan","continent":"AS"},{"countryCode":"KE","countryName":"Kenya","continent":"AF"},{"countryCode":"KG","countryName":"Kyrgyzstan","continent":"AS"},{"countryCode":"KH","countryName":"Cambodia","continent":"AS"},{"countryCode":"KI","countryName":"Kiribati","continent":"OC"},{"countryCode":"KM","countryName":"Comoros","continent":"AF"},{"countryCode":"KN","countryName":"Saint Kitts and Nevis","continent":"NA"},{"countryCode":"KP","countryName":"North Korea","continent":"AS"},{"countryCode":"KR","countryName":"South Korea","continent":"AS"},{"countryCode":"KW","countryName":"Kuwait","continent":"AS"},{"countryCode":"KY","countryName":"Cayman Islands","continent":"NA"},{"countryCode":"KZ","countryName":"Kazakhstan","continent":"AS"},{"countryCode":"LA","countryName":"Laos","continent":"AS"},{"countryCode":"LB","countryName":"Lebanon","continent":"AS"},{"countryCode":"LC","countryName":"Saint Lucia","continent":"NA"},{"countryCode":"LI","countryName":"Liechtenstein","continent":"EU"},{"countryCode":"LK","countryName":"Sri Lanka","continent":"AS"},{"countryCode":"LR","countryName":"Liberia","continent":"AF"},{"countryCode":"LS","countryName":"Lesotho","continent":"AF"},{"countryCode":"LT","countryName":"Lithuania","continent":"EU"},{"countryCode":"LU","countryName":"Luxembourg","continent":"EU"},{"countryCode":"LV","countryName":"Latvia","continent":"EU"},{"countryCode":"LY","countryName":"Libya","continent":"AF"},{"countryCode":"MA","countryName":"Morocco","continent":"AF"},{"countryCode":"MC","countryName":"Monaco","continent":"EU"},{"countryCode":"MD","countryName":"Moldova","continent":"EU"},{"countryCode":"ME","countryName":"Montenegro","continent":"EU"},{"countryCode":"MF","countryName":"Saint Martin","continent":"NA"},{"countryCode":"MG","countryName":"Madagascar","continent":"AF"},{"countryCode":"MH","countryName":"Marshall Islands","continent":"OC"},{"countryCode":"MK","countryName":"Macedonia","continent":"EU"},{"countryCode":"ML","countryName":"Mali","continent":"AF"},{"countryCode":"MM","countryName":"Myanmar [Burma]","continent":"AS"},{"countryCode":"MN","countryName":"Mongolia","continent":"AS"},{"countryCode":"MO","countryName":"Macao","continent":"AS"},{"countryCode":"MP","countryName":"Northern Mariana Islands","continent":"OC"},{"countryCode":"MQ","countryName":"Martinique","continent":"NA"},{"countryCode":"MR","countryName":"Mauritania","continent":"AF"},{"countryCode":"MS","countryName":"Montserrat","continent":"NA"},{"countryCode":"MT","countryName":"Malta","continent":"EU"},{"countryCode":"MU","countryName":"Mauritius","continent":"AF"},{"countryCode":"MV","countryName":"Maldives","continent":"AS"},{"countryCode":"MW","countryName":"Malawi","continent":"AF"},{"countryCode":"MX","countryName":"Mexico","continent":"NA"},{"countryCode":"MY","countryName":"Malaysia","continent":"AS"},{"countryCode":"MZ","countryName":"Mozambique","continent":"AF"},{"countryCode":"NA","countryName":"Namibia","continent":"AF"},{"countryCode":"NC","countryName":"New Caledonia","continent":"OC"},{"countryCode":"NE","countryName":"Niger","continent":"AF"},{"countryCode":"NF","countryName":"Norfolk Island","continent":"OC"},{"countryCode":"NG","countryName":"Nigeria","continent":"AF"},{"countryCode":"NI","countryName":"Nicaragua","continent":"NA"},{"countryCode":"NL","countryName":"Netherlands","continent":"EU"},{"countryCode":"NO","countryName":"Norway","continent":"EU"},{"countryCode":"NP","countryName":"Nepal","continent":"AS"},{"countryCode":"NR","countryName":"Nauru","continent":"OC"},{"countryCode":"NU","countryName":"Niue","continent":"OC"},{"countryCode":"NZ","countryName":"New Zealand","continent":"OC"},{"countryCode":"OM","countryName":"Oman","continent":"AS"},{"countryCode":"PA","countryName":"Panama","continent":"NA"},{"countryCode":"PE","countryName":"Peru","continent":"SA"},{"countryCode":"PF","countryName":"French Polynesia","continent":"OC"},{"countryCode":"PG","countryName":"Papua New Guinea","continent":"OC"},{"countryCode":"PH","countryName":"Philippines","continent":"AS"},{"countryCode":"PK","countryName":"Pakistan","continent":"AS"},{"countryCode":"PL","countryName":"Poland","continent":"EU"},{"countryCode":"PM","countryName":"Saint Pierre and Miquelon","continent":"NA"},{"countryCode":"PN","countryName":"Pitcairn Islands","continent":"OC"},{"countryCode":"PR","countryName":"Puerto Rico","continent":"NA"},{"countryCode":"PS","countryName":"Palestine","continent":"AS"},{"countryCode":"PT","countryName":"Portugal","continent":"EU"},{"countryCode":"PW","countryName":"Palau","continent":"OC"},{"countryCode":"PY","countryName":"Paraguay","continent":"SA"},{"countryCode":"QA","countryName":"Qatar","continent":"AS"},{"countryCode":"RE","countryName":"Réunion","continent":"AF"},{"countryCode":"RO","countryName":"Romania","continent":"EU"},{"countryCode":"RS","countryName":"Serbia","continent":"EU"},{"countryCode":"RU","countryName":"Russia","continent":"EU"},{"countryCode":"RW","countryName":"Rwanda","continent":"AF"},{"countryCode":"SA","countryName":"Saudi Arabia","continent":"AS"},{"countryCode":"SB","countryName":"Solomon Islands","continent":"OC"},{"countryCode":"SC","countryName":"Seychelles","continent":"AF"},{"countryCode":"SD","countryName":"Sudan","continent":"AF"},{"countryCode":"SE","countryName":"Sweden","continent":"EU"},{"countryCode":"SG","countryName":"Singapore","continent":"AS"},{"countryCode":"SH","countryName":"Saint Helena","continent":"AF"},{"countryCode":"SI","countryName":"Slovenia","continent":"EU"},{"countryCode":"SJ","countryName":"Svalbard and Jan Mayen","continent":"EU"},{"countryCode":"SK","countryName":"Slovakia","continent":"EU"},{"countryCode":"SL","countryName":"Sierra Leone","continent":"AF"},{"countryCode":"SM","countryName":"San Marino","continent":"EU"},{"countryCode":"SN","countryName":"Senegal","continent":"AF"},{"countryCode":"SO","countryName":"Somalia","continent":"AF"},{"countryCode":"SR","countryName":"Suriname","continent":"SA"},{"countryCode":"SS","countryName":"South Sudan","continent":"AF"},{"countryCode":"ST","countryName":"São Tomé and Príncipe","continent":"AF"},{"countryCode":"SV","countryName":"El Salvador","continent":"NA"},{"countryCode":"SX","countryName":"Sint Maarten","continent":"NA"},{"countryCode":"SY","countryName":"Syria","continent":"AS"},{"countryCode":"SZ","countryName":"Swaziland","continent":"AF"},{"countryCode":"TC","countryName":"Turks and Caicos Islands","continent":"NA"},{"countryCode":"TD","countryName":"Chad","continent":"AF"},{"countryCode":"TF","countryName":"French Southern Territories","continent":"AN"},{"countryCode":"TG","countryName":"Togo","continent":"AF"},{"countryCode":"TH","countryName":"Thailand","continent":"AS"},{"countryCode":"TJ","countryName":"Tajikistan","continent":"AS"},{"countryCode":"TK","countryName":"Tokelau","continent":"OC"},{"countryCode":"TL","countryName":"East Timor","continent":"OC"},{"countryCode":"TM","countryName":"Turkmenistan","continent":"AS"},{"countryCode":"TN","countryName":"Tunisia","continent":"AF"},{"countryCode":"TO","countryName":"Tonga","continent":"OC"},{"countryCode":"TR","countryName":"Turkey","continent":"AS"},{"countryCode":"TT","countryName":"Trinidad and Tobago","continent":"NA"},{"countryCode":"TV","countryName":"Tuvalu","continent":"OC"},{"countryCode":"TW","countryName":"Taiwan","continent":"AS"},{"countryCode":"TZ","countryName":"Tanzania","continent":"AF"},{"countryCode":"UA","countryName":"Ukraine","continent":"EU"},{"countryCode":"UG","countryName":"Uganda","continent":"AF"},{"countryCode":"UM","countryName":"U.S. Minor Outlying Islands","continent":"OC"},{"countryCode":"US","countryName":"United States","continent":"NA"},{"countryCode":"UY","countryName":"Uruguay","continent":"SA"},{"countryCode":"UZ","countryName":"Uzbekistan","continent":"AS"},{"countryCode":"VA","countryName":"Vatican City","continent":"EU"},{"countryCode":"VC","countryName":"Saint Vincent and the Grenadines","continent":"NA"},{"countryCode":"VE","countryName":"Venezuela","continent":"SA"},{"countryCode":"VG","countryName":"British Virgin Islands","continent":"NA"},{"countryCode":"VI","countryName":"U.S. Virgin Islands","continent":"NA"},{"countryCode":"VN","countryName":"Vietnam","continent":"AS"},{"countryCode":"VU","countryName":"Vanuatu","continent":"OC"},{"countryCode":"WF","countryName":"Wallis and Futuna","continent":"OC"},{"countryCode":"WS","countryName":"Samoa","continent":"OC"},{"countryCode":"XK","countryName":"Kosovo","continent":"EU"},{"countryCode":"YE","countryName":"Yemen","continent":"AS"},{"countryCode":"YT","countryName":"Mayotte","continent":"AF"},{"countryCode":"ZA","countryName":"South Africa","continent":"AF"},{"countryCode":"ZM","countryName":"Zambia","continent":"AF"},{"countryCode":"ZW","countryName":"Zimbabwe","continent":"AF"}]

/***/ }),
/* 461 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[94]);


// WEBPACK FOOTER //
// static/js/app.21a2f94d606e14b276de.js